// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
  baseUrl: `${string}://${string}` | (string & {})
}

export type AssignProposalCategoryRequest = {
  /**
   * The proxy intermediary this category belongs to.
   *
   * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
   * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
   * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
   */
  proxy_intermediary: ProxyIntermediaryEnum
  /**
   * The id of the transparency proposal this category belongs to.
   */
  transparency_proposal_id: string
  /**
   * The free-text category to assign to the proposal. An empty category deletes any existing category for the proposal. Max length 100 characters.
   */
  proposal_category: string
}

export type AssignProposalCategoryResponse = {
  /**
   * The proxy intermediary this category belongs to.
   *
   * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
   * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
   * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
   */
  proxy_intermediary: ProxyIntermediaryEnum
  /**
   * The id of the transparency proposal this category refers to.
   */
  transparency_proposal_id: string
  /**
   * The free-text category assigned to the proposal.
   */
  proposal_category: string
}

export type AssignProposalLabelRequest = {
  /**
   * The proxy intermediary from which this label was sourced.
   *
   * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
   * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
   * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
   */
  proxy_intermediary: ProxyIntermediaryEnum
  /**
   * The label used by the proxy intermediary to identify the proposal, stored as-is. An empty label deletes any existing label for the proposal. Max length 100 characters.
   */
  proposal_label: string
  /**
   * The resource name of the transparency proposal, in the format 'organizations/{uuid}/generalMeetings/{uuid}/proposals/{uuid}'.
   */
  transparency_proposal_name: string
  /**
   * The ISS category code for the proposal (e.g. 'M0276'), stored as-is.
   */
  proposal_category?: string
  /**
   * The fields to update on an existing label. An empty mask updates both the label and the category.
   */
  update_mask?: Array<UpdateMaskEnum>
}

export type AssignProposalLabelResponse = {
  /**
   * The proxy intermediary from which this label was sourced.
   *
   * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
   * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
   * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
   */
  proxy_intermediary: ProxyIntermediaryEnum
  /**
   * The assigned proposal label.
   */
  proposal_label: string
  /**
   * The resource name of the transparency proposal this label refers to.
   */
  transparency_proposal_name: string
  /**
   * The ISS category code for the proposal.
   */
  proposal_category: string
}

export type AuditEvent = {
  /**
   * The audit event resource name, of the form 'auditEvents/{uuid}'.
   */
  readonly name: string
  /**
   * The name of the entity that was audited, in the form '{entity_name}/{entity_id}/...' e.g. 'organizations/{uuid}/generalMeetings/{uuid}'.
   */
  readonly entity_name: string
  /**
   * The original entity, serialised into JSON. '{}' when there is no original entity.
   */
  readonly original_entity_json: string
  /**
   * The difference between the original entity and the new entity, as a JSON merge patch (RFC 7396). '{}' when there is no patch.
   */
  readonly patch_json: string
  /**
   * The time the audit event was created.
   */
  readonly create_time: Date
  /**
   * The name of the endpoint that triggered the change to the data entity.
   */
  readonly endpoint_name: string
  /**
   * The pseudonymous identifier of the user that triggered the change to the data entity.
   */
  readonly username: string
}

/**
 * Request body for searching audit events.
 *
 * Domain validation (entity name and audit event name formats) is delegated
 * to the filter so behaviour matches the previous query-param-based list
 * endpoint exactly; this serializer only validates the request shape.
 */
export type AuditEventSearchRequestRequest = {
  entity_name?: string
  audit_event_names?: Array<string>
}

/**
 * * `institutional` - Institutional
 * * `retail` - Retail
 * * `retail_ptv` - Retail PTV
 */
export const AvailableToInvestorTypeEnum = {
  INSTITUTIONAL: 'institutional',
  RETAIL: 'retail',
  RETAIL_PTV: 'retail_ptv',
} as const

/**
 * * `institutional` - Institutional
 * * `retail` - Retail
 * * `retail_ptv` - Retail PTV
 */
export type AvailableToInvestorTypeEnum = (typeof AvailableToInvestorTypeEnum)[keyof typeof AvailableToInvestorTypeEnum]

/**
 * Serializer for BallotEntitlement responses.
 */
export type BallotEntitlement = {
  readonly id: string
  proxy_intermediary_ballot_id: string
  investor_account_id: string
  readonly ballot_breakdown_metadata_id: string | null
  ballot_proportion: number
  investor_supported_issued_instrument_id?: string | null
  investor_policy_supported_issued_instrument_id?: string | null
  fund_manager_policy_supported_issued_instrument_id?: string | null
  readonly create_time: Date
  readonly update_time: Date
  invalid_time?: Date | null
}

/**
 * Serializer for ballot voting information.
 */
export type BallotInvestorsCanVote = {
  /**
   * Number of investor accounts expected to vote on this ballot
   */
  num_investor_accounts_expected_to_vote: number
  /**
   * List of investor accounts expected to vote with their fund proportions
   */
  investor_accounts: Array<InvestorAccountVoteInfo>
  /**
   * Whether this ballot requires investigation due to potentially missing or inaccurate entitlements
   */
  requires_investigation: boolean
  /**
   * Reason why investigation is required (empty if not required)
   */
  requires_investigation_reason: string
}

export type BatchIsinsToOrganizationNamesRequestRequest = {
  isins: Array<string>
  only_with_voting_rights?: boolean
}

export type BatchIsinsToOrganizationNamesResponse = {
  isins_to_organization_names: {
    [key: string]: string
  }
}

export type BatchVoterWithHoldingsInputRequest = {
  /**
   * List of voters with their holdings
   */
  voters: Array<VoterWithHoldingsInputRequest>
}

export type BatchVoterWithHoldingsResponse = {
  /**
   * Newly created voters
   */
  created: Array<VoterResponse>
  /**
   * Updated voters
   */
  updated: Array<VoterResponse>
}

/**
 * * `tumelo` - tumelo
 * * `wikipedia` - wikipedia
 */
export const BioSourceEnum = { TUMELO: 'tumelo', WIKIPEDIA: 'wikipedia' } as const

/**
 * * `tumelo` - tumelo
 * * `wikipedia` - wikipedia
 */
export type BioSourceEnum = (typeof BioSourceEnum)[keyof typeof BioSourceEnum]

/**
 * Response serializer for ballot breakdown computation result.
 */
export type BreakdownResponse = {
  /**
   * Breakdown metadata including ballot ID, security ISIN, and filters
   */
  metadata: {
    [key: string]: unknown
  }
  /**
   * Statistics about the breakdown (node counts, edge counts, etc.)
   */
  statistics: {
    [key: string]: unknown
  }
  /**
   * NetworkX graph in node-link JSON format
   */
  graph: {
    [key: string]: unknown
  }
}

/**
 * * `PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_ALL` - PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_ALL
 * * `PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_NOT_CANCELLED` - PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_NOT_CANCELLED
 * * `PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_CANCELLED` - PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_CANCELLED
 */
export const CancelledEnum = {
  PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_ALL: 'PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_ALL',
  PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_NOT_CANCELLED:
    'PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_NOT_CANCELLED',
  PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_CANCELLED: 'PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_CANCELLED',
} as const

/**
 * * `PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_ALL` - PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_ALL
 * * `PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_NOT_CANCELLED` - PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_NOT_CANCELLED
 * * `PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_CANCELLED` - PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_CANCELLED
 */
export type CancelledEnum = (typeof CancelledEnum)[keyof typeof CancelledEnum]

/**
 * Individual component difference in a composition
 */
export type ComponentDiff = {
  /**
   * Name of the organization
   */
  organization_name?: string | null
  /**
   * ISIN identifier for the holding
   */
  isin: string
  /**
   * Holding's Classification of Financial Instruments (CFI) code
   */
  cfi?: string | null
  /**
   * Status of the component (UNCHANGED, ADDED, or REMOVED)
   *
   * * `UNCHANGED` - UNCHANGED
   * * `ADDED` - ADDED
   * * `REMOVED` - REMOVED
   * * `FILTERED` - FILTERED
   */
  status: ComponentDiffStatusEnum
  /**
   * Reasons why the component was filtered
   */
  filter_reasons: Array<FilterReasonsEnum>
  /**
   * Name of the voting policy in format 'votingPolicies/{uuid}'
   */
  voting_policy_name?: string | null
  /**
   * Start date of this component diff
   */
  start_date: Date
}

/**
 * Individual component difference in a composition
 */
export type ComponentDiffRequest = {
  /**
   * Name of the organization
   */
  organization_name?: string | null
  /**
   * ISIN identifier for the holding
   */
  isin: string
  /**
   * Holding's Classification of Financial Instruments (CFI) code
   */
  cfi?: string | null
  /**
   * Status of the component (UNCHANGED, ADDED, or REMOVED)
   *
   * * `UNCHANGED` - UNCHANGED
   * * `ADDED` - ADDED
   * * `REMOVED` - REMOVED
   * * `FILTERED` - FILTERED
   */
  status: ComponentDiffStatusEnum
  /**
   * Reasons why the component was filtered
   */
  filter_reasons: Array<FilterReasonsEnum>
  /**
   * Name of the voting policy in format 'votingPolicies/{uuid}'
   */
  voting_policy_name?: string | null
  /**
   * Start date of this component diff
   */
  start_date: Date
}

/**
 * * `UNCHANGED` - UNCHANGED
 * * `ADDED` - ADDED
 * * `REMOVED` - REMOVED
 * * `FILTERED` - FILTERED
 */
export const ComponentDiffStatusEnum = {
  UNCHANGED: 'UNCHANGED',
  ADDED: 'ADDED',
  REMOVED: 'REMOVED',
  FILTERED: 'FILTERED',
} as const

/**
 * * `UNCHANGED` - UNCHANGED
 * * `ADDED` - ADDED
 * * `REMOVED` - REMOVED
 * * `FILTERED` - FILTERED
 */
export type ComponentDiffStatusEnum = (typeof ComponentDiffStatusEnum)[keyof typeof ComponentDiffStatusEnum]

/**
 * Response serializer for composition differences
 */
export type CompositionDifferenceResponse = {
  /**
   * Name of the investor who holds this diff
   */
  investor_name: string
  /**
   * List of component differences
   */
  components: Array<ComponentDiff>
}

/**
 * * `institutional` - institutional
 * * `retail` - retail
 * * `all` - all
 */
export const ComputeBreakdownRequestInvestorTypeEnum = {
  INSTITUTIONAL: 'institutional',
  RETAIL: 'retail',
  ALL: 'all',
} as const

/**
 * * `institutional` - institutional
 * * `retail` - retail
 * * `all` - all
 */
export type ComputeBreakdownRequestInvestorTypeEnum =
  (typeof ComputeBreakdownRequestInvestorTypeEnum)[keyof typeof ComputeBreakdownRequestInvestorTypeEnum]

/**
 * Request serializer for computing ballot breakdown.
 */
export type ComputeBreakdownRequestRequest = {
  /**
   * ID of the proxy intermediary ballot
   */
  proxy_intermediary_ballot_id: string
  /**
   * Start of the validity window (ISO 8601 format). If not provided, defaults to VAT - 1 day
   */
  valid_from?: Date | null
  /**
   * End of the validity window (ISO 8601 format). If not provided, defaults to VAT
   */
  valid_to?: Date | null
  /**
   * Type of investor: 'institutional', 'retail', or 'all' for all investor types
   *
   * * `institutional` - institutional
   * * `retail` - retail
   * * `all` - all
   */
  investor_type: ComputeBreakdownRequestInvestorTypeEnum
}

/**
 * * `CURRENTLY_VOTABLE_FILTER_UNSPECIFIED` - CURRENTLY_VOTABLE_FILTER_UNSPECIFIED
 * * `CURRENTLY_VOTABLE_FILTER_IS_CURRENTLY_VOTABLE` - CURRENTLY_VOTABLE_FILTER_IS_CURRENTLY_VOTABLE
 * * `CURRENTLY_VOTABLE_FILTER_IS_NOT_CURRENTLY_VOTABLE` - CURRENTLY_VOTABLE_FILTER_IS_NOT_CURRENTLY_VOTABLE
 */
export const CurrentlyVotableFilterEnum = {
  CURRENTLY_VOTABLE_FILTER_UNSPECIFIED: 'CURRENTLY_VOTABLE_FILTER_UNSPECIFIED',
  CURRENTLY_VOTABLE_FILTER_IS_CURRENTLY_VOTABLE: 'CURRENTLY_VOTABLE_FILTER_IS_CURRENTLY_VOTABLE',
  CURRENTLY_VOTABLE_FILTER_IS_NOT_CURRENTLY_VOTABLE: 'CURRENTLY_VOTABLE_FILTER_IS_NOT_CURRENTLY_VOTABLE',
} as const

/**
 * * `CURRENTLY_VOTABLE_FILTER_UNSPECIFIED` - CURRENTLY_VOTABLE_FILTER_UNSPECIFIED
 * * `CURRENTLY_VOTABLE_FILTER_IS_CURRENTLY_VOTABLE` - CURRENTLY_VOTABLE_FILTER_IS_CURRENTLY_VOTABLE
 * * `CURRENTLY_VOTABLE_FILTER_IS_NOT_CURRENTLY_VOTABLE` - CURRENTLY_VOTABLE_FILTER_IS_NOT_CURRENTLY_VOTABLE
 */
export type CurrentlyVotableFilterEnum = (typeof CurrentlyVotableFilterEnum)[keyof typeof CurrentlyVotableFilterEnum]

/**
 * * `PROPOSAL_OUTCOME_DECISION_FOR` - PROPOSAL_OUTCOME_DECISION_FOR
 * * `PROPOSAL_OUTCOME_DECISION_AGAINST` - PROPOSAL_OUTCOME_DECISION_AGAINST
 * * `PROPOSAL_OUTCOME_DECISION_WITHDRAWN` - PROPOSAL_OUTCOME_DECISION_WITHDRAWN
 * * `PROPOSAL_OUTCOME_DECISION_ONE_YEAR` - PROPOSAL_OUTCOME_DECISION_ONE_YEAR
 * * `PROPOSAL_OUTCOME_DECISION_TWO_YEARS` - PROPOSAL_OUTCOME_DECISION_TWO_YEARS
 * * `PROPOSAL_OUTCOME_DECISION_THREE_YEARS` - PROPOSAL_OUTCOME_DECISION_THREE_YEARS
 */
export const DecisionEnum = {
  PROPOSAL_OUTCOME_DECISION_FOR: 'PROPOSAL_OUTCOME_DECISION_FOR',
  PROPOSAL_OUTCOME_DECISION_AGAINST: 'PROPOSAL_OUTCOME_DECISION_AGAINST',
  PROPOSAL_OUTCOME_DECISION_WITHDRAWN: 'PROPOSAL_OUTCOME_DECISION_WITHDRAWN',
  PROPOSAL_OUTCOME_DECISION_ONE_YEAR: 'PROPOSAL_OUTCOME_DECISION_ONE_YEAR',
  PROPOSAL_OUTCOME_DECISION_TWO_YEARS: 'PROPOSAL_OUTCOME_DECISION_TWO_YEARS',
  PROPOSAL_OUTCOME_DECISION_THREE_YEARS: 'PROPOSAL_OUTCOME_DECISION_THREE_YEARS',
} as const

/**
 * * `PROPOSAL_OUTCOME_DECISION_FOR` - PROPOSAL_OUTCOME_DECISION_FOR
 * * `PROPOSAL_OUTCOME_DECISION_AGAINST` - PROPOSAL_OUTCOME_DECISION_AGAINST
 * * `PROPOSAL_OUTCOME_DECISION_WITHDRAWN` - PROPOSAL_OUTCOME_DECISION_WITHDRAWN
 * * `PROPOSAL_OUTCOME_DECISION_ONE_YEAR` - PROPOSAL_OUTCOME_DECISION_ONE_YEAR
 * * `PROPOSAL_OUTCOME_DECISION_TWO_YEARS` - PROPOSAL_OUTCOME_DECISION_TWO_YEARS
 * * `PROPOSAL_OUTCOME_DECISION_THREE_YEARS` - PROPOSAL_OUTCOME_DECISION_THREE_YEARS
 */
export type DecisionEnum = (typeof DecisionEnum)[keyof typeof DecisionEnum]

/**
 * * `TUMELO` - TUMELO
 * * `PIRC` - PIRC
 * * `GLASS_LEWIS` - GLASS_LEWIS
 * * `MINERVA` - MINERVA
 * * `ISS` - ISS
 * * `EOS` - EOS
 * * `ISS_RETAIL` - ISS_RETAIL
 */
export const DiffFormatEnum = {
  TUMELO: 'TUMELO',
  PIRC: 'PIRC',
  GLASS_LEWIS: 'GLASS_LEWIS',
  MINERVA: 'MINERVA',
  ISS: 'ISS',
  EOS: 'EOS',
  ISS_RETAIL: 'ISS_RETAIL',
} as const

/**
 * * `TUMELO` - TUMELO
 * * `PIRC` - PIRC
 * * `GLASS_LEWIS` - GLASS_LEWIS
 * * `MINERVA` - MINERVA
 * * `ISS` - ISS
 * * `EOS` - EOS
 * * `ISS_RETAIL` - ISS_RETAIL
 */
export type DiffFormatEnum = (typeof DiffFormatEnum)[keyof typeof DiffFormatEnum]

/**
 * Serializer for export result response.
 */
export type ExportResult = {
  /**
   * S3 bucket name where the exported CSV file is stored
   */
  s3_bucket: string
  /**
   * S3 key (path) of the exported CSV file
   */
  s3_key: string
  /**
   * Number of rows exported (0 if unavailable)
   */
  row_count: number
  /**
   * Timestamp when export was executed
   */
  exported_at: Date
}

export type ExternalMeetingId = {
  /**
   * Unique identifier for this external meeting ID mapping.
   */
  id: string
  /**
   * The identifier used by the external provider.
   */
  external_meeting_id: string
  /**
   * The name of the external provider (e.g. EDI, Broadridge).
   */
  provider: string
  /**
   * The UUID of the internal general meeting.
   */
  general_meeting_id: string
  /**
   * The time this mapping was created.
   */
  create_time: Date
}

export type ExternalMeetingIdCreateRequest = {
  /**
   * The identifier used by the external provider.
   */
  external_meeting_id: string
  /**
   * The name of the external provider (e.g. EDI, Broadridge).
   */
  provider: string
  /**
   * The UUID of the internal general meeting.
   */
  general_meeting_id: string
}

export type FetchMinimalInstrumentsRequestRequest = {
  isins: Array<string>
}

export type FetchMinimalInstrumentsResponse = {
  instruments: Array<MinimalInstrument>
}

export type FetchProposalLabelsRequest = {
  /**
   * The proxy intermediary to fetch labels for.
   *
   * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
   * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
   * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
   */
  proxy_intermediary: ProxyIntermediaryEnum
  /**
   * The resource names of the transparency proposals to fetch labels for, each in the format 'organizations/{uuid}/generalMeetings/{uuid}/proposals/{uuid}'.
   */
  transparency_proposal_names: Array<string>
}

export type FetchProposalLabelsResponse = {
  /**
   * The proxy intermediary the labels were fetched for.
   *
   * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
   * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
   * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
   */
  proxy_intermediary: ProxyIntermediaryEnum
  /**
   * Map of transparency proposal name to its label. Proposals without a label are omitted.
   */
  proposal_name_and_label: {
    [key: string]: string
  }
  /**
   * Map of transparency proposal name to its category. Proposals without a label are omitted.
   */
  proposal_name_and_category: {
    [key: string]: string
  }
}

/**
 * * `NEW_PORTFOLIO_INVESTMENT` - NEW_PORTFOLIO_INVESTMENT
 * * `NOT_HELD_IN_PORTFOLIO` - NOT_HELD_IN_PORTFOLIO
 * * `POA_MARKET` - POA_MARKET
 * * `NON_SPLIT_VOTING_COUNTRY` - NON_SPLIT_VOTING_COUNTRY
 * * `OUT_OF_SCOPE_ISIN` - OUT_OF_SCOPE_ISIN
 * * `UNSUPPORTED_CFI_CODE` - UNSUPPORTED_CFI_CODE
 */
export const FilterReasonsEnum = {
  NEW_PORTFOLIO_INVESTMENT: 'NEW_PORTFOLIO_INVESTMENT',
  NOT_HELD_IN_PORTFOLIO: 'NOT_HELD_IN_PORTFOLIO',
  POA_MARKET: 'POA_MARKET',
  NON_SPLIT_VOTING_COUNTRY: 'NON_SPLIT_VOTING_COUNTRY',
  OUT_OF_SCOPE_ISIN: 'OUT_OF_SCOPE_ISIN',
  UNSUPPORTED_CFI_CODE: 'UNSUPPORTED_CFI_CODE',
} as const

/**
 * * `NEW_PORTFOLIO_INVESTMENT` - NEW_PORTFOLIO_INVESTMENT
 * * `NOT_HELD_IN_PORTFOLIO` - NOT_HELD_IN_PORTFOLIO
 * * `POA_MARKET` - POA_MARKET
 * * `NON_SPLIT_VOTING_COUNTRY` - NON_SPLIT_VOTING_COUNTRY
 * * `OUT_OF_SCOPE_ISIN` - OUT_OF_SCOPE_ISIN
 * * `UNSUPPORTED_CFI_CODE` - UNSUPPORTED_CFI_CODE
 */
export type FilterReasonsEnum = (typeof FilterReasonsEnum)[keyof typeof FilterReasonsEnum]

export type Fund = {
  /**
   * The name of the fund in the format of 'funds/{uuid}'
   */
  readonly name: string
  /**
   * The fund ID
   */
  id: string
  /**
   * The product that the fund exists in
   *
   * * `PTV` - PTV
   * * `Shareholder` - Shareholder
   */
  product: ProductEnum
  /**
   * The creation time of the fund
   */
  create_time: Date
  /**
   * The update time of the fund
   */
  update_time: Date
  /**
   * The title of the fund
   */
  title: string
  /**
   * The name of the fund manager that manages the fund, in the format 'fundManagers/{uuid}'
   */
  readonly fund_manager_name: string
  /**
   * The base currency of the fund. Currency is a letter code designator specified in ISO 4217, plus some additional non-ISO codes
   */
  base_currency: string | null
  /**
   * The external identifier for the fund
   */
  external_id: string | null
  /**
   * If true this signifies that the fund supports pass through voting to both institutional and retail investors. A fund must have this set in order for the vote engine to issue pass through voting entitlements for organizations owned through this fund.
   */
  institutional_pass_through_voting_enabled: boolean
  /**
   * If true this signifies that we should be receiving quantification and composition data daily for this fund and therefore it is deemed data ready.
   */
  data_ready: boolean
  /**
   * Custodian identifiers, or null when the fund has none.
   */
  custodian_identifiers: FundCustodianIdentifiers | null
  /**
   * Identifiers within the proxy intermediary, or null when the fund has none.
   */
  proxy_intermediary_identifiers: FundProxyIntermediaryIdentifiers | null
  /**
   * Custodian region is used to identify the public holidays for custodian accounts. It is a CAPITALISED 3-letter code as defined by ISO 3166-1 A-3.
   */
  custodian_region: string | null
}

/**
 * Set of identifiers used to identify the custodian and account id of the custodian.
 *
 * As a pair these identifiers should be unique for a specific Fund:
 * - The custodian_external_id may be shared across multiple funds.
 * - The custodian_account_external_id should be unique across funds for the same custodian.
 * - The custodian_account_external_id may be repeated across multiple funds if the
 * custodian_external_id is different.
 */
export type FundCustodianIdentifiers = {
  /**
   * The identifier/title for the custodian of the fund. This identifies the custodian and may take the form of a name such as 'State Street' or 'Fidelity'. Limited to a maximum of 200 characters, and must not start or end with spaces.
   */
  custodian_external_id?: string
  /**
   * The identifier for the custodian global account. Unique across funds for the same custodian. Limited to a maximum of 200 characters, and must not start or end with spaces.
   */
  custodian_account_external_id?: string
}

/**
 * Set of identifiers used to identify the custodian and account id of the custodian.
 *
 * As a pair these identifiers should be unique for a specific Fund:
 * - The custodian_external_id may be shared across multiple funds.
 * - The custodian_account_external_id should be unique across funds for the same custodian.
 * - The custodian_account_external_id may be repeated across multiple funds if the
 * custodian_external_id is different.
 */
export type FundCustodianIdentifiersRequest = {
  /**
   * The identifier/title for the custodian of the fund. This identifies the custodian and may take the form of a name such as 'State Street' or 'Fidelity'. Limited to a maximum of 200 characters, and must not start or end with spaces.
   */
  custodian_external_id?: string
  /**
   * The identifier for the custodian global account. Unique across funds for the same custodian. Limited to a maximum of 200 characters, and must not start or end with spaces.
   */
  custodian_account_external_id?: string
}

export type FundManager = {
  readonly name: string
  id: string
  title: string
  product: ProductEnum
  website_url: string | null
  logo_url: string | null
  logo_thumbnail_url: string | null
  relationship_owner: string | null
  create_time: Date
  update_time: Date
}

export type FundManagerPolicySii = {
  readonly name: string
  fund_manager_name: string
  voting_policy_name: string
  public_security_id_name: string
  create_time: Date
  delete_time?: Date | null
  valid_from: Date
  valid_to?: Date | null
}

export type FundManagerPolicySiiBatchCreateRequest = {
  fund_manager_name: string
  voting_policy_name: string
  instruments: Array<FundManagerPolicySiiInputRequest>
}

export type FundManagerPolicySiiBatchDeleteRequest = {
  names: Array<string>
}

/**
 * An instrument with an associated validity period, used as input for batch create operations.
 */
export type FundManagerPolicySiiInputRequest = {
  public_security_id_name: string
  valid_from: Date
  valid_to?: Date | null
}

export type FundManagerPolicySiiResponse = {
  items: Array<FundManagerPolicySii>
}

/**
 * Request body for searching fund manager policy supported issued instruments.
 *
 * Domain validation (name formats, datetime parsing) is delegated to the
 * filter so behaviour matches the previous query-param-based list endpoint
 * exactly; this serializer only validates the request shape.
 */
export type FundManagerPolicySiiSearchRequestRequest = {
  fund_manager_names?: Array<string>
  voting_policy_names?: Array<string>
  public_security_id_names?: Array<string>
  valid_to_after?: string
  valid_to_before?: string
  valid_from_after?: string
  valid_from_before?: string
  include_deleted?: boolean
}

/**
 * Request body for searching fund managers.
 *
 * Domain validation (name format) is delegated to the filter so behaviour
 * matches the previous query-param-based list endpoint exactly; this
 * serializer only validates the request shape.
 */
export type FundManagerSearchRequestRequest = {
  names?: Array<string>
  search_title?: string
  relationship_owners?: Array<string>
  product?: ProductEnum
}

export type FundManagerSupportedIssuedInstrumentsQueryRequest = {
  /**
   * List of component differences
   */
  components: Array<ComponentDiffRequest>
  /**
   * Date at which the supported instruments take effect
   */
  recomposition_date: Date
  /**
   * Fund manager resource name in format 'fundManagers/<uuid>'
   */
  fund_manager_name: string
  /**
   * List of voting policy names in format 'votingPolicies/<uuid>'
   */
  voting_policy_names: Array<string>
}

/**
 * Serializer for FundManagerSupportedVotingPolicy responses.
 */
export type FundManagerSupportedVotingPolicy = {
  readonly id: string
  readonly fund_manager_id: string
  /**
   * UUID primary key. The resource name is `votingPolicies/{id}`.
   */
  readonly voting_policy_id: string
  readonly create_time: Date
  readonly update_time: Date
}

/**
 * Request serializer for batch upserting fund manager supported policies.
 */
export type FundManagerSupportedVotingPolicyBatchUpsertRequest = {
  /**
   * List of fund manager / voting policy links to upsert
   */
  policies: Array<FundManagerSupportedVotingPolicyItemRequest>
}

/**
 * Response serializer for batch upserting fund manager supported policies.
 */
export type FundManagerSupportedVotingPolicyBatchUpsertResponse = {
  policies: Array<FundManagerSupportedVotingPolicy>
}

/**
 * Serializer for historical FundManagerSupportedVotingPolicy records.
 */
export type FundManagerSupportedVotingPolicyHistorical = {
  id: string
  fund_manager_id: string
  voting_policy_id: string
  create_time: Date
  update_time: Date
  /**
   * Present on as_of queries: the datetime this historical record was captured
   */
  history_date?: Date
}

/**
 * Serializer for a single fund manager / voting policy link.
 */
export type FundManagerSupportedVotingPolicyItemRequest = {
  /**
   * UUID of the FundManager
   */
  fund_manager_id: string
  /**
   * UUID of the VotingPolicy
   */
  voting_policy_id: string
}

export type FundManagerWriteRequest = {
  title: string
  product: ProductEnum
  website_url?: string | null
  logo_url?: string | null
  logo_thumbnail_url?: string | null
  relationship_owner?: string | null
}

/**
 * Set of identifiers for proxy intermediary accounts.
 *
 * Proxymity, ProxyEdge and ProxyExchange are currently supported.
 */
export type FundProxyIntermediaryIdentifiers = {
  /**
   * List of proxy edge account ids for the fund, unique across funds. Each id is limited to a maximum of 200 characters, and must not start or end with spaces.
   */
  proxyedge_external_ids?: Array<string>
  /**
   * List of proxymity account ids for the fund, unique across funds. Each id is limited to a maximum of 200 characters, and must not start or end with spaces.
   */
  proxymity_external_ids?: Array<string>
  /**
   * List of proxyexchange account ids for the fund, unique across funds. Each id is limited to a maximum of 200 characters, and must not start or end with spaces.
   */
  proxyexchange_external_ids?: Array<string>
}

/**
 * Set of identifiers for proxy intermediary accounts.
 *
 * Proxymity, ProxyEdge and ProxyExchange are currently supported.
 */
export type FundProxyIntermediaryIdentifiersRequest = {
  /**
   * List of proxy edge account ids for the fund, unique across funds. Each id is limited to a maximum of 200 characters, and must not start or end with spaces.
   */
  proxyedge_external_ids?: Array<string>
  /**
   * List of proxymity account ids for the fund, unique across funds. Each id is limited to a maximum of 200 characters, and must not start or end with spaces.
   */
  proxymity_external_ids?: Array<string>
  /**
   * List of proxyexchange account ids for the fund, unique across funds. Each id is limited to a maximum of 200 characters, and must not start or end with spaces.
   */
  proxyexchange_external_ids?: Array<string>
}

export type FundQuantificationSnapshot = {
  /**
   * The name of the snapshot in the format 'funds/{uuid}/quantificationSnapshots/{uuid}'.
   */
  readonly name: string
  /**
   * The time at which the snapshot was valid.
   */
  valid_time: Date
  /**
   * The quantification of the fund.
   */
  fund_quantification: Quantification
  /**
   * The quantifications of all the variants of the fund.
   */
  readonly fund_variant_quantifications: Array<FundVariantQuantificationSet>
  /**
   * The creation time of the snapshot.
   */
  create_time: Date
  /**
   * The product that the quantification snapshot is associated with.
   *
   * * `PTV` - PTV
   * * `Shareholder` - Shareholder
   */
  product: ProductEnum
}

/**
 * Request body for searching fund quantification snapshots.
 *
 * Results are ordered by valid time descending, id descending.
 */
export type FundQuantificationSnapshotSearchRequestRequest = {
  /**
   * Filter by snapshot resource names, each in the format 'funds/{uuid}/quantificationSnapshots/{uuid}'.
   */
  names?: Array<string>
  /**
   * Filter by fund resource names, each in the format 'funds/{uuid}'.
   */
  fund_names?: Array<string>
  /**
   * Filter for snapshots valid at or after this timestamp (inclusive).
   */
  valid_time_after?: Date
  /**
   * Filter for snapshots valid before this timestamp (exclusive).
   */
  valid_time_before?: Date
  /**
   * The product to query for snapshots.
   *
   * * `PTV` - PTV
   * * `Shareholder` - Shareholder
   */
  product: ProductEnum
}

/**
 * Request body for creating a fund quantification snapshot.
 *
 * The generated name and create time are server-assigned and ignored on write.
 */
export type FundQuantificationSnapshotWriteRequest = {
  /**
   * The time at which the snapshot was valid. Records the time at which the snapshot was calculated by the fund administrator.
   */
  valid_time: Date
  /**
   * The quantification of the fund.
   */
  fund_quantification: QuantificationRequest
  /**
   * The quantifications of all the variants of the fund. The sum of all quantifications of the same unit type as the fund must be less than or equal to the fund quantification.
   */
  fund_variant_quantifications?: Array<FundVariantQuantificationSetRequest>
  /**
   * The product that the quantification snapshot is associated with.
   *
   * * `PTV` - PTV
   * * `Shareholder` - Shareholder
   */
  product: ProductEnum
}

/**
 * Request body for searching funds.
 *
 * Results are ordered by create time descending, id descending.
 */
export type FundSearchRequestRequest = {
  /**
   * Filter by fund manager resource names, each in the format 'fundManagers/{uuid}'.
   */
  fund_manager_names?: Array<string>
  /**
   * Filter by fund resource names, each in the format 'funds/{uuid}'.
   */
  names?: Array<string>
  /**
   * Case-insensitive substring match on the fund title.
   */
  search_title?: string
  /**
   * Filter by fund external ids.
   */
  external_ids?: Array<string>
  /**
   * Filter for whether the fund supports pass through voting for institutional investors. Omit (or pass null) to match all funds.
   */
  institutional_pass_through_voting_enabled?: boolean | null
  /**
   * The product to query for funds.
   *
   * * `PTV` - PTV
   * * `Shareholder` - Shareholder
   */
  product: ProductEnum
  /**
   * Filter for proxymity account ids.
   */
  proxymity_account_external_ids?: Array<string>
  /**
   * Filter for proxy edge account ids.
   */
  proxy_edge_account_external_ids?: Array<string>
  /**
   * Filter for proxy exchange account ids.
   */
  proxyexchange_account_external_ids?: Array<string>
  /**
   * Filter for custodian external ids.
   */
  custodian_external_ids?: Array<string>
  /**
   * Filter for custodian account ids. Note that using this filter without the custodian_external_ids filter may return multiple funds if there are multiple custodians with the same account id.
   */
  custodian_account_ids?: Array<string>
  /**
   * Matches custodian account ids that contain the search string. As an example, a search string of 'bcd' would match 'abcde', 'abcd' and 'bcde'.
   */
  search_custodian_account_id?: string
  /**
   * Matches proxymity account ids that contain the search string.
   */
  search_proxymity_account_external_id?: string
  /**
   * Matches proxy edge account ids that contain the search string.
   */
  search_proxy_edge_account_external_id?: string
  /**
   * Matches proxy exchange account ids that contain the search string.
   */
  search_proxyexchange_account_external_id?: string
}

/**
 * A fund variant is a wrapper for a fund, allowing a single fund to be represented with a
 * variety of differing titles and security IDs.
 */
export type FundVariant = {
  /**
   * The name of the variant, in the format 'funds/{uuid}/variants/{uuid}'
   */
  readonly name: string
  /**
   * The fund variant ID
   */
  id: string
  /**
   * The product that the fund variant exists in
   *
   * * `PTV` - PTV
   * * `Shareholder` - Shareholder
   */
  product: ProductEnum
  /**
   * The title of the fund variant
   */
  title: string
  /**
   * The classification of financial instruments: an uppercase six-letter code describing the structure and function of the instrument.
   */
  cfi: string | null
  /**
   * The closest MIFIR code from the current CFI code, set to 'SHRS' when CFI empty, defaults to 'OTHE' when no match found.
   */
  readonly mifir_code: string
  /**
   * The names of the public security IDs the fund variant is linked to, each in the format 'securityIDTypes/{type}/securityIDs/{value}'.
   */
  readonly public_security_id_names: Array<string>
  /**
   * The names of the custom security IDs the fund variant is linked to, each in the format '{fundManagers|providers}/{uuid}/securityIDTypes/{type}/securityIDs/{uuid}'.
   */
  readonly custom_security_id_names: Array<string>
  /**
   * The creation time of the fund variant
   */
  create_time: Date
  /**
   * The update time of the fund variant
   */
  update_time: Date
}

/**
 * All quantifications of a single fund variant within a snapshot.
 */
export type FundVariantQuantificationSet = {
  /**
   * The name of the fund variant, in the format 'funds/{uuid}/variants/{uuid}'.
   */
  fund_variant_name: string
  /**
   * All quantifications of the fund variant. Must include a quantification of the same unit type as the fund quantification, and cannot repeat a unit type.
   */
  quantifications: Array<Quantification>
}

/**
 * All quantifications of a single fund variant within a snapshot.
 */
export type FundVariantQuantificationSetRequest = {
  /**
   * The name of the fund variant, in the format 'funds/{uuid}/variants/{uuid}'.
   */
  fund_variant_name: string
  /**
   * All quantifications of the fund variant. Must include a quantification of the same unit type as the fund quantification, and cannot repeat a unit type.
   */
  quantifications: Array<QuantificationRequest>
}

/**
 * Request body for searching fund variants.
 *
 * The parent fund filter (`fund_name`) is optional: omitting it searches across
 * all funds (the wildcard parent 'funds/-'). Results are ordered by fund id,
 * title, id.
 */
export type FundVariantSearchRequestRequest = {
  /**
   * Optional parent fund 'funds/{uuid}'. Omit to search across all funds.
   */
  fund_name?: string
  /**
   * Filter by fund variant names, each in the format 'funds/{uuid}/variants/{uuid}'.
   */
  names?: Array<string>
  /**
   * The names of the public security IDs the fund variant is linked to, each in the format 'securityIDTypes/{type}/securityIDs/{value}'.
   */
  public_security_id_names?: Array<string>
  /**
   * The names of the custom security IDs the fund variant is linked to, each in the format '{fundManagers|providers}/{uuid}/securityIDTypes/{type}/securityIDs/{uuid}'.
   */
  custom_security_id_names?: Array<string>
  /**
   * Filter by security ID names that may be either public or custom.
   */
  security_id_names?: Array<string>
  /**
   * Filter by fund manager resource names, each in the format 'fundManagers/{uuid}'.
   */
  fund_manager_names?: Array<string>
  /**
   * Case-insensitive substring match on the fund variant title.
   */
  search_title?: string
  /**
   * Filter by product. Omit to search across all products.
   *
   * * `PTV` - PTV
   * * `Shareholder` - Shareholder
   */
  product?: ProductEnum
}

export type FundVariantWriteRequest = {
  /**
   * The name of the parent fund, in the format 'funds/{uuid}'
   */
  fund_name: string
  /**
   * The title of the fund variant
   */
  title: string
  /**
   * The product that the fund variant exists in. Defaults to PTV.
   *
   * * `PTV` - PTV
   * * `Shareholder` - Shareholder
   */
  product?: ProductEnum
  /**
   * The classification of financial instruments: a six-letter code. Stored upper-cased; omit or leave blank when the variant has no CFI.
   */
  cfi?: string
  /**
   * The names of the public security IDs the fund variant is linked to, each in the format 'securityIDTypes/{type}/securityIDs/{value}'.
   */
  public_security_id_names?: Array<string>
  /**
   * The names of the custom security IDs the fund variant is linked to, each in the format '{fundManagers|providers}/{uuid}/securityIDTypes/{type}/securityIDs/{uuid}'.
   */
  custom_security_id_names?: Array<string>
}

export type FundWriteRequest = {
  /**
   * The title of the fund
   */
  title: string
  /**
   * The name of the fund manager that manages the fund, in the format 'fundManagers/{uuid}'
   */
  fund_manager_name: string
  /**
   * The product that the fund exists in
   *
   * * `PTV` - PTV
   * * `Shareholder` - Shareholder
   */
  product: ProductEnum
  /**
   * The base currency of the fund. Currency is a letter code designator specified in ISO 4217, plus some additional non-ISO codes
   */
  base_currency?: string | null
  /**
   * The external identifier for the fund
   */
  external_id?: string | null
  /**
   * If true this signifies that the fund supports pass through voting to both institutional and retail investors.
   */
  institutional_pass_through_voting_enabled?: boolean
  /**
   * If true this signifies that we should be receiving quantification and composition data daily for this fund and therefore it is deemed data ready.
   */
  data_ready?: boolean
  /**
   * Custodian identifiers
   */
  custodian_identifiers?: FundCustodianIdentifiersRequest | null
  /**
   * Identifiers within the proxy intermediary
   */
  proxy_intermediary_identifiers?: FundProxyIntermediaryIdentifiersRequest | null
  /**
   * Custodian region is used to identify the public holidays for custodian accounts. It is a CAPITALISED 3-letter code as defined by ISO 3166-1 A-3.
   */
  custodian_region?: string | null
}

/**
 * Response shape for a GeneralMeeting.
 *
 * Takes the dict produced by services.build_general_meeting_view (or
 * build_general_meeting_views). The service layer is responsible for
 * assembling that dict from the GeneralMeeting row.
 */
export type GeneralMeeting = {
  /**
   * The general meeting resource name, of the form 'organizations/{uuid}/generalMeetings/{uuid}'.
   */
  readonly name: string
  /**
   * The name of the organization that this general meeting is for, of the form 'organizations/{uuid}'.
   */
  organization_name: string
  /**
   * The type of the general meeting.
   *
   * * `GENERAL_MEETING_TYPE_ANNUAL` - GENERAL_MEETING_TYPE_ANNUAL
   * * `GENERAL_MEETING_TYPE_BOND_HOLDER` - GENERAL_MEETING_TYPE_BOND_HOLDER
   * * `GENERAL_MEETING_TYPE_COURT_ORDERED` - GENERAL_MEETING_TYPE_COURT_ORDERED
   * * `GENERAL_MEETING_TYPE_EXTRAORDINARY` - GENERAL_MEETING_TYPE_EXTRAORDINARY
   * * `GENERAL_MEETING_TYPE_GENERAL` - GENERAL_MEETING_TYPE_GENERAL
   * * `GENERAL_MEETING_TYPE_POSTAL_BALLOT` - GENERAL_MEETING_TYPE_POSTAL_BALLOT
   * * `GENERAL_MEETING_TYPE_SPECIAL` - GENERAL_MEETING_TYPE_SPECIAL
   * * `GENERAL_MEETING_TYPE_INVALID` - GENERAL_MEETING_TYPE_INVALID
   */
  type: GeneralMeetingTypeEnum
  /**
   * The date of the general meeting.
   */
  meeting_date: Date
  /**
   * The time the general meeting was created.
   */
  readonly create_time: Date
  /**
   * The time the general meeting was last updated.
   */
  readonly update_time: Date
  /**
   * The time the general meeting became invalid.
   */
  invalid_time: Date | null
  /**
   * The time the general meeting was announced.
   */
  announcement_time: Date | null
  /**
   * The EDI event ID for the general meeting as presented in the EDI Worldwide Corporate Actions service.
   */
  edi_event_id: string | null
  /**
   * URL of the official general meeting announcement.
   */
  announcement_url: string | null
  /**
   * URL linking to a page containing the proxy notice of the general meeting.
   */
  proxy_notice_url: string | null
  /**
   * URL of the official results for the general meeting.
   */
  results_url: string | null
  /**
   * The record date for the general meeting: the date on which shareholders must have owned shares in order to be eligible to vote.
   */
  record_date: Date | null
  /**
   * The record date for the general meeting as reported by EDI.
   */
  edi_record_date: Date | null
  /**
   * The time voting was enabled for the general meeting. Null if voting is not enabled.
   */
  readonly voting_enabled_time: Date | null
  /**
   * Whether voting is enabled for this general meeting.
   */
  voting_enabled: boolean
  /**
   * The time the EDI agenda pipelines were disabled. Null if pipelines are enabled.
   */
  readonly disable_edi_agenda_pipeline_updates_time: Date | null
  /**
   * Whether the EDI agenda pipelines are disabled for this general meeting.
   */
  disable_edi_agenda_pipeline_updates: boolean
  /**
   * The proxy submission deadlines for the general meeting.
   */
  proxy_submission: ProxySubmission | null
  /**
   * Index to distinguish duplicated general meetings for the same organization, meeting date and meeting type. Defaults to 0.
   */
  duplicate_index: number
}

/**
 * Request body for searching general meetings.
 *
 * Every filter is typed here so the generated clients get accurate types.
 * Name-format validation is delegated to the service, where a malformed name
 * surfaces as a 400.
 */
export type GeneralMeetingSearchRequestRequest = {
  /**
   * Filter to general meetings whose organization matches this name ('organizations/{uuid}').
   */
  parent_name?: string
  /**
   * Filter to general meetings for any of these organizations ('organizations/{uuid}').
   */
  organization_names?: Array<string>
  /**
   * Filter to general meetings with any of these names ('organizations/{uuid}/generalMeetings/{uuid}').
   */
  general_meeting_names?: Array<string>
  /**
   * Filter to general meetings with any of these UUIDs.
   */
  general_meeting_ids?: Array<string>
  /**
   * Filter to general meetings with any of these EDI event IDs.
   */
  edi_event_ids?: Array<string>
  /**
   * Filter to general meetings occurring on or after this time.
   */
  meeting_date_after?: Date
  /**
   * Filter to general meetings occurring strictly before this time.
   */
  meeting_date_before?: Date
  /**
   * Filter to general meetings with a record date on or after this time.
   */
  record_date_after?: Date
  /**
   * Filter to general meetings with a record date strictly before this time.
   */
  record_date_before?: Date
  /**
   * Filter to general meetings created on or after this time.
   */
  create_time_after?: Date
  /**
   * Filter on validity (presence of invalid_time): 'VALID' for meetings without an invalid_time, 'NOT_VALID' for meetings with one, 'ALL' (or omitted) for both.
   *
   * * `VALID` - VALID
   * * `NOT_VALID` - NOT_VALID
   * * `ALL` - ALL
   */
  valid?: ValidEnum
  /**
   * When true, restrict to general meetings that have voting enabled.
   */
  only_voting_enabled?: boolean
  /**
   * Filter to general meetings with voting enabled on or after this time.
   */
  voting_enabled_after?: Date
  /**
   * Filter to general meetings with voting enabled strictly before this time.
   */
  voting_enabled_before?: Date
}

/**
 * * `GENERAL_MEETING_TYPE_ANNUAL` - GENERAL_MEETING_TYPE_ANNUAL
 * * `GENERAL_MEETING_TYPE_BOND_HOLDER` - GENERAL_MEETING_TYPE_BOND_HOLDER
 * * `GENERAL_MEETING_TYPE_COURT_ORDERED` - GENERAL_MEETING_TYPE_COURT_ORDERED
 * * `GENERAL_MEETING_TYPE_EXTRAORDINARY` - GENERAL_MEETING_TYPE_EXTRAORDINARY
 * * `GENERAL_MEETING_TYPE_GENERAL` - GENERAL_MEETING_TYPE_GENERAL
 * * `GENERAL_MEETING_TYPE_POSTAL_BALLOT` - GENERAL_MEETING_TYPE_POSTAL_BALLOT
 * * `GENERAL_MEETING_TYPE_SPECIAL` - GENERAL_MEETING_TYPE_SPECIAL
 * * `GENERAL_MEETING_TYPE_INVALID` - GENERAL_MEETING_TYPE_INVALID
 */
export const GeneralMeetingTypeEnum = {
  GENERAL_MEETING_TYPE_ANNUAL: 'GENERAL_MEETING_TYPE_ANNUAL',
  GENERAL_MEETING_TYPE_BOND_HOLDER: 'GENERAL_MEETING_TYPE_BOND_HOLDER',
  GENERAL_MEETING_TYPE_COURT_ORDERED: 'GENERAL_MEETING_TYPE_COURT_ORDERED',
  GENERAL_MEETING_TYPE_EXTRAORDINARY: 'GENERAL_MEETING_TYPE_EXTRAORDINARY',
  GENERAL_MEETING_TYPE_GENERAL: 'GENERAL_MEETING_TYPE_GENERAL',
  GENERAL_MEETING_TYPE_POSTAL_BALLOT: 'GENERAL_MEETING_TYPE_POSTAL_BALLOT',
  GENERAL_MEETING_TYPE_SPECIAL: 'GENERAL_MEETING_TYPE_SPECIAL',
  GENERAL_MEETING_TYPE_INVALID: 'GENERAL_MEETING_TYPE_INVALID',
} as const

/**
 * * `GENERAL_MEETING_TYPE_ANNUAL` - GENERAL_MEETING_TYPE_ANNUAL
 * * `GENERAL_MEETING_TYPE_BOND_HOLDER` - GENERAL_MEETING_TYPE_BOND_HOLDER
 * * `GENERAL_MEETING_TYPE_COURT_ORDERED` - GENERAL_MEETING_TYPE_COURT_ORDERED
 * * `GENERAL_MEETING_TYPE_EXTRAORDINARY` - GENERAL_MEETING_TYPE_EXTRAORDINARY
 * * `GENERAL_MEETING_TYPE_GENERAL` - GENERAL_MEETING_TYPE_GENERAL
 * * `GENERAL_MEETING_TYPE_POSTAL_BALLOT` - GENERAL_MEETING_TYPE_POSTAL_BALLOT
 * * `GENERAL_MEETING_TYPE_SPECIAL` - GENERAL_MEETING_TYPE_SPECIAL
 * * `GENERAL_MEETING_TYPE_INVALID` - GENERAL_MEETING_TYPE_INVALID
 */
export type GeneralMeetingTypeEnum = (typeof GeneralMeetingTypeEnum)[keyof typeof GeneralMeetingTypeEnum]

/**
 * Write shape for both POST (create) and PATCH (partial update).
 *
 * Required-ness is enforced by passing ``partial=True`` for PATCH at the view
 * layer. Generated fields (``name``, ``create_time``, ``update_time``, the
 * ``*_time`` columns derived from the boolean flags) are not writable.
 *
 * The proxy-deadline-before-meeting-date constraint depends on the resulting
 * (merged) entity, so it is enforced in the service rather than here.
 */
export type GeneralMeetingWriteRequest = {
  /**
   * The name of the organization that this general meeting is for, of the form 'organizations/{uuid}'.
   */
  organization_name: string
  /**
   * The type of the general meeting.
   *
   * * `GENERAL_MEETING_TYPE_ANNUAL` - GENERAL_MEETING_TYPE_ANNUAL
   * * `GENERAL_MEETING_TYPE_BOND_HOLDER` - GENERAL_MEETING_TYPE_BOND_HOLDER
   * * `GENERAL_MEETING_TYPE_COURT_ORDERED` - GENERAL_MEETING_TYPE_COURT_ORDERED
   * * `GENERAL_MEETING_TYPE_EXTRAORDINARY` - GENERAL_MEETING_TYPE_EXTRAORDINARY
   * * `GENERAL_MEETING_TYPE_GENERAL` - GENERAL_MEETING_TYPE_GENERAL
   * * `GENERAL_MEETING_TYPE_POSTAL_BALLOT` - GENERAL_MEETING_TYPE_POSTAL_BALLOT
   * * `GENERAL_MEETING_TYPE_SPECIAL` - GENERAL_MEETING_TYPE_SPECIAL
   */
  type: GeneralMeetingWriteTypeEnum
  /**
   * The date of the general meeting.
   */
  meeting_date: Date
  /**
   * The time the general meeting became invalid.
   */
  invalid_time?: Date | null
  /**
   * The time the general meeting was announced.
   */
  announcement_time?: Date | null
  /**
   * The EDI event ID for the general meeting as presented in the EDI Worldwide Corporate Actions service.
   */
  edi_event_id?: string | null
  /**
   * URL of the official general meeting announcement.
   */
  announcement_url?: string | null
  /**
   * URL linking to a page containing the proxy notice of the general meeting.
   */
  proxy_notice_url?: string | null
  /**
   * URL of the official results for the general meeting.
   */
  results_url?: string | null
  /**
   * The record date for the general meeting: the date on which shareholders must have owned shares in order to be eligible to vote.
   */
  record_date?: Date | null
  /**
   * The record date for the general meeting as reported by EDI.
   */
  edi_record_date?: Date | null
  /**
   * Set to true if voting should be enabled for this general meeting.
   */
  voting_enabled?: boolean
  /**
   * Set to true if the EDI agenda pipelines should be disabled for this general meeting.
   */
  disable_edi_agenda_pipeline_updates?: boolean
  /**
   * The proxy submission deadlines for the general meeting.
   */
  proxy_submission?: ProxySubmissionRequest | null
  /**
   * Index to distinguish duplicated general meetings for the same organization, meeting date and meeting type. Defaults to 0.
   */
  duplicate_index?: number
}

/**
 * * `GENERAL_MEETING_TYPE_ANNUAL` - GENERAL_MEETING_TYPE_ANNUAL
 * * `GENERAL_MEETING_TYPE_BOND_HOLDER` - GENERAL_MEETING_TYPE_BOND_HOLDER
 * * `GENERAL_MEETING_TYPE_COURT_ORDERED` - GENERAL_MEETING_TYPE_COURT_ORDERED
 * * `GENERAL_MEETING_TYPE_EXTRAORDINARY` - GENERAL_MEETING_TYPE_EXTRAORDINARY
 * * `GENERAL_MEETING_TYPE_GENERAL` - GENERAL_MEETING_TYPE_GENERAL
 * * `GENERAL_MEETING_TYPE_POSTAL_BALLOT` - GENERAL_MEETING_TYPE_POSTAL_BALLOT
 * * `GENERAL_MEETING_TYPE_SPECIAL` - GENERAL_MEETING_TYPE_SPECIAL
 */
export const GeneralMeetingWriteTypeEnum = {
  GENERAL_MEETING_TYPE_ANNUAL: 'GENERAL_MEETING_TYPE_ANNUAL',
  GENERAL_MEETING_TYPE_BOND_HOLDER: 'GENERAL_MEETING_TYPE_BOND_HOLDER',
  GENERAL_MEETING_TYPE_COURT_ORDERED: 'GENERAL_MEETING_TYPE_COURT_ORDERED',
  GENERAL_MEETING_TYPE_EXTRAORDINARY: 'GENERAL_MEETING_TYPE_EXTRAORDINARY',
  GENERAL_MEETING_TYPE_GENERAL: 'GENERAL_MEETING_TYPE_GENERAL',
  GENERAL_MEETING_TYPE_POSTAL_BALLOT: 'GENERAL_MEETING_TYPE_POSTAL_BALLOT',
  GENERAL_MEETING_TYPE_SPECIAL: 'GENERAL_MEETING_TYPE_SPECIAL',
} as const

/**
 * * `GENERAL_MEETING_TYPE_ANNUAL` - GENERAL_MEETING_TYPE_ANNUAL
 * * `GENERAL_MEETING_TYPE_BOND_HOLDER` - GENERAL_MEETING_TYPE_BOND_HOLDER
 * * `GENERAL_MEETING_TYPE_COURT_ORDERED` - GENERAL_MEETING_TYPE_COURT_ORDERED
 * * `GENERAL_MEETING_TYPE_EXTRAORDINARY` - GENERAL_MEETING_TYPE_EXTRAORDINARY
 * * `GENERAL_MEETING_TYPE_GENERAL` - GENERAL_MEETING_TYPE_GENERAL
 * * `GENERAL_MEETING_TYPE_POSTAL_BALLOT` - GENERAL_MEETING_TYPE_POSTAL_BALLOT
 * * `GENERAL_MEETING_TYPE_SPECIAL` - GENERAL_MEETING_TYPE_SPECIAL
 */
export type GeneralMeetingWriteTypeEnum = (typeof GeneralMeetingWriteTypeEnum)[keyof typeof GeneralMeetingWriteTypeEnum]

export type GetOrganizationByIdentifierRequestRequest = {
  identifier: OrganizationIdentifierRequest
}

export type Holding = {
  /**
   * Unique identifier for the holdings record
   */
  readonly id: string
  /**
   * ISIN (International Securities Identification Number). Must be 12-character alphanumeric code.
   */
  isin?: string | null
  /**
   * Number of shares held
   */
  settled_quantity: number
  /**
   * CUSIP (Committee on Uniform Securities Identification Procedures) number. A 9-character alphanumeric code that identifies North American financial securities.
   */
  cusip: string
  /**
   * When the holdings record is valid
   */
  valid_time: Date
  /**
   * When the holdings record was created
   */
  readonly create_time: Date
  /**
   * When the holdings record was last updated
   */
  readonly update_time: Date
  /**
   * Reference to the voter owning the holdings
   */
  voter_id: string
}

/**
 * Serializer for creating holdings (without voter_id).
 */
export type HoldingInputRequest = {
  /**
   * ISIN (International Securities Identification Number). Must be 12-character alphanumeric code.
   */
  isin?: string | null
  /**
   * Number of shares held
   */
  settled_quantity: number
  /**
   * CUSIP (Committee on Uniform Securities Identification Procedures) number. A 9-character alphanumeric code that identifies North American financial securities.
   */
  cusip: string
  /**
   * When the holdings record is valid
   */
  valid_time: Date
}

export type HoldingResponse = {
  /**
   * List of holdings for the voter
   */
  holdings: Array<Holding>
}

/**
 * * `duns` - duns
 * * `edi_issuer_id` - edi_issuer_id
 * * `lei` - lei
 */
export const IdentifierTypeEnum = {
  DUNS: 'duns',
  EDI_ISSUER_ID: 'edi_issuer_id',
  LEI: 'lei',
} as const

/**
 * * `duns` - duns
 * * `edi_issuer_id` - edi_issuer_id
 * * `lei` - lei
 */
export type IdentifierTypeEnum = (typeof IdentifierTypeEnum)[keyof typeof IdentifierTypeEnum]

export type Industry = {
  naics_2017: IndustryNaics
}

export type IndustryNaics = {
  code: string
  readonly title: string | null
}

export type IndustryNaicsRequest = {
  code: string
}

export type IndustryRequest = {
  naics_2017: IndustryNaicsRequest
}

export type Instrument = {
  /**
   * Resource name of the instrument, in the format `instruments/{isin}`.
   */
  readonly name: string
  /**
   * The ISIN of the instrument as defined by ISO 6166. Used as the identifier; it is part of the resource name and so cannot be updated.
   */
  isin: string
  /**
   * A string name representation of the fund. May be thought of as the Issuer Name concatenated with the Name of the instrument.
   */
  title: string
  /**
   * The 4-letter capital MiFIR identifier code describing the kind of financial instrument, which may be equity or non-equity. Values are: SHRS, ETFS, DPRS, CRFT, OTHE, SDRV, SFPS, BOND, ETCS, ETNS, EMAL, DERV.
   */
  mifir_identifier_code: string
  /**
   * Whether the instrument can be broken down.
   */
  is_composite: boolean
  /**
   * The Classification of Financial Instruments — an uppercase six-letter code describing the structure and function of the instrument.
   */
  cfi: string | null
  /**
   * Resource names of public security IDs identifying this instrument (allowed types: sedol, cusip, cin), in the format `securityIDTypes/{type}/securityIDs/{value}`.
   */
  readonly public_security_id_names: Array<string>
}

/**
 * Request body for searching instruments.
 *
 * Domain validation (ISIN, MiFIR, PSID name formats) is delegated to the
 * filter so behaviour matches the previous query-param-based list endpoint
 * exactly; this serializer only validates the request shape.
 */
export type InstrumentSearchRequestRequest = {
  isins?: Array<string>
  mifir_codes?: Array<string>
  public_security_id_names?: Array<string>
  search?: string
  is_composite?: boolean
  only_with_voting_rights?: boolean
}

export type InstrumentWriteRequest = {
  /**
   * The ISIN of the instrument as defined by ISO 6166. Used as the identifier; it is part of the resource name and so cannot be updated.
   */
  isin?: string
  /**
   * A string name representation of the fund. May be thought of as the Issuer Name concatenated with the Name of the instrument.
   */
  title: string
  /**
   * The 4-letter capital MiFIR identifier code describing the kind of financial instrument, which may be equity or non-equity. Values are: SHRS, ETFS, DPRS, CRFT, OTHE, SDRV, SFPS, BOND, ETCS, ETNS, EMAL, DERV.
   */
  mifir_identifier_code: string
  /**
   * Whether the instrument can be broken down.
   */
  is_composite: boolean
  /**
   * The Classification of Financial Instruments — an uppercase six-letter code describing the structure and function of the instrument.
   */
  cfi?: string | null
  /**
   * Resource names of public security IDs identifying this instrument (allowed types: sedol, cusip, cin), in the format `securityIDTypes/{type}/securityIDs/{value}`.
   */
  public_security_id_names?: Array<string>
}

/**
 * Serializer for individual investor account voting information.
 */
export type InvestorAccountVoteInfo = {
  /**
   * Unique identifier of the habitat for the investor account
   */
  habitat_id: string
  /**
   * Unique identifier of the investor account
   */
  investor_account_id: string
  /**
   * Unique identifier of the investor
   */
  investor_id: string
  /**
   * External identifier of the investor (displayable)
   */
  investor_external_id: string
  /**
   * Investor type: 'institutional', 'retail_ptv', or 'unknown'
   */
  investor_type: string
  /**
   * Combined fund proportion from the ballot breakdown graph. Null for accounts not in breakdown.
   */
  ballot_combined_fund_proportion?: number | null
  /**
   * Whether this investor has manual votes. Null when no meeting entitlement data is available.
   */
  has_manual_votes?: boolean | null
  /**
   * Whether this investor account is expected to vote based on the breakdown, and their SIIs. False for accounts not in the breakdown (they have validated entitlements we didn't expect).
   */
  expected_to_vote: boolean
  /**
   * Number of validated meeting entitlements expected for this investor account on this ballot. For accounts not in the breakdown but with validated entitlements, defaults to the count of their validated entitlement IDs (they have entitlements we didn't expect based on the breakdown).
   */
  expected_validated_meeting_entitlements: number
  /**
   * Combined fund proportion from validated meeting entitlement (None when no validated entitlement)
   */
  meeting_entitlement_combined_fund_proportion?: number | null
  /**
   * List of validated meeting entitlement IDs associated with this investor account for this ballot
   */
  validated_meeting_entitlement_ids: Array<string>
}

export type InvestorPolicySii = {
  readonly name: string
  voting_policy_name: string
  public_security_id_name: string
  create_time: Date
  delete_time?: Date | null
  valid_from: Date
  valid_to?: Date | null
}

export type InvestorPolicySiiBatchCreateRequest = {
  investor_name: string
  voting_policy_name: string
  instruments: Array<InvestorPolicySiiInputRequest>
}

export type InvestorPolicySiiBatchDeleteRequest = {
  names: Array<string>
}

/**
 * An instrument with an associated validity period, used as input for batch create operations.
 */
export type InvestorPolicySiiInputRequest = {
  public_security_id_name: string
  valid_from: Date
  valid_to?: Date | null
}

export type InvestorPolicySiiResponse = {
  items: Array<InvestorPolicySii>
}

/**
 * Request body for searching investor policy supported issued instruments.
 *
 * Domain validation (name formats, datetime parsing) is delegated to the
 * filter so behaviour matches the previous query-param-based list endpoint
 * exactly; this serializer only validates the request shape.
 */
export type InvestorPolicySiiSearchRequestRequest = {
  investor_names?: Array<string>
  voting_policy_names?: Array<string>
  public_security_id_names?: Array<string>
  valid_to_after?: string
  valid_to_before?: string
  valid_from_after?: string
  valid_from_before?: string
  include_deleted?: boolean
}

export type InvestorRulesEngine = {
  readonly id: number
  investor_name: string
  rules_engine_name?: string | null
  readonly created_at: Date
  readonly updated_at: Date
}

export type InvestorRulesEngineRequest = {
  investor_name: string
  rules_engine_name?: string | null
}

export type InvestorSiiBatchCreateRequest = {
  investor_name: string
  instruments: Array<InvestorSiiInputRequest>
}

export type InvestorSiiBatchDeleteRequest = {
  names: Array<string>
}

/**
 * An instrument with an associated validity period, used as input for batch create operations.
 */
export type InvestorSiiInputRequest = {
  public_security_id_name: string
  valid_from: Date
  valid_to?: Date | null
}

export type InvestorSiiResponse = {
  items: Array<InvestorSupportedIssuedInstrument>
}

/**
 * Request body for searching investor supported issued instruments.
 *
 * Domain validation (name formats, datetime parsing) is delegated to the
 * filter so behaviour matches the previous query-param-based list endpoint
 * exactly; this serializer only validates the request shape.
 */
export type InvestorSiiSearchRequestRequest = {
  investor_names?: Array<string>
  public_security_id_names?: Array<string>
  valid_to_after?: string
  valid_to_before?: string
  valid_from_after?: string
  valid_from_before?: string
  include_deleted?: boolean
}

export type InvestorSupportedIssuedInstrument = {
  readonly name: string
  public_security_id_name: string
  create_time: Date
  delete_time?: Date | null
  valid_from: Date
  valid_to?: Date | null
}

/**
 * Request serializer for getting which investor accounts can vote on given ballots.
 */
export type InvestorsCanVoteRequest = {
  /**
   * List of proxy intermediary ballot IDs to check
   */
  proxy_intermediary_ballot_ids: Array<string>
  /**
   * When True, sources meeting entitlements using an indirect lookup path instead of the direct PI ballot source ID. The indirect path uses: (1) custodian_account_fund_id from the ballot to find fund variant security IDs that map to owning_fund_security_id on meeting entitlements, (2) target_security_id to match issued_instrument_security_id, and (3) the PI ballot's linked general meeting via transparency_general_meeting_name. This approach avoids issues where multiple PI ballots exist for a single meeting entitlement.
   */
  source_meeting_entitlements_indirectly?: boolean
}

/**
 * Response serializer containing voting information for all requested ballots.
 */
export type InvestorsCanVoteResponse = {
  /**
   * Dictionary mapping proxy intermediary ballot ID to investors can vote, and requires investigation information
   */
  ballots: {
    [key: string]: BallotInvestorsCanVote
  }
}

/**
 * * `PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_ALL` - PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_ALL
 * * `PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_NOT_LINKED` - PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_NOT_LINKED
 * * `PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_LINKED` - PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_LINKED
 */
export const LinkedEnum = {
  PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_ALL: 'PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_ALL',
  PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_NOT_LINKED: 'PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_NOT_LINKED',
  PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_LINKED: 'PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_LINKED',
} as const

/**
 * * `PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_ALL` - PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_ALL
 * * `PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_NOT_LINKED` - PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_NOT_LINKED
 * * `PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_LINKED` - PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_LINKED
 */
export type LinkedEnum = (typeof LinkedEnum)[keyof typeof LinkedEnum]

export type ListProposalCategoriesRequest = {
  /**
   * The proxy intermediaries to filter categories by.
   */
  proxy_intermediary_names: Array<ProxyIntermediaryNamesEnum>
  /**
   * The ids of the transparency proposals to filter categories by.
   */
  transparency_proposal_ids: Array<string>
}

export type ListProposalCategoriesResponse = {
  proposal_categories: Array<ProposalCategory>
}

/**
 * Request body for matching a provider voting recommendation to a proposal.
 */
export type MatchVotingRecommendationFromPvrRequest = {
  /**
   * The proposal to create a recommendation for, in the form organizations/{uuid}/generalMeetings/{uuid}/proposals/{uuid}.
   */
  proposal_name: string
}

export type Meeting = {
  /**
   * Unique identifier for the general meeting
   */
  general_meeting_id: string
  /**
   * Resource name for the general meeting in the format
   * 'organizations/{organization_id}/generalMeetings/{general_meeting_id}'
   */
  readonly general_meeting_name: string
  /**
   * Resource name for the organization in the format 'organizations/{organization_id}'
   */
  readonly organization_name: string
  /**
   * Resource name for the meeting ballot in the format
   * 'habitats/{habitat_id}/meetingBallots/{meeting_ballot_id}'
   */
  readonly meeting_ballot_name: string
  /**
   * Resource name for the scheme in the format 'habitats/{habitat_id}/schemes/{scheme_id}'
   */
  readonly scheme_name: string
  /**
   * Date and time when the meeting is scheduled
   */
  meeting_date: Date
  /**
   * Identifier for the habitat this meeting belongs to
   */
  habitat_id: string
  /**
   * Unique identifier for the organization holding the meeting
   */
  organization_id: string
  /**
   * Display name of the organization
   */
  organization_display_title: string
  /**
   * URL to the organization's logo image
   */
  organization_logo_url?: string | null
  /**
   * NAICS industry classification title for the organization
   */
  organization_naics_title: string
  /**
   * Identifier for the meeting ballot
   */
  meeting_ballot_id: string
  /**
   * Deadline for voting/taking action on meeting proposals
   */
  action_deadline: Date
  /**
   * Identifier for the investment scheme
   */
  scheme_id: string
  /**
   * List of theme/classification codes for proposals in this meeting (e.g., CC, OE, PR)
   */
  proposal_classification_codes?: Array<string>
}

export type MeetingBallot = {
  /**
   * Unique identifier for the meeting ballot
   */
  readonly id: string
  /**
   * The investor this ballot belongs to
   */
  investor: string
  /**
   * The habitat this meeting ballot belongs to
   */
  habitat: string
  /**
   * General meeting this ballot is associated with
   */
  general_meeting: string
  /**
   * Earliest voting deadline across all PI ballots linked to this meeting ballot
   */
  earliest_voting_deadline: Date
  /**
   * Latest voting deadline across all PI ballots linked to this meeting ballot
   */
  latest_voting_deadline: Date
  readonly create_time: Date
  readonly update_time: Date
  complete_time?: Date | null
}

export type MeetingBallotSource = {
  /**
   * Unique identifier for the meeting ballot source
   */
  readonly id: string
  /**
   * The meeting ballot this source contributes to
   */
  meeting_ballot: string
  /**
   * The PI ballot whose entitlements contributed to the meeting ballot
   */
  proxy_intermediary_ballot: string
  /**
   * Investor SII context at the time the source was created
   */
  investor_supported_issued_instrument_id?: string | null
  /**
   * Investor policy SII context at the time the source was created
   */
  investor_policy_supported_issued_instrument_id?: string | null
  /**
   * Fund-manager policy SII context at the time the source was created
   */
  fund_manager_policy_supported_issued_instrument_id?: string | null
  readonly create_time: Date
  readonly update_time: Date
  /**
   * When this source was soft-invalidated; NULL for active sources
   */
  invalid_time?: Date | null
}

/**
 * * `annual` - Annual
 * * `extraordinary` - Extraordinary
 * * `special` - Special
 * * `court_ordered` - Court Ordered
 * * `general` - General
 * * `postal_ballot` - Postal Ballot
 * * `bond_holder` - Bond Holder
 */
export const MeetingTypeEnum = {
  ANNUAL: 'annual',
  EXTRAORDINARY: 'extraordinary',
  SPECIAL: 'special',
  COURT_ORDERED: 'court_ordered',
  GENERAL: 'general',
  POSTAL_BALLOT: 'postal_ballot',
  BOND_HOLDER: 'bond_holder',
} as const

/**
 * * `annual` - Annual
 * * `extraordinary` - Extraordinary
 * * `special` - Special
 * * `court_ordered` - Court Ordered
 * * `general` - General
 * * `postal_ballot` - Postal Ballot
 * * `bond_holder` - Bond Holder
 */
export type MeetingTypeEnum = (typeof MeetingTypeEnum)[keyof typeof MeetingTypeEnum]

export type MinimalInstrument = {
  /**
   * Resource name of the instrument, in the format `instruments/{isin}`.
   */
  readonly name: string
  /**
   * The ISIN of the instrument as defined by ISO 6166. Used as the identifier; it is part of the resource name and so cannot be updated.
   */
  isin: string
  /**
   * A string name representation of the fund. May be thought of as the Issuer Name concatenated with the Name of the instrument.
   */
  title: string
  /**
   * The Classification of Financial Instruments — an uppercase six-letter code describing the structure and function of the instrument.
   */
  cfi: string | null
}

export const NullEnum = {} as const

export type NullEnum = (typeof NullEnum)[keyof typeof NullEnum]

/**
 * Response shape for an Organization.
 *
 * Takes the dict produced by services.build_organization_view (or
 * build_organization_views). The view layer is responsible for assembling
 * that dict from the Organization row plus its joined sub-rows.
 */
export type Organization = {
  readonly name: string
  readonly create_time: Date
  readonly update_time: Date
  legal_title: string
  display_title: string | null
  url: string | null
  logo_url: string | null
  logo_thumbnail_url: string | null
  trbc: string | null
  external_identifiers: Array<OrganizationIdentifier>
  bio: OrganizationBio | null
  issued_isins: Array<string>
  headquarters: OrganizationAddress | null
  industry: Industry | null
  country_of_incorporation_iso2: string | null
}

export type OrganizationAddress = {
  country_code_iso2: string
}

export type OrganizationAddressRequest = {
  country_code_iso2: string
}

export type OrganizationBio = {
  description: string
  source_url: string
  bio_source: BioSourceEnum
}

export type OrganizationBioRequest = {
  description: string
  source_url: string
  bio_source: BioSourceEnum
}

export type OrganizationIdentifier = {
  identifier_type: IdentifierTypeEnum
  value: string
}

export type OrganizationIdentifierRequest = {
  identifier_type: IdentifierTypeEnum
  value: string
}

export type OrganizationLogoUploadRequest = {
  url?: string
  file?: Blob | File
}

/**
 * Request body for searching organizations.
 *
 * Domain validation (name format, identifier pairs, ISINs) is delegated to
 * the filter so behaviour matches the previous query-param-based list
 * endpoint exactly; this serializer only validates the request shape.
 */
export type OrganizationSearchRequestRequest = {
  names?: Array<string>
  search?: string
  identifier_types?: Array<string>
  identifier_values?: Array<string>
  issued_isins?: Array<string>
}

/**
 * Write shape for both PUT (full replace) and PATCH (partial update).
 *
 * Validation is field-level; required-ness is enforced by passing
 * ``partial=True`` for PATCH at the view layer.
 *
 * Note: ``logo_url`` and ``logo_thumbnail_url`` are read-only - the
 * dedicated logo endpoint owns them, so a generic PUT cannot accidentally
 * clear them by omitting them from the payload.
 */
export type OrganizationWriteRequest = {
  legal_title: string
  display_title?: string | null
  url?: string | null
  trbc?: string | null
  external_identifiers?: Array<OrganizationIdentifierRequest>
  bio?: OrganizationBioRequest | null
  issued_isins?: Array<string>
  headquarters?: OrganizationAddressRequest | null
  industry?: IndustryRequest | null
  country_of_incorporation_iso2?: string | null
}

export type PaginatedAuditEventList = {
  next?: string | null
  previous?: string | null
  results: Array<AuditEvent>
}

export type PaginatedBallotEntitlementList = {
  next?: string | null
  previous?: string | null
  results: Array<BallotEntitlement>
}

export type PaginatedFundList = {
  next?: string | null
  previous?: string | null
  results: Array<Fund>
}

export type PaginatedFundManagerList = {
  next?: string | null
  previous?: string | null
  results: Array<FundManager>
}

export type PaginatedFundManagerPolicySiiList = {
  next?: string | null
  previous?: string | null
  results: Array<FundManagerPolicySii>
}

export type PaginatedFundManagerSupportedVotingPolicyHistoricalList = {
  next?: string | null
  previous?: string | null
  results: Array<FundManagerSupportedVotingPolicyHistorical>
}

export type PaginatedFundQuantificationSnapshotList = {
  next?: string | null
  previous?: string | null
  results: Array<FundQuantificationSnapshot>
}

export type PaginatedFundVariantList = {
  next?: string | null
  previous?: string | null
  results: Array<FundVariant>
}

export type PaginatedGeneralMeetingList = {
  next?: string | null
  previous?: string | null
  results: Array<GeneralMeeting>
}

export type PaginatedInstrumentList = {
  next?: string | null
  previous?: string | null
  results: Array<Instrument>
}

export type PaginatedInvestorPolicySiiList = {
  next?: string | null
  previous?: string | null
  results: Array<InvestorPolicySii>
}

export type PaginatedInvestorSupportedIssuedInstrumentList = {
  next?: string | null
  previous?: string | null
  results: Array<InvestorSupportedIssuedInstrument>
}

export type PaginatedMeetingBallotList = {
  next?: string | null
  previous?: string | null
  results: Array<MeetingBallot>
}

export type PaginatedMeetingBallotSourceList = {
  next?: string | null
  previous?: string | null
  results: Array<MeetingBallotSource>
}

export type PaginatedMeetingList = {
  next?: string | null
  previous?: string | null
  results: Array<Meeting>
}

export type PaginatedOrganizationList = {
  next?: string | null
  previous?: string | null
  results: Array<Organization>
}

export type PaginatedPiBallotSearchList = {
  next?: string | null
  previous?: string | null
  results: Array<PiBallotSearch>
}

export type PaginatedPiMeetingSearchList = {
  next?: string | null
  previous?: string | null
  results: Array<PiMeetingSearch>
}

export type PaginatedProposalList = {
  next?: string | null
  previous?: string | null
  results: Array<Proposal>
}

export type PaginatedProviderList = {
  next?: string | null
  previous?: string | null
  results: Array<Provider>
}

export type PaginatedProviderVotingRecommendationList = {
  next?: string | null
  previous?: string | null
  results: Array<ProviderVotingRecommendation>
}

export type PaginatedProxyIntermediaryList = {
  next?: string | null
  previous?: string | null
  results: Array<ProxyIntermediary>
}

export type PaginatedProxyIntermediaryMeetingAuditEventList = {
  next?: string | null
  previous?: string | null
  results: Array<ProxyIntermediaryMeetingAuditEvent>
}

export type PaginatedProxyIntermediaryMeetingList = {
  next?: string | null
  previous?: string | null
  results: Array<ProxyIntermediaryMeeting>
}

export type PaginatedProxyIntermediaryProposalList = {
  next?: string | null
  previous?: string | null
  results: Array<ProxyIntermediaryProposal>
}

export type PaginatedPublicSecurityIdList = {
  next?: string | null
  previous?: string | null
  results: Array<PublicSecurityId>
}

export type PaginatedRulesEngineDefinitionList = {
  next?: string | null
  previous?: string | null
  results: Array<RulesEngineDefinition>
}

export type PaginatedRulesEngineRuleList = {
  next?: string | null
  previous?: string | null
  results: Array<RulesEngineRule>
}

export type PaginatedSplitVoteInstructionOverwriteReasonList = {
  next?: string | null
  previous?: string | null
  results: Array<SplitVoteInstructionOverwriteReason>
}

export type PaginatedVoterList = {
  next?: string | null
  previous?: string | null
  results: Array<Voter>
}

export type PaginatedVotingPolicyDocumentList = {
  next?: string | null
  previous?: string | null
  results: Array<VotingPolicyDocument>
}

export type PaginatedVotingPolicyList = {
  next?: string | null
  previous?: string | null
  results: Array<VotingPolicy>
}

export type PaginatedVotingRecommendationList = {
  next?: string | null
  previous?: string | null
  results: Array<VotingRecommendation>
}

/**
 * Write shape for both POST (create) and PATCH (partial update).
 *
 * Required-ness is enforced by passing ``partial=True`` for PATCH at the view
 * layer. Generated fields (``name``, ``create_time``, ``update_time``, the
 * ``*_time`` columns derived from the boolean flags) are not writable.
 *
 * The proxy-deadline-before-meeting-date constraint depends on the resulting
 * (merged) entity, so it is enforced in the service rather than here.
 */
export type PatchedGeneralMeetingWriteRequest = {
  /**
   * The name of the organization that this general meeting is for, of the form 'organizations/{uuid}'.
   */
  organization_name?: string
  /**
   * The type of the general meeting.
   *
   * * `GENERAL_MEETING_TYPE_ANNUAL` - GENERAL_MEETING_TYPE_ANNUAL
   * * `GENERAL_MEETING_TYPE_BOND_HOLDER` - GENERAL_MEETING_TYPE_BOND_HOLDER
   * * `GENERAL_MEETING_TYPE_COURT_ORDERED` - GENERAL_MEETING_TYPE_COURT_ORDERED
   * * `GENERAL_MEETING_TYPE_EXTRAORDINARY` - GENERAL_MEETING_TYPE_EXTRAORDINARY
   * * `GENERAL_MEETING_TYPE_GENERAL` - GENERAL_MEETING_TYPE_GENERAL
   * * `GENERAL_MEETING_TYPE_POSTAL_BALLOT` - GENERAL_MEETING_TYPE_POSTAL_BALLOT
   * * `GENERAL_MEETING_TYPE_SPECIAL` - GENERAL_MEETING_TYPE_SPECIAL
   */
  type?: GeneralMeetingWriteTypeEnum
  /**
   * The date of the general meeting.
   */
  meeting_date?: Date
  /**
   * The time the general meeting became invalid.
   */
  invalid_time?: Date | null
  /**
   * The time the general meeting was announced.
   */
  announcement_time?: Date | null
  /**
   * The EDI event ID for the general meeting as presented in the EDI Worldwide Corporate Actions service.
   */
  edi_event_id?: string | null
  /**
   * URL of the official general meeting announcement.
   */
  announcement_url?: string | null
  /**
   * URL linking to a page containing the proxy notice of the general meeting.
   */
  proxy_notice_url?: string | null
  /**
   * URL of the official results for the general meeting.
   */
  results_url?: string | null
  /**
   * The record date for the general meeting: the date on which shareholders must have owned shares in order to be eligible to vote.
   */
  record_date?: Date | null
  /**
   * The record date for the general meeting as reported by EDI.
   */
  edi_record_date?: Date | null
  /**
   * Set to true if voting should be enabled for this general meeting.
   */
  voting_enabled?: boolean
  /**
   * Set to true if the EDI agenda pipelines should be disabled for this general meeting.
   */
  disable_edi_agenda_pipeline_updates?: boolean
  /**
   * The proxy submission deadlines for the general meeting.
   */
  proxy_submission?: ProxySubmissionRequest | null
  /**
   * Index to distinguish duplicated general meetings for the same organization, meeting date and meeting type. Defaults to 0.
   */
  duplicate_index?: number
}

/**
 * Write shape for both PUT (full replace) and PATCH (partial update).
 *
 * Validation is field-level; required-ness is enforced by passing
 * ``partial=True`` for PATCH at the view layer.
 *
 * Note: ``logo_url`` and ``logo_thumbnail_url`` are read-only - the
 * dedicated logo endpoint owns them, so a generic PUT cannot accidentally
 * clear them by omitting them from the payload.
 */
export type PatchedOrganizationWriteRequest = {
  legal_title?: string
  display_title?: string | null
  url?: string | null
  trbc?: string | null
  external_identifiers?: Array<OrganizationIdentifierRequest>
  bio?: OrganizationBioRequest | null
  issued_isins?: Array<string>
  headquarters?: OrganizationAddressRequest | null
  industry?: IndustryRequest | null
  country_of_incorporation_iso2?: string | null
}

/**
 * Partial-update (PATCH) shape for a proposal.
 *
 * Every field is optional. Fields omitted from the request are preserved from
 * the proposal's current version by the service; a field sent with a value
 * overwrites it, and a nullable field sent as null clears it. The three code
 * lists drop the write serializer's ``default=list`` so that omitting one
 * preserves the existing codes rather than clearing them — sending an empty
 * list still clears.
 */
export type PatchedProposalPatchRequest = {
  /**
   * The alphanumeric sequence identifier for the proposal within the meeting.
   */
  sequence_identifier?: string
  /**
   * The human-readable title of the proposal.
   */
  title?: string
  /**
   * Optional long-form description of the proposal.
   */
  description?: string | null
  /**
   * The management voting recommendation.
   */
  management_recommendation?: ProposalManagementRecommendationRequest | null
  /**
   * Who proposed this: a PROPOSAL_SOURCE_* enum name.
   *
   * * `PROPOSAL_SOURCE_MANAGEMENT` - PROPOSAL_SOURCE_MANAGEMENT
   * * `PROPOSAL_SOURCE_SHAREHOLDER` - PROPOSAL_SOURCE_SHAREHOLDER
   */
  source?: SourceEnum
  /**
   * The fraction of votes required for the proposal to pass.
   */
  pass_threshold?: ProposalPassThresholdRequest | null
  /**
   * The voting outcome for this proposal.
   */
  outcome?: ProposalOutcomeRequest | null
  /**
   * The EDI numeric identifier for this proposal.
   */
  edi_proposal_identifier?: number | null
  /**
   * The resource name of the parent proposal, if this is a sub-proposal.
   */
  parent_proposal_name?: string | null
  /**
   * The EDI sequence number for this proposal.
   */
  edi_sequence_number?: number | null
  /**
   * Whether shareholders can cast votes on this proposal.
   */
  votable?: boolean
  /**
   * Full text of the proposal as supplied by EDI.
   */
  full_text?: string | null
  /**
   * Classification codes to associate with this proposal. Replaces the existing set when sent.
   */
  classification_codes?: Array<string>
  /**
   * The set of valid voting options for this proposal. Replaces the existing set when sent.
   */
  voting_options?: Array<VotingOptionsEnum>
  /**
   * The time the proposal was withdrawn. Null if not withdrawn.
   */
  withdraw_time?: Date | null
  /**
   * SEC category codes to associate with this proposal. Replaces the existing set when sent.
   */
  sec_classification_codes?: Array<string>
}

export type PatchedVoterRequest = {
  /**
   * Free-text label representing the voter in reporting and back office.
   */
  label?: string
}

export type PatchedVotingPolicyDocumentUpdateRequest = {
  /**
   * The document title.
   */
  title?: string
  /**
   * The document's official publication time.
   */
  issue_time?: Date
}

/**
 * Request body for partial-updating a voting policy.
 *
 * Only the fields present in the request body are updated; absent fields are left
 * untouched. All fields are optional, but supplying `available_to_investor_type` as
 * an empty list is rejected (the policy must remain available to at least one
 * investor type).
 */
export type PatchedVotingPolicyUpdateRequest = {
  /**
   * The voting policy title. Maximum 150 characters.
   */
  title?: string
  /**
   * Optional abbreviated title for the voting policy.
   */
  title_abbreviation?: string | null
  /**
   * Title of the policy provider.
   */
  policy_provider?: string
  /**
   * The description of the voting policy.
   */
  formatted_description?: string
  /**
   * Optional external identifier used to link to upstream policy systems.
   */
  external_id?: string | null
  /**
   * Investor types this policy is available to. At least one is required if supplied.
   */
  available_to_investor_type?: Array<AvailableToInvestorTypeEnum>
  /**
   * Optional Cloudinary URL for the voting policy image.
   */
  image_url?: string | null
}

/**
 * Only voting_instruction and rationale may be updated.
 */
export type PatchedVotingRecommendationUpdateRequest = {
  /**
   * The updated voting instruction.
   *
   * * `for` - For
   * * `against` - Against
   * * `abstain` - Abstain
   * * `withhold` - Withhold
   * * `no_action` - No Action
   * * `one_year` - One Year
   * * `two_years` - Two Years
   * * `three_years` - Three Years
   */
  voting_instruction?: VotingInstructionEnum
  /**
   * The updated rationale. Maximum 5000 characters.
   */
  rationale?: string | null
}

/**
 * Serializer for PI ballot search results.
 */
export type PiBallotSearch = {
  /**
   * Unique identifier for this specific version of the ballot
   */
  ballot_version_id: string
  /**
   * Resource name for the proxy intermediary ballot in the format used by the workflow system.
   */
  readonly proxy_intermediary_ballot_name: string
  /**
   * Resource name for the proxy intermediary meeting in the format used by the workflow system.
   */
  readonly proxy_intermediary_meeting_name: string
  /**
   * Total number of shares available for voting on this ballot
   */
  available_shares: number
  /**
   * Unique identity identifier for the ballot across all versions
   */
  ballot_identity_id: string
  /**
   * External system identifier for the ballot (e.g., from proxy intermediary platform)
   */
  ballot_external_id: string
  /**
   * Indicates if this is the most recent active version of the ballot
   */
  ballot_version_is_current: boolean
  /**
   * Total number of ballots associated with the same proxy intermediary meeting
   */
  ballots_per_meeting: number
  /**
   * Internal identifier for the custodian account holding the shares
   */
  custodian_account_id: string
  /**
   * Account number assigned by the custodian institution
   */
  custodian_account_number: string
  /**
   * Descriptive name or title of the custodian account
   */
  custodian_account_title: string
  /**
   * Indicates if the ballot aligns with the fund manager's voting policy
   */
  fund_manager_policy_supported: boolean
  /**
   * Name of the fund manager organization that manages the fund
   */
  fund_manager_title?: string | null
  /**
   * UUID of the fund manager record
   */
  fund_manager_id?: string | null
  /**
   * Name of the investment fund that owns the shares being voted
   */
  fund_title: string
  /**
   * Official name of the shareholder meeting (e.g., Annual General Meeting 2024)
   */
  general_meeting_name: string
  /**
   * Indicates if the ballot aligns with investor voting guidelines
   */
  investor_supported: boolean
  /**
   * Indicates if the ballot is supported by formal investor policy recommendations
   */
  investor_policy_supported: boolean
  /**
   * Name of the company or organization holding the shareholder meeting
   */
  organization_title: string
  /**
   * CUSIP, ISIN, or other public identifier for the security being voted on
   */
  owned_public_security_id: string
  /**
   * Display name of the proxy intermediary service provider
   */
  proxy_intermediary_title: string
  /**
   * Meeting identifier where this ballot is being voted on
   */
  proxy_intermediary_meeting_id: string
  /**
   * Identifier for the proxy intermediary managing this ballot
   */
  proxy_intermediary_id: string
  /**
   * Indicates if additional validation is needed for split voting scenarios
   */
  split_vote_check_required: boolean
  /**
   * Cutoff date and time for submitting votes on this ballot
   */
  vote_deadline: Date
  /**
   * Current state in the voting workflow (e.g. pending, submitted, checked)
   */
  workflow_status: string
  /**
   * Username of the person who submitted the vote for processing
   */
  workflow_submitter: string
  /**
   * Username of the person who reviewed and approved the vote submission
   */
  workflow_checker: string
  /**
   * UUID of the fund record, used to construct the fund resource name
   */
  fund_id?: string | null
}

/**
 * Serializer for PI meeting search results.
 */
export type PiMeetingSearch = {
  /**
   * Unique identifier for this specific version of the meeting
   */
  meeting_version_id: string
  /**
   * Resource name for the proxy intermediary meeting in the format used by the workflow system.
   */
  readonly proxy_intermediary_meeting_name: string
  /**
   * Unique identity identifier for the meeting across all versions
   */
  meeting_identity_id: string
  /**
   * Indicates if this is the most recent active version of the meeting
   */
  meeting_version_is_current: boolean
  /**
   * Meeting identifier within the proxy intermediary system
   */
  proxy_intermediary_meeting_id: string
  /**
   * Identifier for the proxy intermediary managing this meeting
   */
  proxy_intermediary_id: string
  /**
   * External system identifier for the meeting (e.g., from proxy intermediary platform)
   */
  meeting_external_id: string
  /**
   * Name of the company or organization holding the shareholder meeting
   */
  organization_title: string
  /**
   * Official name of the shareholder meeting (e.g., Annual General Meeting 2024)
   */
  transparency_general_meeting_name: string
  /**
   * Type of meeting (e.g., Annual General Meeting, Extraordinary General Meeting)
   */
  meeting_type: string
  /**
   * Date and time when the meeting is scheduled to occur
   */
  meeting_time: Date
  /**
   * Cutoff date and time for submitting votes for this meeting
   */
  submission_deadline: Date
  /**
   * Record date for determining shareholder eligibility
   */
  record_date?: Date | null
  /**
   * Indicates if the meeting contains contested proposals
   */
  is_contested: boolean
  /**
   * Indicates if split voting is supported for this meeting
   */
  is_split_voting_supported?: boolean | null
  /**
   * Additional comments or notes about the meeting
   */
  meeting_comment?: string | null
  /**
   * Reason why the meeting might not be supported
   */
  unsupported_reason?: string | null
  /**
   * Date and time when the meeting was cancelled, if applicable
   */
  cancel_time?: Date | null
  /**
   * Array of security identifiers associated with this meeting
   */
  security_ids?: Array<string> | null
  /**
   * Identifier for the voting operations workflow
   */
  workflow_id?: string | null
  /**
   * Current state in the voting workflow (e.g. new, ready_for_refinement, successful)
   */
  workflow_status?: string | null
  /**
   * Username of the person assigned to refine the meeting data
   */
  workflow_refiner?: string | null
  /**
   * Username of the person assigned to check the meeting data
   */
  workflow_checker?: string | null
  /**
   * Display name of the proxy intermediary service provider
   */
  proxy_intermediary_title?: string | null
  /**
   * Indicates if any of the meeting's securities are supported by investor policies
   */
  investor_supported?: boolean
  /**
   * Indicates if any of the meeting's securities are supported by investor policy guidelines
   */
  investor_policy_supported?: boolean
  /**
   * Indicates if any of the meeting's securities are supported by fund manager policies
   */
  fund_manager_policy_supported?: boolean
  /**
   * Number of ballots associated with this meeting
   */
  ballot_count: number
  /**
   * Indicates if the meeting has associated ballots available for voting
   */
  has_ballots: boolean
  /**
   * Date and time when the meeting was first created in the proxy intermediary system
   */
  meeting_create_time: Date
  /**
   * Latest valid_to date across all SIIs for this meeting's securities, or NULL if any SII has no expiry
   */
  latest_valid_to_sii?: Date | null
  /**
   * the earliest submission deadline for ballots on the meetingnull if no ballots with submission deadlines present
   */
  earliest_ballot_submission_deadline?: Date | null
}

/**
 * Serializer for a policy.
 */
export type Policy = {
  /**
   * Unique identifier for the policy
   */
  readonly id: string
  /**
   * Identifier to be shared externally with integrated parties
   */
  readonly external_id: string
  /**
   * Title of the voting policy
   */
  title: string
  /**
   * Title of the voting policy provider
   */
  provider_title: string
  /**
   * Description of the voting policy in formatted text
   */
  formatted_description?: string | null
  /**
   * Key referencing the document associated with the voting policy
   */
  document_key?: string | null
  /**
   * Indicates if the selected policy is currently available on direct outreach
   */
  is_available?: boolean | null
  /**
   * When the voting policy was created
   */
  readonly create_time: Date
  /**
   * When the voting policy was last updated
   */
  readonly update_time: Date
}

/**
 * * `for` - For
 * * `against` - Against
 * * `abstain` - Abstain
 * * `withhold` - Withhold
 * * `no_action` - No Action
 * * `one_year` - One Year
 * * `two_years` - Two Years
 * * `three_years` - Three Years
 */
export const PolicyInstructionEnum = {
  FOR: 'for',
  AGAINST: 'against',
  ABSTAIN: 'abstain',
  WITHHOLD: 'withhold',
  NO_ACTION: 'no_action',
  ONE_YEAR: 'one_year',
  TWO_YEARS: 'two_years',
  THREE_YEARS: 'three_years',
} as const

/**
 * * `for` - For
 * * `against` - Against
 * * `abstain` - Abstain
 * * `withhold` - Withhold
 * * `no_action` - No Action
 * * `one_year` - One Year
 * * `two_years` - Two Years
 * * `three_years` - Three Years
 */
export type PolicyInstructionEnum = (typeof PolicyInstructionEnum)[keyof typeof PolicyInstructionEnum]

/**
 * Serializer for a policy.
 */
export type PolicyRequest = {
  /**
   * Title of the voting policy
   */
  title: string
  /**
   * Title of the voting policy provider
   */
  provider_title: string
  /**
   * Description of the voting policy in formatted text
   */
  formatted_description?: string | null
  /**
   * Key referencing the document associated with the voting policy
   */
  document_key?: string | null
  /**
   * Indicates if the selected policy is currently available on direct outreach
   */
  is_available?: boolean | null
}

/**
 * Serializer for policy response.
 */
export type PolicyResponse = {
  /**
   * Unique identifier for the policy
   */
  readonly id: string
  /**
   * Identifier to be shared externally with integrated parties
   */
  external_id: string
  /**
   * Title of the voting policy
   */
  title: string
  /**
   * Title of the voting policy provider
   */
  provider_title: string
  /**
   * Description of the voting policy in formatted text
   */
  formatted_description?: string | null
  /**
   * Key referencing the document associated with the voting policy
   */
  document_key?: string | null
  /**
   * Indicates if the selected policy is currently available on direct outreach
   */
  is_available?: boolean | null
  /**
   * When the voting policy was created
   */
  readonly create_time: Date
  /**
   * When the voting policy was last updated
   */
  readonly update_time: Date
}

/**
 * * `PTV` - PTV
 * * `Shareholder` - Shareholder
 */
export const ProductEnum = { PTV: 'PTV', SHAREHOLDER: 'Shareholder' } as const

/**
 * * `PTV` - PTV
 * * `Shareholder` - Shareholder
 */
export type ProductEnum = (typeof ProductEnum)[keyof typeof ProductEnum]

/**
 * Response shape for a Proposal (current version).
 */
export type Proposal = {
  /**
   * The proposal resource name, of the form 'organizations/{uuid}/generalMeetings/{uuid}/proposals/{uuid}'.
   */
  readonly name: string
  /**
   * The alphanumeric sequence identifier for the proposal within the meeting.
   */
  sequence_identifier: string
  /**
   * The human-readable title of the proposal.
   */
  title: string
  /**
   * Optional long-form description of the proposal.
   */
  description?: string | null
  /**
   * The management voting recommendation.
   */
  management_recommendation?: ProposalManagementRecommendation | null
  /**
   * Who proposed this: a PROPOSAL_SOURCE_* enum name.
   *
   * * `PROPOSAL_SOURCE_MANAGEMENT` - PROPOSAL_SOURCE_MANAGEMENT
   * * `PROPOSAL_SOURCE_SHAREHOLDER` - PROPOSAL_SOURCE_SHAREHOLDER
   */
  source: SourceEnum
  /**
   * The fraction of votes required for the proposal to pass.
   */
  pass_threshold?: ProposalPassThreshold | null
  /**
   * The voting outcome for this proposal.
   */
  outcome?: ProposalOutcome | null
  /**
   * The EDI numeric identifier for this proposal.
   */
  edi_proposal_identifier?: number | null
  /**
   * The resource name of the parent proposal, if this is a sub-proposal.
   */
  parent_proposal_name?: string | null
  /**
   * The EDI sequence number for this proposal.
   */
  edi_sequence_number?: number | null
  /**
   * Whether shareholders can cast votes on this proposal.
   */
  votable: boolean
  /**
   * Full text of the proposal as supplied by EDI.
   */
  full_text?: string | null
  /**
   * Classification codes linked to this proposal.
   */
  classification_codes: Array<string>
  /**
   * The set of valid voting options for this proposal.
   */
  voting_options: Array<VotingOptionsEnum>
  /**
   * The time the proposal was withdrawn. Null if not withdrawn.
   */
  withdraw_time?: Date | null
  /**
   * Computed: true when votable=true and withdraw_time is null.
   */
  readonly currently_votable: boolean | null
  /**
   * SEC category codes linked to this proposal.
   */
  sec_classification_codes: Array<string>
  /**
   * The time this proposal version was created.
   */
  readonly create_time: Date
  /**
   * The time this proposal version was last updated.
   */
  readonly update_time: Date
  /**
   * The time this version was superseded (soft-delete marker). Null if current.
   */
  readonly delete_time: Date | null
}

export type ProposalCategory = {
  /**
   * The proxy intermediary this category belongs to.
   *
   * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
   * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
   * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
   */
  proxy_intermediary: ProxyIntermediaryEnum
  /**
   * The id of the transparency proposal this category refers to.
   */
  transparency_proposal_id: string
  /**
   * The free-text category assigned to the proposal.
   */
  proposal_category: string
}

export type ProposalClassificationCodesResponse = {
  /**
   * Map of classification code to title.
   */
  classification_codes: {
    [key: string]: string
  }
}

/**
 * Request body for counting proposals per general meeting.
 */
export type ProposalCountRequestRequest = {
  /**
   * General meeting resource names to count proposals for.
   */
  general_meeting_names: Array<string>
}

export type ProposalCountResponse = {
  /**
   * Map of general meeting resource name to proposal count.
   */
  counts: {
    [key: string]: number
  }
}

/**
 * Request body for fetching proposal resource names from identity UUIDs.
 */
export type ProposalFetchNamesFromIdsRequestRequest = {
  /**
   * Proposal identity UUIDs to resolve to resource names.
   */
  proposal_ids: Array<string>
}

export type ProposalFetchNamesFromIdsResponse = {
  /**
   * Resolved proposal resource names.
   */
  proposal_names: Array<string>
}

/**
 * Request body for fetching proposals across multiple general meetings.
 */
export type ProposalFetchRequestRequest = {
  /**
   * General meeting resource names to fetch proposals for.
   */
  general_meeting_names: Array<string>
  /**
   * When true, restrict to votable proposals.
   */
  only_votable?: boolean
  /**
   * Filter on the currently_votable computed field.
   *
   * * `CURRENTLY_VOTABLE_FILTER_UNSPECIFIED` - CURRENTLY_VOTABLE_FILTER_UNSPECIFIED
   * * `CURRENTLY_VOTABLE_FILTER_IS_CURRENTLY_VOTABLE` - CURRENTLY_VOTABLE_FILTER_IS_CURRENTLY_VOTABLE
   * * `CURRENTLY_VOTABLE_FILTER_IS_NOT_CURRENTLY_VOTABLE` - CURRENTLY_VOTABLE_FILTER_IS_NOT_CURRENTLY_VOTABLE
   */
  currently_votable_filter?: CurrentlyVotableFilterEnum
}

export type ProposalManagementRecommendation = {
  /**
   * The management voting recommendation.
   *
   * * `VOTING_OPTION_FOR` - for
   * * `VOTING_OPTION_AGAINST` - against
   * * `VOTING_OPTION_ABSTAIN` - abstain
   * * `VOTING_OPTION_WITHHOLD` - withhold
   * * `VOTING_OPTION_NO_ACTION` - no_action
   * * `VOTING_OPTION_ONE_YEAR` - one_year
   * * `VOTING_OPTION_TWO_YEARS` - two_years
   * * `VOTING_OPTION_THREE_YEARS` - three_years
   */
  recommendation: RecommendationEnum
  /**
   * Optional description accompanying the management recommendation.
   */
  recommendation_description?: string | null
}

export type ProposalManagementRecommendationRequest = {
  /**
   * The management voting recommendation.
   *
   * * `VOTING_OPTION_FOR` - for
   * * `VOTING_OPTION_AGAINST` - against
   * * `VOTING_OPTION_ABSTAIN` - abstain
   * * `VOTING_OPTION_WITHHOLD` - withhold
   * * `VOTING_OPTION_NO_ACTION` - no_action
   * * `VOTING_OPTION_ONE_YEAR` - one_year
   * * `VOTING_OPTION_TWO_YEARS` - two_years
   * * `VOTING_OPTION_THREE_YEARS` - three_years
   */
  recommendation: RecommendationEnum
  /**
   * Optional description accompanying the management recommendation.
   */
  recommendation_description?: string | null
}

export type ProposalOutcome = {
  /**
   * The outcome decision.
   *
   * * `PROPOSAL_OUTCOME_DECISION_FOR` - PROPOSAL_OUTCOME_DECISION_FOR
   * * `PROPOSAL_OUTCOME_DECISION_AGAINST` - PROPOSAL_OUTCOME_DECISION_AGAINST
   * * `PROPOSAL_OUTCOME_DECISION_WITHDRAWN` - PROPOSAL_OUTCOME_DECISION_WITHDRAWN
   * * `PROPOSAL_OUTCOME_DECISION_ONE_YEAR` - PROPOSAL_OUTCOME_DECISION_ONE_YEAR
   * * `PROPOSAL_OUTCOME_DECISION_TWO_YEARS` - PROPOSAL_OUTCOME_DECISION_TWO_YEARS
   * * `PROPOSAL_OUTCOME_DECISION_THREE_YEARS` - PROPOSAL_OUTCOME_DECISION_THREE_YEARS
   */
  decision: DecisionEnum
  /**
   * Detailed vote counts.
   */
  votes?: ProposalVotes | null
  /**
   * The time this outcome record was created.
   */
  readonly create_time: Date
  /**
   * The reason the proposal was withdrawn, if applicable.
   */
  withdrawal_reason?: string | null
}

export type ProposalOutcomeRequest = {
  /**
   * The outcome decision.
   *
   * * `PROPOSAL_OUTCOME_DECISION_FOR` - PROPOSAL_OUTCOME_DECISION_FOR
   * * `PROPOSAL_OUTCOME_DECISION_AGAINST` - PROPOSAL_OUTCOME_DECISION_AGAINST
   * * `PROPOSAL_OUTCOME_DECISION_WITHDRAWN` - PROPOSAL_OUTCOME_DECISION_WITHDRAWN
   * * `PROPOSAL_OUTCOME_DECISION_ONE_YEAR` - PROPOSAL_OUTCOME_DECISION_ONE_YEAR
   * * `PROPOSAL_OUTCOME_DECISION_TWO_YEARS` - PROPOSAL_OUTCOME_DECISION_TWO_YEARS
   * * `PROPOSAL_OUTCOME_DECISION_THREE_YEARS` - PROPOSAL_OUTCOME_DECISION_THREE_YEARS
   */
  decision: DecisionEnum
  /**
   * Detailed vote counts.
   */
  votes?: ProposalVotesRequest | null
  /**
   * The reason the proposal was withdrawn, if applicable.
   */
  withdrawal_reason?: string | null
}

export type ProposalPassThreshold = {
  /**
   * The fraction of votes required for the proposal to pass (0.0–1.0).
   */
  threshold: number
}

export type ProposalPassThresholdRequest = {
  /**
   * The fraction of votes required for the proposal to pass (0.0–1.0).
   */
  threshold: number
}

export type ProposalSecClassificationCodesResponse = {
  /**
   * Map of SEC category code to title.
   */
  sec_classification_codes: {
    [key: string]: string
  }
}

/**
 * Request body for searching proposals within a general meeting.
 */
export type ProposalSearchRequestRequest = {
  /**
   * Filter to proposals with these resource names.
   */
  names?: Array<string>
  /**
   * Filter to proposals with these EDI identifiers.
   */
  edi_proposal_identifiers?: Array<number>
  /**
   * Case-insensitive substring filter on proposal title.
   */
  title_query?: string
  /**
   * When true, restrict to proposals with an outcome; when false, restrict to those without.
   */
  has_outcome?: boolean | null
  /**
   * Filter on the currently_votable computed field.
   *
   * * `CURRENTLY_VOTABLE_FILTER_UNSPECIFIED` - CURRENTLY_VOTABLE_FILTER_UNSPECIFIED
   * * `CURRENTLY_VOTABLE_FILTER_IS_CURRENTLY_VOTABLE` - CURRENTLY_VOTABLE_FILTER_IS_CURRENTLY_VOTABLE
   * * `CURRENTLY_VOTABLE_FILTER_IS_NOT_CURRENTLY_VOTABLE` - CURRENTLY_VOTABLE_FILTER_IS_NOT_CURRENTLY_VOTABLE
   */
  currently_votable_filter?: CurrentlyVotableFilterEnum
}

export type ProposalVotes = {
  /**
   * Number of votes cast in favour of the proposal.
   */
  for_votes?: bigint | null
  /**
   * Number of votes cast against the proposal.
   */
  against_votes?: bigint | null
  /**
   * Number of abstention votes.
   */
  abstention_votes?: bigint | null
  /**
   * Number of broker non-votes.
   */
  broker_non_votes?: bigint | null
  /**
   * Number of withheld votes.
   */
  withheld_votes?: bigint | null
  /**
   * Votes in favour of a one-year frequency.
   */
  one_year_votes?: bigint | null
  /**
   * Votes in favour of a two-year frequency.
   */
  two_years_votes?: bigint | null
  /**
   * Votes in favour of a three-year frequency.
   */
  three_years_votes?: bigint | null
}

export type ProposalVotesRequest = {
  /**
   * Number of votes cast in favour of the proposal.
   */
  for_votes?: bigint | null
  /**
   * Number of votes cast against the proposal.
   */
  against_votes?: bigint | null
  /**
   * Number of abstention votes.
   */
  abstention_votes?: bigint | null
  /**
   * Number of broker non-votes.
   */
  broker_non_votes?: bigint | null
  /**
   * Number of withheld votes.
   */
  withheld_votes?: bigint | null
  /**
   * Votes in favour of a one-year frequency.
   */
  one_year_votes?: bigint | null
  /**
   * Votes in favour of a two-year frequency.
   */
  two_years_votes?: bigint | null
  /**
   * Votes in favour of a three-year frequency.
   */
  three_years_votes?: bigint | null
}

/**
 * Write shape for both POST (create) and PUT (full update).
 */
export type ProposalWriteRequest = {
  /**
   * The alphanumeric sequence identifier for the proposal within the meeting.
   */
  sequence_identifier: string
  /**
   * The human-readable title of the proposal.
   */
  title: string
  /**
   * Optional long-form description of the proposal.
   */
  description?: string | null
  /**
   * The management voting recommendation.
   */
  management_recommendation?: ProposalManagementRecommendationRequest | null
  /**
   * Who proposed this: a PROPOSAL_SOURCE_* enum name.
   *
   * * `PROPOSAL_SOURCE_MANAGEMENT` - PROPOSAL_SOURCE_MANAGEMENT
   * * `PROPOSAL_SOURCE_SHAREHOLDER` - PROPOSAL_SOURCE_SHAREHOLDER
   */
  source: SourceEnum
  /**
   * The fraction of votes required for the proposal to pass.
   */
  pass_threshold?: ProposalPassThresholdRequest | null
  /**
   * The voting outcome for this proposal.
   */
  outcome?: ProposalOutcomeRequest | null
  /**
   * The EDI numeric identifier for this proposal.
   */
  edi_proposal_identifier?: number | null
  /**
   * The resource name of the parent proposal, if this is a sub-proposal.
   */
  parent_proposal_name?: string | null
  /**
   * The EDI sequence number for this proposal.
   */
  edi_sequence_number?: number | null
  /**
   * Whether shareholders can cast votes on this proposal.
   */
  votable: boolean
  /**
   * Full text of the proposal as supplied by EDI.
   */
  full_text?: string | null
  /**
   * Classification codes to associate with this proposal.
   */
  classification_codes?: Array<string>
  /**
   * The set of valid voting options for this proposal.
   */
  voting_options?: Array<VotingOptionsEnum>
  /**
   * The time the proposal was withdrawn. Null if not withdrawn.
   */
  withdraw_time?: Date | null
  /**
   * SEC category codes to associate with this proposal.
   */
  sec_classification_codes?: Array<string>
}

export type Provider = {
  /**
   * The provider resource name in format providers/{uuid}
   */
  readonly name: string
  /**
   * The provider ID
   */
  id: string
  /**
   * The title of this provider
   */
  title: string
  /**
   * Generated at the time of provider creation
   */
  create_time: Date
  /**
   * Set to the latest update time
   */
  update_time: Date
}

/**
 * Read serializer for a ProviderVotingRecommendation.
 */
export type ProviderVotingRecommendation = {
  /**
   * Unique identifier of the provider voting recommendation.
   */
  id: string
  /**
   * Time the provider voting recommendation was created.
   */
  create_time: Date
  /**
   * ISINs of the instruments this recommendation applies to.
   */
  instrument_isins: Array<string>
  /**
   * The date of the meeting the recommendation applies to.
   */
  meeting_date: Date
  /**
   * The type of meeting: annual, extraordinary, special, court_ordered, general, postal_ballot, or bond_holder.
   */
  meeting_type: string
  /**
   * The proposal label provided by the recommendation provider.
   */
  proposal_label: string
  /**
   * Optional sequence number for the proposal provided by the recommendation provider.
   */
  proposal_sequence_number: number | null
  /**
   * The proposal text provided by the recommendation provider.
   */
  proposal_text: string
  /**
   * The voting instruction recommended by the policy: for, against, abstain, withhold, no_action, one_year, two_years, or three_years.
   */
  policy_instruction: string
  /**
   * Optional rationale supporting the policy instruction.
   */
  rationale: string | null
  /**
   * Optional name of the policy provider.
   */
  policy_provider: string | null
  /**
   * UUID of the parent voting policy this recommendation belongs to.
   */
  policy_id: string
  /**
   * Set when the recommendation is soft-deleted. Null means not deleted.
   */
  delete_time: Date | null
  /**
   * UUID4 identifying the meeting and policy combination this recommendation belongs to.
   */
  unique_meeting_policy_id: string
  /**
   * Integer version counter for the batch of recommendations for this meeting+policy combination.
   */
  meeting_batch_version: number
  /**
   * Optional provider's identifier for the meeting.
   */
  external_meeting_id: string | null
}

export type ProviderVotingRecommendationCreateRequest = {
  /**
   * ISINs of the instruments this recommendation applies to. Maximum 100.
   */
  instrument_isins: Array<string>
  /**
   * The date of the meeting the recommendation applies to.
   */
  meeting_date: Date
  /**
   * The type of meeting.
   *
   * * `annual` - Annual
   * * `extraordinary` - Extraordinary
   * * `special` - Special
   * * `court_ordered` - Court Ordered
   * * `general` - General
   * * `postal_ballot` - Postal Ballot
   * * `bond_holder` - Bond Holder
   */
  meeting_type: MeetingTypeEnum
  /**
   * The proposal label provided by the recommendation provider. Maximum 100 characters.
   */
  proposal_label: string
  /**
   * Optional sequence number for the proposal provided by the recommendation provider.
   */
  proposal_sequence_number?: number | null
  /**
   * The proposal text provided by the recommendation provider. Maximum 5000 characters.
   */
  proposal_text: string
  /**
   * The voting instruction recommended by the policy.
   *
   * * `for` - For
   * * `against` - Against
   * * `abstain` - Abstain
   * * `withhold` - Withhold
   * * `no_action` - No Action
   * * `one_year` - One Year
   * * `two_years` - Two Years
   * * `three_years` - Three Years
   */
  policy_instruction: PolicyInstructionEnum
  /**
   * Optional rationale supporting the policy instruction. Maximum 5000 characters.
   */
  rationale?: string | null
  /**
   * Optional name of the policy provider. Maximum 100 characters.
   */
  policy_provider?: string | null
  /**
   * UUID of the parent voting policy this recommendation belongs to.
   */
  policy_id: string
  /**
   * UUID4 identifying the meeting and policy combination this recommendation belongs to.
   */
  unique_meeting_policy_id: string
  /**
   * Integer version counter for the batch of recommendations for this meeting+policy combination.
   */
  meeting_batch_version: number
  /**
   * Optional provider's identifier for the meeting.
   */
  external_meeting_id?: string | null
}

/**
 * Wrapper response for endpoints that return an unpaginated list of recommendations.
 */
export type ProviderVotingRecommendationListResponse = {
  provider_voting_recommendations: Array<ProviderVotingRecommendation>
}

/**
 * Body filters for searching provider voting recommendations. All filters are optional.
 */
export type ProviderVotingRecommendationSearchRequest = {
  /**
   * Return recommendations whose instrument_isins contain this ISIN.
   */
  isin?: string
  /**
   * Return recommendations whose instrument_isins overlap any ISIN in this list.
   */
  isins?: Array<string>
  /**
   * Return recommendations whose meeting_date falls on this date.
   */
  meeting_date?: Date
  /**
   * Return recommendations with this meeting type.
   *
   * * `annual` - Annual
   * * `extraordinary` - Extraordinary
   * * `special` - Special
   * * `court_ordered` - Court Ordered
   * * `general` - General
   * * `postal_ballot` - Postal Ballot
   * * `bond_holder` - Bond Holder
   */
  meeting_type?: MeetingTypeEnum
  /**
   * Return recommendations belonging to any of these voting policy UUIDs.
   */
  policy_ids?: Array<string>
  /**
   * If true, only return recommendations from the latest meeting batch version per meeting+policy.
   */
  latest_batch?: boolean
}

export type ProviderWriteRequest = {
  /**
   * The title of this provider
   */
  title: string
}

export type ProxyIntermediary = {
  /**
   * Resource name of the proxy intermediary, in the format 'proxyIntermediaries/{uuid}'.
   */
  readonly name: string
  /**
   * What the proxy intermediary is called, e.g. "ProxyEdge" or "Proxymity".
   */
  title: string
  /**
   * The time the proxy intermediary was created.
   */
  readonly create_time: Date
}

/**
 * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
 * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
 * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
 */
export const ProxyIntermediaryEnum = {
  PROXY_INTERMEDIARY_PROXYEDGE: 'PROXY_INTERMEDIARY_PROXYEDGE',
  PROXY_INTERMEDIARY_PROXYMITY: 'PROXY_INTERMEDIARY_PROXYMITY',
  PROXY_INTERMEDIARY_PROXYEXCHANGE: 'PROXY_INTERMEDIARY_PROXYEXCHANGE',
} as const

/**
 * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
 * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
 * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
 */
export type ProxyIntermediaryEnum = (typeof ProxyIntermediaryEnum)[keyof typeof ProxyIntermediaryEnum]

export type ProxyIntermediaryMeeting = {
  /**
   * Resource name of the meeting, in the format 'proxyIntermediaries/{uuid}/meetings/{uuid}'.
   */
  readonly name: string
  /**
   * Resource name of the proxy intermediary the meeting was sourced from, 'proxyIntermediaries/{uuid}'.
   */
  readonly proxy_intermediary_name: string
  /**
   * The identifier of the meeting in the proxy intermediary's system.
   */
  readonly external_id: string
  /**
   * The title of the organization holding the meeting.
   */
  readonly organization_title: string
  /**
   * Whether the meeting is contested.
   */
  readonly is_contested: boolean
  /**
   * Whether the meeting supports split voting.
   */
  readonly is_split_voting_supported: boolean | null
  /**
   * The type of the meeting as displayed by the proxy intermediary.
   */
  readonly meeting_type_code: string
  /**
   * The date and time the meeting is to be held.
   */
  readonly meeting_time: Date
  /**
   * The date and time votes must be submitted to the proxy intermediary by for this meeting.
   */
  readonly submission_deadline: Date
  /**
   * The date an investor needed to own shares by to be eligible to vote at the meeting.
   */
  readonly record_date: Date | null
  /**
   * The time the entity was created.
   */
  readonly create_time: Date
  /**
   * The time the meeting was cancelled by the proxy intermediary.
   */
  readonly cancel_time: Date | null
  /**
   * Resource name of the linked transparency general meeting, in the format 'organizations/{uuid}/generalMeetings/{uuid}', or empty when not linked.
   */
  readonly transparency_general_meeting_name: string
  /**
   * Proxy intermediary comment on the meeting notification.
   */
  readonly meeting_comment: string
  /**
   * The public security ids of securities able to vote in this meeting.
   */
  readonly security_ids: Array<string>
  /**
   * The date and time the meeting version is valid for.
   */
  readonly valid_time: Date
  /**
   * The reason a meeting is unsupported.
   */
  readonly unsupported_reason: string | null
}

export type ProxyIntermediaryMeetingAuditEvent = {
  /**
   * Resource name of the audit event, 'auditEvents/{uuid}'.
   */
  readonly name: string
  /**
   * Resource name of the audited meeting, 'proxyIntermediaries/{uuid}/meetings/{uuid}'.
   */
  readonly entity_name: string
  /**
   * The original entity, serialised into JSON. '{}' when there is no original entity.
   */
  readonly original_entity_json: string
  /**
   * The difference between the original and new entity, as a JSON merge patch (RFC 7396). '{}' when there is no patch.
   */
  readonly patch_json: string
  /**
   * The time the audit event was created.
   */
  readonly create_time: Date
  /**
   * The name of the endpoint that triggered the change.
   */
  readonly endpoint_name: string
  /**
   * The pseudonymous identifier of the user that triggered the change.
   */
  readonly username: string
}

export type ProxyIntermediaryMeetingAuditEventSearchRequestRequest = {
  /**
   * Audit event resource names to filter by, 'auditEvents/{uuid}'.
   */
  audit_event_names?: Array<string>
  /**
   * Resource name of the audited meeting, 'proxyIntermediaries/{uuid}/meetings/{uuid}'.
   */
  entity_name?: string
}

export type ProxyIntermediaryMeetingBatchCancelRequestRequest = {
  /**
   * Resource names of the meetings to cancel, 'proxyIntermediaries/{uuid}/meetings/{uuid}'.
   */
  names: Array<string>
}

export type ProxyIntermediaryMeetingBatchCancelResponse = {
  /**
   * The cancelled meetings.
   */
  proxy_intermediary_meetings: Array<ProxyIntermediaryMeeting>
}

export type ProxyIntermediaryMeetingLinkRequestRequest = {
  /**
   * Resource name of the meeting to link, 'proxyIntermediaries/{uuid}/meetings/{uuid}'.
   */
  proxy_intermediary_meeting_name: string
  /**
   * Resource name of the transparency general meeting, 'organizations/{uuid}/generalMeetings/{uuid}'.
   */
  transparency_general_meeting_name: string
}

export type ProxyIntermediaryMeetingResponse = {
  /**
   * The meeting.
   */
  proxy_intermediary_meeting: ProxyIntermediaryMeeting
}

export type ProxyIntermediaryMeetingSearchRequestRequest = {
  /**
   * Meeting resource names to filter by, in the format 'proxyIntermediaries/{uuid}/meetings/{uuid}'.
   */
  names?: Array<string>
  /**
   * Resource name of the proxy intermediary to filter by, 'proxyIntermediaries/{uuid}'.
   */
  proxy_intermediary_name?: string
  /**
   * The proxy intermediary to filter by. Preferred over proxy_intermediary_name when both are set.
   *
   * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
   * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
   * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
   */
  proxy_intermediary?: ProxyIntermediaryEnum
  /**
   * External ids to filter by. Requires a proxy intermediary filter.
   */
  external_ids?: Array<string>
  /**
   * Transparency general meeting names to filter by, 'organizations/{uuid}/generalMeetings/{uuid}'.
   */
  transparency_general_meeting_names?: Array<string>
  /**
   * Filters the meetings by cancellation state.
   *
   * * `PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_ALL` - PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_ALL
   * * `PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_NOT_CANCELLED` - PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_NOT_CANCELLED
   * * `PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_CANCELLED` - PROXY_INTERMEDIARY_MEETING_CANCELLED_FILTER_CANCELLED
   */
  cancelled?: CancelledEnum
  /**
   * Filters the meetings by transparency-general-meeting link state.
   *
   * * `PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_ALL` - PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_ALL
   * * `PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_NOT_LINKED` - PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_NOT_LINKED
   * * `PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_LINKED` - PROXY_INTERMEDIARY_MEETING_LINKED_FILTER_LINKED
   */
  linked?: LinkedEnum
  /**
   * Case-insensitive search over organization title, external id and security id.
   */
  search?: string
  /**
   * Filters for meetings with a submission deadline on or after this time.
   */
  submission_deadline_after?: Date
  /**
   * Filters for meetings with a submission deadline before this time.
   */
  submission_deadline_before?: Date
  /**
   * Public security ids of securities able to vote in the meeting.
   */
  security_ids?: Array<string>
  /**
   * When the security_ids filter is set, also include meetings that have no security ids.
   */
  include_meetings_with_no_security_ids?: boolean
  /**
   * Filters for meetings that have ballots, or not. If unset, all meetings are returned.
   */
  has_ballots?: boolean | null
}

export type ProxyIntermediaryMeetingUnlinkRequestRequest = {
  /**
   * Resource name of the meeting to unlink, 'proxyIntermediaries/{uuid}/meetings/{uuid}'.
   */
  proxy_intermediary_meeting_name: string
}

/**
 * Write shape for the upsert endpoint.
 *
 * ``proxy_intermediary_name``, ``external_id`` and ``valid_time`` identify and time-stamp the
 * version and are always required. Every other field is optional: a create must still supply the
 * core meeting fields, and an update patches only the fields present in the request.
 */
export type ProxyIntermediaryMeetingUpsertRequest = {
  /**
   * Resource name of the proxy intermediary the meeting is sourced from, 'proxyIntermediaries/{uuid}'.
   */
  proxy_intermediary_name: string
  /**
   * The identifier of the meeting in the proxy intermediary's system.
   */
  external_id: string
  /**
   * The title of the organization holding the meeting.
   */
  organization_title?: string
  /**
   * Whether the meeting is contested.
   */
  is_contested?: boolean
  /**
   * Whether the meeting supports split voting.
   */
  is_split_voting_supported?: boolean | null
  /**
   * The type of the meeting as displayed by the proxy intermediary.
   */
  meeting_type_code?: string
  /**
   * The date and time the meeting is to be held.
   */
  meeting_time?: Date
  /**
   * The date and time votes must be submitted to the proxy intermediary by for this meeting.
   */
  submission_deadline?: Date
  /**
   * The date an investor needed to own shares by to be eligible to vote at the meeting.
   */
  record_date?: Date | null
  /**
   * The time the meeting was cancelled by the proxy intermediary.
   */
  cancel_time?: Date | null
  /**
   * Proxy intermediary comment on the meeting notification.
   */
  meeting_comment?: string
  /**
   * The public security ids of securities able to vote in this meeting.
   */
  security_ids?: Array<string>
  /**
   * The date and time the meeting version is valid for.
   */
  valid_time: Date
}

export type ProxyIntermediaryMeetingUpsertRequestRequest = {
  /**
   * The meeting to create or update.
   */
  proxy_intermediary_meeting: ProxyIntermediaryMeetingUpsertRequest
  /**
   * The proxy intermediary to resolve to a canonical title and id. Preferred over proxy_intermediary_name when both are supplied.
   *
   * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
   * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
   * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
   */
  proxy_intermediary?: ProxyIntermediaryEnum
}

export type ProxyIntermediaryMeetingUpsertResponse = {
  /**
   * The created or updated meeting.
   */
  proxy_intermediary_meeting: ProxyIntermediaryMeeting
  /**
   * Indicates whether the meeting was created, updated, or left unchanged.
   *
   * * `STATUS_MEETING_INVALID` - STATUS_MEETING_INVALID
   * * `STATUS_MEETING_CREATED` - STATUS_MEETING_CREATED
   * * `STATUS_MEETING_UPDATED` - STATUS_MEETING_UPDATED
   * * `STATUS_MEETING_NO_OPERATION` - STATUS_MEETING_NO_OPERATION
   */
  status: ProxyIntermediaryMeetingUpsertResponseStatusEnum
}

/**
 * * `STATUS_MEETING_INVALID` - STATUS_MEETING_INVALID
 * * `STATUS_MEETING_CREATED` - STATUS_MEETING_CREATED
 * * `STATUS_MEETING_UPDATED` - STATUS_MEETING_UPDATED
 * * `STATUS_MEETING_NO_OPERATION` - STATUS_MEETING_NO_OPERATION
 */
export const ProxyIntermediaryMeetingUpsertResponseStatusEnum = {
  STATUS_MEETING_INVALID: 'STATUS_MEETING_INVALID',
  STATUS_MEETING_CREATED: 'STATUS_MEETING_CREATED',
  STATUS_MEETING_UPDATED: 'STATUS_MEETING_UPDATED',
  STATUS_MEETING_NO_OPERATION: 'STATUS_MEETING_NO_OPERATION',
} as const

/**
 * * `STATUS_MEETING_INVALID` - STATUS_MEETING_INVALID
 * * `STATUS_MEETING_CREATED` - STATUS_MEETING_CREATED
 * * `STATUS_MEETING_UPDATED` - STATUS_MEETING_UPDATED
 * * `STATUS_MEETING_NO_OPERATION` - STATUS_MEETING_NO_OPERATION
 */
export type ProxyIntermediaryMeetingUpsertResponseStatusEnum =
  (typeof ProxyIntermediaryMeetingUpsertResponseStatusEnum)[keyof typeof ProxyIntermediaryMeetingUpsertResponseStatusEnum]

/**
 * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
 * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
 * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
 */
export const ProxyIntermediaryNamesEnum = {
  PROXY_INTERMEDIARY_PROXYEDGE: 'PROXY_INTERMEDIARY_PROXYEDGE',
  PROXY_INTERMEDIARY_PROXYMITY: 'PROXY_INTERMEDIARY_PROXYMITY',
  PROXY_INTERMEDIARY_PROXYEXCHANGE: 'PROXY_INTERMEDIARY_PROXYEXCHANGE',
} as const

/**
 * * `PROXY_INTERMEDIARY_PROXYEDGE` - PROXY_INTERMEDIARY_PROXYEDGE
 * * `PROXY_INTERMEDIARY_PROXYMITY` - PROXY_INTERMEDIARY_PROXYMITY
 * * `PROXY_INTERMEDIARY_PROXYEXCHANGE` - PROXY_INTERMEDIARY_PROXYEXCHANGE
 */
export type ProxyIntermediaryNamesEnum = (typeof ProxyIntermediaryNamesEnum)[keyof typeof ProxyIntermediaryNamesEnum]

export type ProxyIntermediaryProposal = {
  /**
   * Unique identifier for the proposal
   */
  id?: string
  /**
   * The set of valid voting options for this proposal.
   */
  voting_options: Array<ProxyIntermediaryVotingOptionsEnum>
  /**
   * The time the proposal was created.
   */
  create_time: Date
  /**
   * The SHA256 hash of the Proposals in the set. Fields hashed: proxy_intermediary_meeting_id,label, text, voting_options, source, management_recommendation, sequence_number
   */
  proposal_set_id: string
  /**
   * The alphanumeric label for the proposal within the meeting. eg (1a, A, 1)
   */
  label: string
  /**
   * The human-readable text of the proposal.
   */
  text: string
  /**
   * Who proposed this: 'management' or 'shareholder'.
   *
   * * `management` - Management
   * * `shareholder` - Shareholder
   */
  source: ProxyIntermediaryProposalSourceEnum
  /**
   * The management voting recommendation (e.g. 'for', 'against').
   *
   * * `for` - For
   * * `against` - Against
   * * `abstain` - Abstain
   * * `withhold` - Withhold
   * * `one_year` - One Year
   * * `two_years` - Two Years
   * * `three_years` - Three Years
   * * `no_vote` - No Vote
   */
  management_recommendation?: ProxyIntermediaryVotingOptionsEnum | NullEnum | null
  /**
   * The ordering sequence for the proposals from the proxy intermediary
   */
  sequence_number?: number | null
  /**
   * The proxy intermediary meeting this proposal belongs to.
   */
  proxy_intermediary_meeting_id: string
}

/**
 * * `management` - Management
 * * `shareholder` - Shareholder
 */
export const ProxyIntermediaryProposalSourceEnum = { MANAGEMENT: 'management', SHAREHOLDER: 'shareholder' } as const

/**
 * * `management` - Management
 * * `shareholder` - Shareholder
 */
export type ProxyIntermediaryProposalSourceEnum =
  (typeof ProxyIntermediaryProposalSourceEnum)[keyof typeof ProxyIntermediaryProposalSourceEnum]

export type ProxyIntermediarySearchRequestRequest = {
  /**
   * Proxy intermediary resource names to filter by, in the format 'proxyIntermediaries/{uuid}'.
   */
  names?: Array<string>
  /**
   * Proxy intermediary titles to filter by. Exact string match only.
   */
  titles?: Array<string>
}

/**
 * * `for` - For
 * * `against` - Against
 * * `abstain` - Abstain
 * * `withhold` - Withhold
 * * `one_year` - One Year
 * * `two_years` - Two Years
 * * `three_years` - Three Years
 * * `no_vote` - No Vote
 */
export const ProxyIntermediaryVotingOptionsEnum = {
  FOR: 'for',
  AGAINST: 'against',
  ABSTAIN: 'abstain',
  WITHHOLD: 'withhold',
  ONE_YEAR: 'one_year',
  TWO_YEARS: 'two_years',
  THREE_YEARS: 'three_years',
  NO_VOTE: 'no_vote',
} as const

/**
 * * `for` - For
 * * `against` - Against
 * * `abstain` - Abstain
 * * `withhold` - Withhold
 * * `one_year` - One Year
 * * `two_years` - Two Years
 * * `three_years` - Three Years
 * * `no_vote` - No Vote
 */
export type ProxyIntermediaryVotingOptionsEnum =
  (typeof ProxyIntermediaryVotingOptionsEnum)[keyof typeof ProxyIntermediaryVotingOptionsEnum]

export type ProxySubmission = {
  /**
   * The time by which votes for this general meeting must be submitted to Broadridge's Proxy Edge to guarantee they are counted.
   */
  proxy_edge_deadline?: Date | null
}

export type ProxySubmissionRequest = {
  /**
   * The time by which votes for this general meeting must be submitted to Broadridge's Proxy Edge to guarantee they are counted.
   */
  proxy_edge_deadline?: Date | null
}

export type PublicSecurityId = {
  readonly name: string
  create_time: Date
}

export type PublicSecurityIdListQueryRequest = {
  names?: Array<string>
  public_security_id_type_names?: Array<string>
  values?: Array<string>
  instrument_isins?: Array<string>
}

/**
 * A quantification of a fund or fund variant expressed in a single unit type.
 */
export type Quantification = {
  /**
   * The unit type of the quantification: SHARES, an ISO-4217 currency code, or NAV_{currency}.
   */
  unit_type: string
  /**
   * The settled quantity of the quantification.
   */
  settled_quantity: number
}

/**
 * A quantification of a fund or fund variant expressed in a single unit type.
 */
export type QuantificationRequest = {
  /**
   * The unit type of the quantification: SHARES, an ISO-4217 currency code, or NAV_{currency}.
   */
  unit_type: string
  /**
   * The settled quantity of the quantification.
   */
  settled_quantity: number
}

/**
 * * `VOTING_OPTION_FOR` - for
 * * `VOTING_OPTION_AGAINST` - against
 * * `VOTING_OPTION_ABSTAIN` - abstain
 * * `VOTING_OPTION_WITHHOLD` - withhold
 * * `VOTING_OPTION_NO_ACTION` - no_action
 * * `VOTING_OPTION_ONE_YEAR` - one_year
 * * `VOTING_OPTION_TWO_YEARS` - two_years
 * * `VOTING_OPTION_THREE_YEARS` - three_years
 */
export const RecommendationEnum = {
  VOTING_OPTION_FOR: 'VOTING_OPTION_FOR',
  VOTING_OPTION_AGAINST: 'VOTING_OPTION_AGAINST',
  VOTING_OPTION_ABSTAIN: 'VOTING_OPTION_ABSTAIN',
  VOTING_OPTION_WITHHOLD: 'VOTING_OPTION_WITHHOLD',
  VOTING_OPTION_NO_ACTION: 'VOTING_OPTION_NO_ACTION',
  VOTING_OPTION_ONE_YEAR: 'VOTING_OPTION_ONE_YEAR',
  VOTING_OPTION_TWO_YEARS: 'VOTING_OPTION_TWO_YEARS',
  VOTING_OPTION_THREE_YEARS: 'VOTING_OPTION_THREE_YEARS',
} as const

/**
 * * `VOTING_OPTION_FOR` - for
 * * `VOTING_OPTION_AGAINST` - against
 * * `VOTING_OPTION_ABSTAIN` - abstain
 * * `VOTING_OPTION_WITHHOLD` - withhold
 * * `VOTING_OPTION_NO_ACTION` - no_action
 * * `VOTING_OPTION_ONE_YEAR` - one_year
 * * `VOTING_OPTION_TWO_YEARS` - two_years
 * * `VOTING_OPTION_THREE_YEARS` - three_years
 */
export type RecommendationEnum = (typeof RecommendationEnum)[keyof typeof RecommendationEnum]

/**
 * Request serializer for rendering a composition difference in a specific format.
 */
export type RenderCompositionDifferenceRequest = {
  /**
   * Name of the investor
   */
  investor_name: string
  /**
   * List of component differences to render
   */
  components: Array<ComponentDiffRequest>
  /**
   * Output format for the rendered composition difference
   *
   * * `TUMELO` - TUMELO
   * * `PIRC` - PIRC
   * * `GLASS_LEWIS` - GLASS_LEWIS
   * * `MINERVA` - MINERVA
   * * `ISS` - ISS
   * * `EOS` - EOS
   * * `ISS_RETAIL` - ISS_RETAIL
   */
  diff_format: DiffFormatEnum
}

/**
 * * `vote_adjusted_for_voting_restriction` - Vote Adjusted for Voting Restriction
 * * `vote_adjusted_for_contested_meeting` - Vote Adjusted for Contested Meeting
 * * `vote_aligned_with_fm_due_to_restriction` - Vote Aligned with FM Due to Restriction
 * * `vote_aligned_with_fm_due_to_proposal_restriction` - Vote Aligned with FM Due to Proposal Restriction
 */
export const ReportableReasonEnum = {
  VOTE_ADJUSTED_FOR_VOTING_RESTRICTION: 'vote_adjusted_for_voting_restriction',
  VOTE_ADJUSTED_FOR_CONTESTED_MEETING: 'vote_adjusted_for_contested_meeting',
  VOTE_ALIGNED_WITH_FM_DUE_TO_RESTRICTION: 'vote_aligned_with_fm_due_to_restriction',
  VOTE_ALIGNED_WITH_FM_DUE_TO_PROPOSAL_RESTRICTION: 'vote_aligned_with_fm_due_to_proposal_restriction',
} as const

/**
 * * `vote_adjusted_for_voting_restriction` - Vote Adjusted for Voting Restriction
 * * `vote_adjusted_for_contested_meeting` - Vote Adjusted for Contested Meeting
 * * `vote_aligned_with_fm_due_to_restriction` - Vote Aligned with FM Due to Restriction
 * * `vote_aligned_with_fm_due_to_proposal_restriction` - Vote Aligned with FM Due to Proposal Restriction
 */
export type ReportableReasonEnum = (typeof ReportableReasonEnum)[keyof typeof ReportableReasonEnum]

/**
 * * `COUNTRY_SCOPE` - Country Scope
 * * `ISIN_SCOPE` - ISIN Scope
 * * `CFI_REGEX` - CFI Regex
 */
export const RuleTypeEnum = {
  COUNTRY_SCOPE: 'COUNTRY_SCOPE',
  ISIN_SCOPE: 'ISIN_SCOPE',
  CFI_REGEX: 'CFI_REGEX',
} as const

/**
 * * `COUNTRY_SCOPE` - Country Scope
 * * `ISIN_SCOPE` - ISIN Scope
 * * `CFI_REGEX` - CFI Regex
 */
export type RuleTypeEnum = (typeof RuleTypeEnum)[keyof typeof RuleTypeEnum]

/**
 * Read serializer for RulesEngineDefinition.
 */
export type RulesEngineDefinition = {
  readonly id: string
  name: string
  valid_from: Date
  readonly create_time: Date
  readonly update_time: Date
}

/**
 * Write serializer for creating a RulesEngineDefinition.
 */
export type RulesEngineDefinitionCreateRequest = {
  name: string
  valid_from: Date
}

/**
 * Response serializer for the list-by-name endpoint.
 */
export type RulesEngineNamesResponse = {
  names: Array<string>
}

/**
 * Read serializer for RulesEngineRule.
 */
export type RulesEngineRule = {
  readonly id: string
  readonly definition_id: string
  rule_type: RuleTypeEnum
  order: number
  parameters: unknown
  readonly create_time: Date
  readonly update_time: Date
}

/**
 * Write serializer for creating or updating a RulesEngineRule.
 */
export type RulesEngineRuleWriteRequest = {
  rule_type: RuleTypeEnum
  order: number
  parameters: unknown
}

export type SearchProposalRequest = {
  /**
   * The proposal set ids to filter by.
   */
  proposal_set_ids?: Array<string>
  /**
   * The proposal ids to filter by.
   */
  proposal_ids?: Array<string>
}

export type SelectedPolicy = {
  /**
   * Unique identifier for the selected policy record
   */
  readonly id: string
  /**
   * The title of the voter's selected policy
   */
  readonly policy_title: string | null
  /**
   * When the selected policy record was created
   */
  readonly create_time: Date
  /**
   * Reference to the voter selecting the policy
   */
  voter_id: string
  /**
   * Reference to the selected policy
   */
  policy_id: string
}

/**
 * Serializer for creating/updating a selected policy.
 */
export type SelectedPolicyRequestRequest = {
  /**
   * The ID of the policy to select
   */
  policy_id: string
}

/**
 * Serializer for the selected policy response wrapper.
 */
export type SelectedPolicyResponse = {
  /**
   * The voter's selected policy, or null if none selected
   */
  selectedPolicy: SelectedPolicy | null
}

/**
 * * `PROPOSAL_SOURCE_MANAGEMENT` - PROPOSAL_SOURCE_MANAGEMENT
 * * `PROPOSAL_SOURCE_SHAREHOLDER` - PROPOSAL_SOURCE_SHAREHOLDER
 */
export const SourceEnum = {
  PROPOSAL_SOURCE_MANAGEMENT: 'PROPOSAL_SOURCE_MANAGEMENT',
  PROPOSAL_SOURCE_SHAREHOLDER: 'PROPOSAL_SOURCE_SHAREHOLDER',
} as const

/**
 * * `PROPOSAL_SOURCE_MANAGEMENT` - PROPOSAL_SOURCE_MANAGEMENT
 * * `PROPOSAL_SOURCE_SHAREHOLDER` - PROPOSAL_SOURCE_SHAREHOLDER
 */
export type SourceEnum = (typeof SourceEnum)[keyof typeof SourceEnum]

export type SplitVoteInstructionOverwriteReason = {
  /**
   * Reportable reason for the overwrite
   *
   * * `vote_adjusted_for_voting_restriction` - Vote Adjusted for Voting Restriction
   * * `vote_adjusted_for_contested_meeting` - Vote Adjusted for Contested Meeting
   * * `vote_aligned_with_fm_due_to_restriction` - Vote Aligned with FM Due to Restriction
   * * `vote_aligned_with_fm_due_to_proposal_restriction` - Vote Aligned with FM Due to Proposal Restriction
   */
  reportable_reason: ReportableReasonEnum
  /**
   * Description of the overwrite reason for internal use
   */
  description: string
}

export type SplitVoteInstructionProposalOverwrite = {
  /**
   * Unique identifier for the SVI Proposal Overwrite
   */
  readonly id: string
  /**
   * Internal reason for the overwrite, not reportable
   */
  internal_reason?: string | null
  /**
   * Author of the overwrite
   */
  author: string
  /**
   * Investor votes FOR
   */
  investor_votes_for: number
  /**
   * Investor votes AGAINST
   */
  investor_votes_against: number
  /**
   * Investor votes ABSTAIN
   */
  investor_votes_abstain: number
  /**
   * Investor votes WITHHOLD
   */
  investor_votes_withhold: number
  /**
   * Investor votes NO VOTE
   */
  investor_votes_no_vote: number
  /**
   * Investor votes ONE YEAR
   */
  investor_votes_one_year: number
  /**
   * Investor votes TWO YEARS
   */
  investor_votes_two_years: number
  /**
   * Investor votes THREE YEARS
   */
  investor_votes_three_years: number
  /**
   * Split votes FOR
   */
  split_votes_for: number
  /**
   * Split votes AGAINST
   */
  split_votes_against: number
  /**
   * Split votes ABSTAIN
   */
  split_votes_abstain: number
  /**
   * Split votes WITHHOLD
   */
  split_votes_withhold: number
  /**
   * Split votes NO VOTE
   */
  split_votes_no_vote: number
  /**
   * Split votes ONE YEAR
   */
  split_votes_one_year: number
  /**
   * Split votes TWO YEARS
   */
  split_votes_two_years: number
  /**
   * Split votes THREE YEARS
   */
  split_votes_three_years: number
  /**
   * Percentage of split votes FOR
   */
  split_votes_percentage_for: number
  /**
   * Percentage of split votes AGAINST
   */
  split_votes_percentage_against: number
  /**
   * Percentage of split votes ABSTAIN
   */
  split_votes_percentage_abstain: number
  /**
   * Percentage of split votes WITHHOLD
   */
  split_votes_percentage_withhold: number
  /**
   * Percentage of split votes NO VOTE
   */
  split_votes_percentage_no_vote: number
  /**
   * Percentage of split votes ONE YEAR
   */
  split_votes_percentage_one_year: number
  /**
   * Percentage of split votes TWO YEARS
   */
  split_votes_percentage_two_years: number
  /**
   * Percentage of split votes THREE YEARS
   */
  split_votes_percentage_three_years: number
  /**
   * When the overwrite was created
   */
  readonly create_time: Date
  /**
   * When the overwrite was deleted
   */
  readonly delete_time: Date | null
  /**
   * Reference to the SVI Proposal being overwritten
   */
  split_vote_instruction_proposal_id: string
  /**
   * Reportable reason for overwriting the SVI Proposal
   */
  reportable_reason: ReportableReasonEnum
}

export type SplitVoteInstructionProposalOverwriteRequest = {
  /**
   * Internal reason for the overwrite, not reportable
   */
  internal_reason?: string | null
  /**
   * Author of the overwrite
   */
  author: string
  /**
   * Investor votes FOR
   */
  investor_votes_for: number
  /**
   * Investor votes AGAINST
   */
  investor_votes_against: number
  /**
   * Investor votes ABSTAIN
   */
  investor_votes_abstain: number
  /**
   * Investor votes WITHHOLD
   */
  investor_votes_withhold: number
  /**
   * Investor votes NO VOTE
   */
  investor_votes_no_vote: number
  /**
   * Investor votes ONE YEAR
   */
  investor_votes_one_year: number
  /**
   * Investor votes TWO YEARS
   */
  investor_votes_two_years: number
  /**
   * Investor votes THREE YEARS
   */
  investor_votes_three_years: number
  /**
   * Split votes FOR
   */
  split_votes_for: number
  /**
   * Split votes AGAINST
   */
  split_votes_against: number
  /**
   * Split votes ABSTAIN
   */
  split_votes_abstain: number
  /**
   * Split votes WITHHOLD
   */
  split_votes_withhold: number
  /**
   * Split votes NO VOTE
   */
  split_votes_no_vote: number
  /**
   * Split votes ONE YEAR
   */
  split_votes_one_year: number
  /**
   * Split votes TWO YEARS
   */
  split_votes_two_years: number
  /**
   * Split votes THREE YEARS
   */
  split_votes_three_years: number
  /**
   * Percentage of split votes FOR
   */
  split_votes_percentage_for: number
  /**
   * Percentage of split votes AGAINST
   */
  split_votes_percentage_against: number
  /**
   * Percentage of split votes ABSTAIN
   */
  split_votes_percentage_abstain: number
  /**
   * Percentage of split votes WITHHOLD
   */
  split_votes_percentage_withhold: number
  /**
   * Percentage of split votes NO VOTE
   */
  split_votes_percentage_no_vote: number
  /**
   * Percentage of split votes ONE YEAR
   */
  split_votes_percentage_one_year: number
  /**
   * Percentage of split votes TWO YEARS
   */
  split_votes_percentage_two_years: number
  /**
   * Percentage of split votes THREE YEARS
   */
  split_votes_percentage_three_years: number
  /**
   * Reference to the SVI Proposal being overwritten
   */
  split_vote_instruction_proposal_id: string
  /**
   * Reportable reason for overwriting the SVI Proposal
   */
  reportable_reason: ReportableReasonEnum
}

export type SupportedIssuedInstrumentsQueryRequest = {
  /**
   * List of component differences
   */
  components: Array<ComponentDiffRequest>
  /**
   * Date at which the supported instruments take effect
   */
  recomposition_date: Date
  investor_name: string
  /**
   * Name of the voting policy in format 'votingPolicies/{uuid}'
   */
  voting_policy_name?: string | null
}

/**
 * Response serializer for task status.
 */
export type TaskStatus = {
  /**
   * Unique task ID
   */
  task_id: number
  /**
   * Task status (todo, doing, succeeded, failed, cancelled)
   */
  status: string
  /**
   * Name of the task
   */
  task_name: string
  /**
   * Queue name
   */
  queue: string
  /**
   * When task was scheduled
   */
  scheduled_at: Date
  /**
   * When task started execution
   */
  started_at?: Date | null
}

/**
 * Response serializer when a task is successfully queued.
 */
export type TaskTriggered = {
  /**
   * Unique task ID for polling status
   */
  task_id: number
  /**
   * Confirmation message
   */
  message: string
}

/**
 * Request serializer for triggering entitlements computation.
 */
export type TriggerComputeEntitlementsRequest = {
  /**
   * ID of the proxy intermediary ballot to compute entitlements for
   */
  proxy_intermediary_ballot_id: string
  /**
   * Optional list of investor IDs to filter entitlements computation. Intended for testing only. If not provided, all investors are included.
   */
  investor_ids?: Array<string>
}

/**
 * Request serializer for triggering meeting ballot handout processing.
 */
export type TriggerProcessMeetingBallotsRequest = {
  /**
   * ID of the proxy intermediary ballot to process meeting ballots for
   */
  proxy_intermediary_ballot_id: string
  /**
   * Optional habitat ID to filter meeting ballot processing. Intended for testing only. If not provided, investors for all habitats are processed.
   */
  habitat_id?: string | null
}

export type UnassociatedInstrumentsResponse = {
  instruments: Array<Instrument>
}

/**
 * * `proposal_label.proposal_label` - proposal_label.proposal_label
 * * `proposal_label.proposal_category` - proposal_label.proposal_category
 */
export const UpdateMaskEnum = {
  PROPOSAL_LABEL_PROPOSAL_LABEL: 'proposal_label.proposal_label',
  PROPOSAL_LABEL_PROPOSAL_CATEGORY: 'proposal_label.proposal_category',
} as const

/**
 * * `proposal_label.proposal_label` - proposal_label.proposal_label
 * * `proposal_label.proposal_category` - proposal_label.proposal_category
 */
export type UpdateMaskEnum = (typeof UpdateMaskEnum)[keyof typeof UpdateMaskEnum]

/**
 * Request body for updating a voting recommendation from a provider voting recommendation.
 */
export type UpdateVotingRecommendationFromPvrRequest = {
  /**
   * The provider voting recommendation to copy fields from.
   */
  provider_voting_recommendation_id: string
}

/**
 * * `VALID` - VALID
 * * `NOT_VALID` - NOT_VALID
 * * `ALL` - ALL
 */
export const ValidEnum = {
  VALID: 'VALID',
  NOT_VALID: 'NOT_VALID',
  ALL: 'ALL',
} as const

/**
 * * `VALID` - VALID
 * * `NOT_VALID` - NOT_VALID
 * * `ALL` - ALL
 */
export type ValidEnum = (typeof ValidEnum)[keyof typeof ValidEnum]

export type Voter = {
  /**
   * Unique identifier for the voter.
   */
  readonly id: string
  /**
   * Free-text label representing the voter in reporting and back office.
   */
  label: string
  /**
   * The time the voter was created.
   */
  readonly create_time: Date
  /**
   * The time the voter was last updated.
   */
  readonly update_time: Date
}

/**
 * Serializer for voter details response.
 */
export type VoterDetailsResponse = {
  /**
   * Unique identifier for the voter
   */
  id: string
  /**
   * Broker associated with the voter
   */
  broker_id: string
}

export type VoterRequest = {
  /**
   * Free-text label representing the voter in reporting and back office.
   */
  label: string
}

/**
 * Serializer for voter response without holdings.
 */
export type VoterResponse = {
  /**
   * Unique identifier for a voter
   */
  readonly id: string
  /**
   * Mediants unique identifier for the voter
   */
  mediant_id: string
  /**
   * Broker associated with the voter
   */
  broker_id: string
  /**
   * Type of voter
   *
   * * `retail` - Retail
   * * `institutional` - Institutional
   */
  type: VoterTypeEnum
  /**
   * Authorization token for the voter
   */
  token: string
}

/**
 * * `retail` - Retail
 * * `institutional` - Institutional
 */
export const VoterTypeEnum = { RETAIL: 'retail', INSTITUTIONAL: 'institutional' } as const

/**
 * * `retail` - Retail
 * * `institutional` - Institutional
 */
export type VoterTypeEnum = (typeof VoterTypeEnum)[keyof typeof VoterTypeEnum]

/**
 * Serializer for creating or updating a voter with their holdings.
 */
export type VoterWithHoldingsInputRequest = {
  /**
   * Mediants unique identifier for the voter
   */
  mediant_id: string
  /**
   * Broker associated with the voter
   */
  broker_id: string
  /**
   * Type of voter
   *
   * * `retail` - Retail
   * * `institutional` - Institutional
   */
  type: VoterTypeEnum
  /**
   * List of holdings for the voter
   */
  holdings: Array<HoldingInputRequest>
}

/**
 * Serializer for voter response with holdings.
 */
export type VoterWithHoldingsResponse = {
  /**
   * Unique identifier for a voter
   */
  readonly id: string
  /**
   * Mediants unique identifier for the voter
   */
  mediant_id: string
  /**
   * Broker associated with the voter
   */
  broker_id: string
  /**
   * Type of voter
   *
   * * `retail` - Retail
   * * `institutional` - Institutional
   */
  type: VoterTypeEnum
  /**
   * Authorization token for the voter
   */
  token: string
  /**
   * List of holdings for the voter
   */
  readonly holdings: Array<Holding>
}

/**
 * * `for` - For
 * * `against` - Against
 * * `abstain` - Abstain
 * * `withhold` - Withhold
 * * `no_action` - No Action
 * * `one_year` - One Year
 * * `two_years` - Two Years
 * * `three_years` - Three Years
 */
export const VotingInstructionEnum = {
  FOR: 'for',
  AGAINST: 'against',
  ABSTAIN: 'abstain',
  WITHHOLD: 'withhold',
  NO_ACTION: 'no_action',
  ONE_YEAR: 'one_year',
  TWO_YEARS: 'two_years',
  THREE_YEARS: 'three_years',
} as const

/**
 * * `for` - For
 * * `against` - Against
 * * `abstain` - Abstain
 * * `withhold` - Withhold
 * * `no_action` - No Action
 * * `one_year` - One Year
 * * `two_years` - Two Years
 * * `three_years` - Three Years
 */
export type VotingInstructionEnum = (typeof VotingInstructionEnum)[keyof typeof VotingInstructionEnum]

/**
 * * `VOTING_OPTION_FOR` - VOTING_OPTION_FOR
 * * `VOTING_OPTION_AGAINST` - VOTING_OPTION_AGAINST
 * * `VOTING_OPTION_ABSTAIN` - VOTING_OPTION_ABSTAIN
 * * `VOTING_OPTION_WITHHOLD` - VOTING_OPTION_WITHHOLD
 * * `VOTING_OPTION_NO_ACTION` - VOTING_OPTION_NO_ACTION
 * * `VOTING_OPTION_ONE_YEAR` - VOTING_OPTION_ONE_YEAR
 * * `VOTING_OPTION_TWO_YEARS` - VOTING_OPTION_TWO_YEARS
 * * `VOTING_OPTION_THREE_YEARS` - VOTING_OPTION_THREE_YEARS
 */
export const VotingOptionsEnum = {
  VOTING_OPTION_FOR: 'VOTING_OPTION_FOR',
  VOTING_OPTION_AGAINST: 'VOTING_OPTION_AGAINST',
  VOTING_OPTION_ABSTAIN: 'VOTING_OPTION_ABSTAIN',
  VOTING_OPTION_WITHHOLD: 'VOTING_OPTION_WITHHOLD',
  VOTING_OPTION_NO_ACTION: 'VOTING_OPTION_NO_ACTION',
  VOTING_OPTION_ONE_YEAR: 'VOTING_OPTION_ONE_YEAR',
  VOTING_OPTION_TWO_YEARS: 'VOTING_OPTION_TWO_YEARS',
  VOTING_OPTION_THREE_YEARS: 'VOTING_OPTION_THREE_YEARS',
} as const

/**
 * * `VOTING_OPTION_FOR` - VOTING_OPTION_FOR
 * * `VOTING_OPTION_AGAINST` - VOTING_OPTION_AGAINST
 * * `VOTING_OPTION_ABSTAIN` - VOTING_OPTION_ABSTAIN
 * * `VOTING_OPTION_WITHHOLD` - VOTING_OPTION_WITHHOLD
 * * `VOTING_OPTION_NO_ACTION` - VOTING_OPTION_NO_ACTION
 * * `VOTING_OPTION_ONE_YEAR` - VOTING_OPTION_ONE_YEAR
 * * `VOTING_OPTION_TWO_YEARS` - VOTING_OPTION_TWO_YEARS
 * * `VOTING_OPTION_THREE_YEARS` - VOTING_OPTION_THREE_YEARS
 */
export type VotingOptionsEnum = (typeof VotingOptionsEnum)[keyof typeof VotingOptionsEnum]

/**
 * Read serializer for a VotingPolicy.
 *
 * `current_policy_document` is the latest VotingPolicyDocument for the policy by
 * issue_time descending, or null if the policy has no documents. The signed_url on
 * the document is generated at request time and is valid for 24 hours.
 */
export type VotingPolicy = {
  /**
   * Unique resource name in format votingPolicies/{uuid}.
   */
  readonly name: string
  /**
   * The voting policy title.
   */
  title: string
  /**
   * Optional abbreviated title for the voting policy.
   */
  title_abbreviation: string | null
  /**
   * Title of the policy provider.
   */
  policy_provider: string
  /**
   * The description of the voting policy.
   */
  formatted_description: string
  /**
   * Latest voting policy document for this policy, or null if none exist.
   */
  readonly current_policy_document: {
    [key: string]: unknown
  } | null
  /**
   * Optional external identifier used to link to upstream policy systems.
   */
  external_id: string | null
  /**
   * Investor types this policy is available to.
   */
  readonly available_to_investor_type: Array<AvailableToInvestorTypeEnum>
  /**
   * Time the voting policy was created.
   */
  create_time: Date
  /**
   * Time the voting policy was last updated.
   */
  update_time: Date
  /**
   * Optional Cloudinary URL for the voting policy image.
   */
  image_url: string | null
}

/**
 * Request body for creating a voting policy.
 */
export type VotingPolicyCreateRequest = {
  /**
   * The voting policy title. Maximum 150 characters.
   */
  title: string
  /**
   * Optional abbreviated title for the voting policy.
   */
  title_abbreviation?: string | null
  /**
   * Title of the policy provider.
   */
  policy_provider: string
  /**
   * The description of the voting policy.
   */
  formatted_description: string
  /**
   * Optional external identifier used to link to upstream policy systems.
   */
  external_id?: string | null
  /**
   * Investor types this policy is available to. At least one is required.
   */
  available_to_investor_type: Array<AvailableToInvestorTypeEnum>
  /**
   * Optional Cloudinary URL for the voting policy image.
   */
  image_url?: string | null
}

/**
 * Serializer for VotingPolicyDocument.
 * The signed_url is generated at request time from the stored document_key; it is
 * valid for 24 hours and is not persisted.
 */
export type VotingPolicyDocument = {
  /**
   * Resource name in format votingPolicies/{uuid}/documents/{integer}.
   */
  readonly name: string
  /**
   * Timestamp when the document record was created.
   */
  create_time: Date
  /**
   * Timestamp when the document record was last updated.
   */
  update_time: Date
  /**
   * The document's official publication time.
   */
  issue_time: Date
  /**
   * The document title.
   */
  title: string
  /**
   * Presigned S3 URL providing unauthenticated access to the PDF for 24 hours.
   */
  readonly signed_url: string
}

/**
 * Body filters for searching voting policies. All filters are optional.
 */
export type VotingPolicySearchRequest = {
  /**
   * Return only the voting policies with these UUIDs.
   */
  voting_policy_ids?: Array<string>
  /**
   * Return only voting policies available to this investor type.
   *
   * * `institutional` - Institutional
   * * `retail` - Retail
   * * `retail_ptv` - Retail PTV
   */
  investor_type?: AvailableToInvestorTypeEnum
  /**
   * Return voting policies whose title contains this substring (case insensitive).
   */
  search_title?: string
}

/**
 * Read serializer for a VotingRecommendationVersion.
 *
 * The resource name uses the version ID:
 * votingPolicies/{voting_policy_id}/votingRecommendations/{version_id}
 */
export type VotingRecommendation = {
  /**
   * Unique resource name in format votingPolicies/{uuid}/votingRecommendations/{uuid}.
   */
  readonly name: string
  /**
   * The proposal this recommendation applies to, in the form organizations/{uuid}/generalMeetings/{uuid}/proposals/{uuid}.
   */
  proposal_name: string
  /**
   * The voting instruction: for, against, abstain, withhold, no_action, one_year, two_years, or three_years.
   */
  voting_instruction: string
  /**
   * Optional rationale supporting the voting instruction. Maximum 5000 characters.
   */
  rationale: string | null
  /**
   * Optional proposal text provided by the recommendation provider. Maximum 5000 characters.
   */
  proposal_text: string | null
  /**
   * Optional proposal label provided by the recommendation provider. Maximum 20 characters.
   */
  proposal_label: string | null
  /**
   * Optional sequence number for the proposal provided by the recommendation provider.
   */
  proposal_sequence_number: number | null
  /**
   * The provider recommendation that led to the creation of this voting recommendation, if any.
   */
  provider_voting_recommendation_id: string | null
  /**
   * Time this recommendation version was created.
   */
  create_time: Date
  /**
   * Time this recommendation version was last updated.
   */
  update_time: Date
}

/**
 * Read serializer for a VotingRecommendationConfidenceScore.
 */
export type VotingRecommendationConfidenceScore = {
  /**
   * The validation confidence score, between 0.0 and 1.0.
   */
  validation_confidence_score: number
  /**
   * The name of the algorithm that produced the score.
   */
  algorithm_name: string
  /**
   * Time this confidence score was created.
   */
  create_time: Date
  /**
   * Time this confidence score was last updated.
   */
  update_time: Date
}

/**
 * Request serializer for upserting a confidence score. Both fields are required.
 */
export type VotingRecommendationConfidenceScoreUpsertRequest = {
  /**
   * The validation confidence score. Must be between 0.0 and 1.0 inclusive.
   */
  validation_confidence_score: number
  /**
   * The name of the algorithm that produced the score. Maximum 255 characters.
   */
  algorithm_name: string
}

export type VotingRecommendationCreateRequest = {
  /**
   * The proposal to recommend a vote for, in the form organizations/{uuid}/generalMeetings/{uuid}/proposals/{uuid}.
   */
  proposal_name: string
  /**
   * The voting instruction.
   *
   * * `for` - For
   * * `against` - Against
   * * `abstain` - Abstain
   * * `withhold` - Withhold
   * * `no_action` - No Action
   * * `one_year` - One Year
   * * `two_years` - Two Years
   * * `three_years` - Three Years
   */
  voting_instruction: VotingInstructionEnum
  /**
   * Optional rationale supporting the voting instruction. Maximum 5000 characters.
   */
  rationale?: string | null
  /**
   * Optional proposal text provided by the recommendation provider. Maximum 5000 characters.
   */
  proposal_text?: string | null
  /**
   * Optional proposal label provided by the recommendation provider. Maximum 20 characters.
   */
  proposal_label?: string | null
  /**
   * Optional sequence number for the proposal provided by the recommendation provider.
   */
  proposal_sequence_number?: number | null
  /**
   * The provider recommendation that led to the creation of this voting recommendation, if any.
   */
  provider_voting_recommendation_id?: string | null
}

/**
 * Body filters for searching voting recommendations under a voting policy. All filters are optional.
 */
export type VotingRecommendationSearchRequest = {
  /**
   * Return recommendations for any of these proposal resource names (each in the form organizations/{uuid}/generalMeetings/{uuid}/proposals/{uuid}).
   */
  proposal_names?: Array<string>
  /**
   * Return recommendations linked to any of these provider voting recommendation UUIDs.
   */
  provider_voting_recommendation_ids?: Array<string>
}

/**
 * Serializer for BallotEntitlement responses.
 */
export type BallotEntitlementWritable = {
  proxy_intermediary_ballot_id: string
  investor_account_id: string
  ballot_proportion: number
  investor_supported_issued_instrument_id?: string | null
  investor_policy_supported_issued_instrument_id?: string | null
  fund_manager_policy_supported_issued_instrument_id?: string | null
  invalid_time?: Date | null
}

export type BatchVoterWithHoldingsResponseWritable = {
  /**
   * Newly created voters
   */
  created: Array<VoterResponseWritable>
  /**
   * Updated voters
   */
  updated: Array<VoterResponseWritable>
}

export type FetchMinimalInstrumentsResponseWritable = {
  instruments: Array<MinimalInstrumentWritable>
}

export type FundWritable = {
  /**
   * The fund ID
   */
  id: string
  /**
   * The product that the fund exists in
   *
   * * `PTV` - PTV
   * * `Shareholder` - Shareholder
   */
  product: ProductEnum
  /**
   * The creation time of the fund
   */
  create_time: Date
  /**
   * The update time of the fund
   */
  update_time: Date
  /**
   * The title of the fund
   */
  title: string
  /**
   * The base currency of the fund. Currency is a letter code designator specified in ISO 4217, plus some additional non-ISO codes
   */
  base_currency: string | null
  /**
   * The external identifier for the fund
   */
  external_id: string | null
  /**
   * If true this signifies that the fund supports pass through voting to both institutional and retail investors. A fund must have this set in order for the vote engine to issue pass through voting entitlements for organizations owned through this fund.
   */
  institutional_pass_through_voting_enabled: boolean
  /**
   * If true this signifies that we should be receiving quantification and composition data daily for this fund and therefore it is deemed data ready.
   */
  data_ready: boolean
  /**
   * Custodian region is used to identify the public holidays for custodian accounts. It is a CAPITALISED 3-letter code as defined by ISO 3166-1 A-3.
   */
  custodian_region: string | null
}

export type FundManagerWritable = {
  id: string
  title: string
  product: ProductEnum
  website_url: string | null
  logo_url: string | null
  logo_thumbnail_url: string | null
  relationship_owner: string | null
  create_time: Date
  update_time: Date
}

export type FundManagerPolicySiiWritable = {
  fund_manager_name: string
  voting_policy_name: string
  public_security_id_name: string
  create_time: Date
  delete_time?: Date | null
  valid_from: Date
  valid_to?: Date | null
}

export type FundManagerPolicySiiResponseWritable = {
  items: Array<FundManagerPolicySiiWritable>
}

/**
 * Response serializer for batch upserting fund manager supported policies.
 */
export type FundManagerSupportedVotingPolicyBatchUpsertResponseWritable = {
  policies: Array<unknown>
}

export type FundQuantificationSnapshotWritable = {
  /**
   * The time at which the snapshot was valid.
   */
  valid_time: Date
  /**
   * The creation time of the snapshot.
   */
  create_time: Date
  /**
   * The product that the quantification snapshot is associated with.
   *
   * * `PTV` - PTV
   * * `Shareholder` - Shareholder
   */
  product: ProductEnum
}

/**
 * A fund variant is a wrapper for a fund, allowing a single fund to be represented with a
 * variety of differing titles and security IDs.
 */
export type FundVariantWritable = {
  /**
   * The fund variant ID
   */
  id: string
  /**
   * The product that the fund variant exists in
   *
   * * `PTV` - PTV
   * * `Shareholder` - Shareholder
   */
  product: ProductEnum
  /**
   * The title of the fund variant
   */
  title: string
  /**
   * The classification of financial instruments: an uppercase six-letter code describing the structure and function of the instrument.
   */
  cfi: string | null
  /**
   * The creation time of the fund variant
   */
  create_time: Date
  /**
   * The update time of the fund variant
   */
  update_time: Date
}

/**
 * Response shape for a GeneralMeeting.
 *
 * Takes the dict produced by services.build_general_meeting_view (or
 * build_general_meeting_views). The service layer is responsible for
 * assembling that dict from the GeneralMeeting row.
 */
export type GeneralMeetingWritable = {
  /**
   * The name of the organization that this general meeting is for, of the form 'organizations/{uuid}'.
   */
  organization_name: string
  /**
   * The type of the general meeting.
   *
   * * `GENERAL_MEETING_TYPE_ANNUAL` - GENERAL_MEETING_TYPE_ANNUAL
   * * `GENERAL_MEETING_TYPE_BOND_HOLDER` - GENERAL_MEETING_TYPE_BOND_HOLDER
   * * `GENERAL_MEETING_TYPE_COURT_ORDERED` - GENERAL_MEETING_TYPE_COURT_ORDERED
   * * `GENERAL_MEETING_TYPE_EXTRAORDINARY` - GENERAL_MEETING_TYPE_EXTRAORDINARY
   * * `GENERAL_MEETING_TYPE_GENERAL` - GENERAL_MEETING_TYPE_GENERAL
   * * `GENERAL_MEETING_TYPE_POSTAL_BALLOT` - GENERAL_MEETING_TYPE_POSTAL_BALLOT
   * * `GENERAL_MEETING_TYPE_SPECIAL` - GENERAL_MEETING_TYPE_SPECIAL
   * * `GENERAL_MEETING_TYPE_INVALID` - GENERAL_MEETING_TYPE_INVALID
   */
  type: GeneralMeetingTypeEnum
  /**
   * The date of the general meeting.
   */
  meeting_date: Date
  /**
   * The time the general meeting became invalid.
   */
  invalid_time: Date | null
  /**
   * The time the general meeting was announced.
   */
  announcement_time: Date | null
  /**
   * The EDI event ID for the general meeting as presented in the EDI Worldwide Corporate Actions service.
   */
  edi_event_id: string | null
  /**
   * URL of the official general meeting announcement.
   */
  announcement_url: string | null
  /**
   * URL linking to a page containing the proxy notice of the general meeting.
   */
  proxy_notice_url: string | null
  /**
   * URL of the official results for the general meeting.
   */
  results_url: string | null
  /**
   * The record date for the general meeting: the date on which shareholders must have owned shares in order to be eligible to vote.
   */
  record_date: Date | null
  /**
   * The record date for the general meeting as reported by EDI.
   */
  edi_record_date: Date | null
  /**
   * Whether voting is enabled for this general meeting.
   */
  voting_enabled: boolean
  /**
   * Whether the EDI agenda pipelines are disabled for this general meeting.
   */
  disable_edi_agenda_pipeline_updates: boolean
  /**
   * The proxy submission deadlines for the general meeting.
   */
  proxy_submission: ProxySubmission | null
  /**
   * Index to distinguish duplicated general meetings for the same organization, meeting date and meeting type. Defaults to 0.
   */
  duplicate_index: number
}

export type HoldingWritable = {
  /**
   * ISIN (International Securities Identification Number). Must be 12-character alphanumeric code.
   */
  isin?: string | null
  /**
   * Number of shares held
   */
  settled_quantity: number
  /**
   * CUSIP (Committee on Uniform Securities Identification Procedures) number. A 9-character alphanumeric code that identifies North American financial securities.
   */
  cusip: string
  /**
   * When the holdings record is valid
   */
  valid_time: Date
  /**
   * Reference to the voter owning the holdings
   */
  voter_id: string
}

export type HoldingResponseWritable = {
  /**
   * List of holdings for the voter
   */
  holdings: Array<HoldingWritable>
}

export type IndustryWritable = {
  naics_2017: IndustryNaicsWritable
}

export type IndustryNaicsWritable = {
  code: string
}

export type InstrumentWritable = {
  /**
   * The ISIN of the instrument as defined by ISO 6166. Used as the identifier; it is part of the resource name and so cannot be updated.
   */
  isin: string
  /**
   * A string name representation of the fund. May be thought of as the Issuer Name concatenated with the Name of the instrument.
   */
  title: string
  /**
   * The 4-letter capital MiFIR identifier code describing the kind of financial instrument, which may be equity or non-equity. Values are: SHRS, ETFS, DPRS, CRFT, OTHE, SDRV, SFPS, BOND, ETCS, ETNS, EMAL, DERV.
   */
  mifir_identifier_code: string
  /**
   * Whether the instrument can be broken down.
   */
  is_composite: boolean
  /**
   * The Classification of Financial Instruments — an uppercase six-letter code describing the structure and function of the instrument.
   */
  cfi: string | null
}

export type InvestorPolicySiiWritable = {
  voting_policy_name: string
  public_security_id_name: string
  create_time: Date
  delete_time?: Date | null
  valid_from: Date
  valid_to?: Date | null
}

export type InvestorPolicySiiResponseWritable = {
  items: Array<InvestorPolicySiiWritable>
}

export type InvestorRulesEngineWritable = {
  investor_name: string
  rules_engine_name?: string | null
}

export type InvestorSiiResponseWritable = {
  items: Array<InvestorSupportedIssuedInstrumentWritable>
}

export type InvestorSupportedIssuedInstrumentWritable = {
  public_security_id_name: string
  create_time: Date
  delete_time?: Date | null
  valid_from: Date
  valid_to?: Date | null
}

export type MeetingWritable = {
  /**
   * Unique identifier for the general meeting
   */
  general_meeting_id: string
  /**
   * Date and time when the meeting is scheduled
   */
  meeting_date: Date
  /**
   * Identifier for the habitat this meeting belongs to
   */
  habitat_id: string
  /**
   * Unique identifier for the organization holding the meeting
   */
  organization_id: string
  /**
   * Display name of the organization
   */
  organization_display_title: string
  /**
   * URL to the organization's logo image
   */
  organization_logo_url?: string | null
  /**
   * NAICS industry classification title for the organization
   */
  organization_naics_title: string
  /**
   * Identifier for the meeting ballot
   */
  meeting_ballot_id: string
  /**
   * Deadline for voting/taking action on meeting proposals
   */
  action_deadline: Date
  /**
   * Identifier for the investment scheme
   */
  scheme_id: string
  /**
   * List of theme/classification codes for proposals in this meeting (e.g., CC, OE, PR)
   */
  proposal_classification_codes?: Array<string>
}

export type MeetingBallotWritable = {
  /**
   * The investor this ballot belongs to
   */
  investor: string
  /**
   * The habitat this meeting ballot belongs to
   */
  habitat: string
  /**
   * General meeting this ballot is associated with
   */
  general_meeting: string
  /**
   * Earliest voting deadline across all PI ballots linked to this meeting ballot
   */
  earliest_voting_deadline: Date
  /**
   * Latest voting deadline across all PI ballots linked to this meeting ballot
   */
  latest_voting_deadline: Date
  complete_time?: Date | null
}

export type MeetingBallotSourceWritable = {
  /**
   * The meeting ballot this source contributes to
   */
  meeting_ballot: string
  /**
   * The PI ballot whose entitlements contributed to the meeting ballot
   */
  proxy_intermediary_ballot: string
  /**
   * Investor SII context at the time the source was created
   */
  investor_supported_issued_instrument_id?: string | null
  /**
   * Investor policy SII context at the time the source was created
   */
  investor_policy_supported_issued_instrument_id?: string | null
  /**
   * Fund-manager policy SII context at the time the source was created
   */
  fund_manager_policy_supported_issued_instrument_id?: string | null
  /**
   * When this source was soft-invalidated; NULL for active sources
   */
  invalid_time?: Date | null
}

export type MinimalInstrumentWritable = {
  /**
   * The ISIN of the instrument as defined by ISO 6166. Used as the identifier; it is part of the resource name and so cannot be updated.
   */
  isin: string
  /**
   * A string name representation of the fund. May be thought of as the Issuer Name concatenated with the Name of the instrument.
   */
  title: string
  /**
   * The Classification of Financial Instruments — an uppercase six-letter code describing the structure and function of the instrument.
   */
  cfi: string | null
}

/**
 * Response shape for an Organization.
 *
 * Takes the dict produced by services.build_organization_view (or
 * build_organization_views). The view layer is responsible for assembling
 * that dict from the Organization row plus its joined sub-rows.
 */
export type OrganizationWritable = {
  legal_title: string
  display_title: string | null
  url: string | null
  logo_url: string | null
  logo_thumbnail_url: string | null
  trbc: string | null
  external_identifiers: Array<OrganizationIdentifier>
  bio: OrganizationBio | null
  issued_isins: Array<string>
  headquarters: OrganizationAddress | null
  industry: IndustryWritable | null
  country_of_incorporation_iso2: string | null
}

export type PaginatedAuditEventListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<unknown>
}

export type PaginatedBallotEntitlementListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<BallotEntitlementWritable>
}

export type PaginatedFundListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<FundWritable>
}

export type PaginatedFundManagerListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<FundManagerWritable>
}

export type PaginatedFundManagerPolicySiiListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<FundManagerPolicySiiWritable>
}

export type PaginatedFundQuantificationSnapshotListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<FundQuantificationSnapshotWritable>
}

export type PaginatedFundVariantListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<FundVariantWritable>
}

export type PaginatedGeneralMeetingListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<GeneralMeetingWritable>
}

export type PaginatedInstrumentListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<InstrumentWritable>
}

export type PaginatedInvestorPolicySiiListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<InvestorPolicySiiWritable>
}

export type PaginatedInvestorSupportedIssuedInstrumentListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<InvestorSupportedIssuedInstrumentWritable>
}

export type PaginatedMeetingBallotListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<MeetingBallotWritable>
}

export type PaginatedMeetingBallotSourceListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<MeetingBallotSourceWritable>
}

export type PaginatedMeetingListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<MeetingWritable>
}

export type PaginatedOrganizationListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<OrganizationWritable>
}

export type PaginatedPiBallotSearchListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<PiBallotSearchWritable>
}

export type PaginatedPiMeetingSearchListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<PiMeetingSearchWritable>
}

export type PaginatedProposalListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<ProposalWritable>
}

export type PaginatedProviderListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<ProviderWritable>
}

export type PaginatedProxyIntermediaryListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<ProxyIntermediaryWritable>
}

export type PaginatedProxyIntermediaryMeetingAuditEventListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<unknown>
}

export type PaginatedProxyIntermediaryMeetingListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<unknown>
}

export type PaginatedPublicSecurityIdListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<PublicSecurityIdWritable>
}

export type PaginatedRulesEngineDefinitionListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<RulesEngineDefinitionWritable>
}

export type PaginatedRulesEngineRuleListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<RulesEngineRuleWritable>
}

export type PaginatedVoterListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<VoterWritable>
}

export type PaginatedVotingPolicyDocumentListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<VotingPolicyDocumentWritable>
}

export type PaginatedVotingPolicyListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<VotingPolicyWritable>
}

export type PaginatedVotingRecommendationListWritable = {
  next?: string | null
  previous?: string | null
  results: Array<VotingRecommendationWritable>
}

/**
 * Serializer for PI ballot search results.
 */
export type PiBallotSearchWritable = {
  /**
   * Unique identifier for this specific version of the ballot
   */
  ballot_version_id: string
  /**
   * Total number of shares available for voting on this ballot
   */
  available_shares: number
  /**
   * Unique identity identifier for the ballot across all versions
   */
  ballot_identity_id: string
  /**
   * External system identifier for the ballot (e.g., from proxy intermediary platform)
   */
  ballot_external_id: string
  /**
   * Indicates if this is the most recent active version of the ballot
   */
  ballot_version_is_current: boolean
  /**
   * Total number of ballots associated with the same proxy intermediary meeting
   */
  ballots_per_meeting: number
  /**
   * Internal identifier for the custodian account holding the shares
   */
  custodian_account_id: string
  /**
   * Account number assigned by the custodian institution
   */
  custodian_account_number: string
  /**
   * Descriptive name or title of the custodian account
   */
  custodian_account_title: string
  /**
   * Indicates if the ballot aligns with the fund manager's voting policy
   */
  fund_manager_policy_supported: boolean
  /**
   * Name of the fund manager organization that manages the fund
   */
  fund_manager_title?: string | null
  /**
   * UUID of the fund manager record
   */
  fund_manager_id?: string | null
  /**
   * Name of the investment fund that owns the shares being voted
   */
  fund_title: string
  /**
   * Official name of the shareholder meeting (e.g., Annual General Meeting 2024)
   */
  general_meeting_name: string
  /**
   * Indicates if the ballot aligns with investor voting guidelines
   */
  investor_supported: boolean
  /**
   * Indicates if the ballot is supported by formal investor policy recommendations
   */
  investor_policy_supported: boolean
  /**
   * Name of the company or organization holding the shareholder meeting
   */
  organization_title: string
  /**
   * CUSIP, ISIN, or other public identifier for the security being voted on
   */
  owned_public_security_id: string
  /**
   * Display name of the proxy intermediary service provider
   */
  proxy_intermediary_title: string
  /**
   * Meeting identifier where this ballot is being voted on
   */
  proxy_intermediary_meeting_id: string
  /**
   * Identifier for the proxy intermediary managing this ballot
   */
  proxy_intermediary_id: string
  /**
   * Indicates if additional validation is needed for split voting scenarios
   */
  split_vote_check_required: boolean
  /**
   * Cutoff date and time for submitting votes on this ballot
   */
  vote_deadline: Date
  /**
   * Current state in the voting workflow (e.g. pending, submitted, checked)
   */
  workflow_status: string
  /**
   * Username of the person who submitted the vote for processing
   */
  workflow_submitter: string
  /**
   * Username of the person who reviewed and approved the vote submission
   */
  workflow_checker: string
  /**
   * UUID of the fund record, used to construct the fund resource name
   */
  fund_id?: string | null
}

/**
 * Serializer for PI meeting search results.
 */
export type PiMeetingSearchWritable = {
  /**
   * Unique identifier for this specific version of the meeting
   */
  meeting_version_id: string
  /**
   * Unique identity identifier for the meeting across all versions
   */
  meeting_identity_id: string
  /**
   * Indicates if this is the most recent active version of the meeting
   */
  meeting_version_is_current: boolean
  /**
   * Meeting identifier within the proxy intermediary system
   */
  proxy_intermediary_meeting_id: string
  /**
   * Identifier for the proxy intermediary managing this meeting
   */
  proxy_intermediary_id: string
  /**
   * External system identifier for the meeting (e.g., from proxy intermediary platform)
   */
  meeting_external_id: string
  /**
   * Name of the company or organization holding the shareholder meeting
   */
  organization_title: string
  /**
   * Official name of the shareholder meeting (e.g., Annual General Meeting 2024)
   */
  transparency_general_meeting_name: string
  /**
   * Type of meeting (e.g., Annual General Meeting, Extraordinary General Meeting)
   */
  meeting_type: string
  /**
   * Date and time when the meeting is scheduled to occur
   */
  meeting_time: Date
  /**
   * Cutoff date and time for submitting votes for this meeting
   */
  submission_deadline: Date
  /**
   * Record date for determining shareholder eligibility
   */
  record_date?: Date | null
  /**
   * Indicates if the meeting contains contested proposals
   */
  is_contested: boolean
  /**
   * Indicates if split voting is supported for this meeting
   */
  is_split_voting_supported?: boolean | null
  /**
   * Additional comments or notes about the meeting
   */
  meeting_comment?: string | null
  /**
   * Reason why the meeting might not be supported
   */
  unsupported_reason?: string | null
  /**
   * Date and time when the meeting was cancelled, if applicable
   */
  cancel_time?: Date | null
  /**
   * Array of security identifiers associated with this meeting
   */
  security_ids?: Array<string> | null
  /**
   * Identifier for the voting operations workflow
   */
  workflow_id?: string | null
  /**
   * Current state in the voting workflow (e.g. new, ready_for_refinement, successful)
   */
  workflow_status?: string | null
  /**
   * Username of the person assigned to refine the meeting data
   */
  workflow_refiner?: string | null
  /**
   * Username of the person assigned to check the meeting data
   */
  workflow_checker?: string | null
  /**
   * Display name of the proxy intermediary service provider
   */
  proxy_intermediary_title?: string | null
  /**
   * Indicates if any of the meeting's securities are supported by investor policies
   */
  investor_supported?: boolean
  /**
   * Indicates if any of the meeting's securities are supported by investor policy guidelines
   */
  investor_policy_supported?: boolean
  /**
   * Indicates if any of the meeting's securities are supported by fund manager policies
   */
  fund_manager_policy_supported?: boolean
  /**
   * Number of ballots associated with this meeting
   */
  ballot_count: number
  /**
   * Indicates if the meeting has associated ballots available for voting
   */
  has_ballots: boolean
  /**
   * Date and time when the meeting was first created in the proxy intermediary system
   */
  meeting_create_time: Date
  /**
   * Latest valid_to date across all SIIs for this meeting's securities, or NULL if any SII has no expiry
   */
  latest_valid_to_sii?: Date | null
  /**
   * the earliest submission deadline for ballots on the meetingnull if no ballots with submission deadlines present
   */
  earliest_ballot_submission_deadline?: Date | null
}

/**
 * Serializer for a policy.
 */
export type PolicyWritable = {
  /**
   * Title of the voting policy
   */
  title: string
  /**
   * Title of the voting policy provider
   */
  provider_title: string
  /**
   * Description of the voting policy in formatted text
   */
  formatted_description?: string | null
  /**
   * Key referencing the document associated with the voting policy
   */
  document_key?: string | null
  /**
   * Indicates if the selected policy is currently available on direct outreach
   */
  is_available?: boolean | null
}

/**
 * Serializer for policy response.
 */
export type PolicyResponseWritable = {
  /**
   * Identifier to be shared externally with integrated parties
   */
  external_id: string
  /**
   * Title of the voting policy
   */
  title: string
  /**
   * Title of the voting policy provider
   */
  provider_title: string
  /**
   * Description of the voting policy in formatted text
   */
  formatted_description?: string | null
  /**
   * Key referencing the document associated with the voting policy
   */
  document_key?: string | null
  /**
   * Indicates if the selected policy is currently available on direct outreach
   */
  is_available?: boolean | null
}

/**
 * Response shape for a Proposal (current version).
 */
export type ProposalWritable = {
  /**
   * The alphanumeric sequence identifier for the proposal within the meeting.
   */
  sequence_identifier: string
  /**
   * The human-readable title of the proposal.
   */
  title: string
  /**
   * Optional long-form description of the proposal.
   */
  description?: string | null
  /**
   * The management voting recommendation.
   */
  management_recommendation?: ProposalManagementRecommendation | null
  /**
   * Who proposed this: a PROPOSAL_SOURCE_* enum name.
   *
   * * `PROPOSAL_SOURCE_MANAGEMENT` - PROPOSAL_SOURCE_MANAGEMENT
   * * `PROPOSAL_SOURCE_SHAREHOLDER` - PROPOSAL_SOURCE_SHAREHOLDER
   */
  source: SourceEnum
  /**
   * The fraction of votes required for the proposal to pass.
   */
  pass_threshold?: ProposalPassThreshold | null
  /**
   * The voting outcome for this proposal.
   */
  outcome?: ProposalOutcomeWritable | null
  /**
   * The EDI numeric identifier for this proposal.
   */
  edi_proposal_identifier?: number | null
  /**
   * The resource name of the parent proposal, if this is a sub-proposal.
   */
  parent_proposal_name?: string | null
  /**
   * The EDI sequence number for this proposal.
   */
  edi_sequence_number?: number | null
  /**
   * Whether shareholders can cast votes on this proposal.
   */
  votable: boolean
  /**
   * Full text of the proposal as supplied by EDI.
   */
  full_text?: string | null
  /**
   * Classification codes linked to this proposal.
   */
  classification_codes: Array<string>
  /**
   * The set of valid voting options for this proposal.
   */
  voting_options: Array<VotingOptionsEnum>
  /**
   * The time the proposal was withdrawn. Null if not withdrawn.
   */
  withdraw_time?: Date | null
  /**
   * SEC category codes linked to this proposal.
   */
  sec_classification_codes: Array<string>
}

export type ProposalOutcomeWritable = {
  /**
   * The outcome decision.
   *
   * * `PROPOSAL_OUTCOME_DECISION_FOR` - PROPOSAL_OUTCOME_DECISION_FOR
   * * `PROPOSAL_OUTCOME_DECISION_AGAINST` - PROPOSAL_OUTCOME_DECISION_AGAINST
   * * `PROPOSAL_OUTCOME_DECISION_WITHDRAWN` - PROPOSAL_OUTCOME_DECISION_WITHDRAWN
   * * `PROPOSAL_OUTCOME_DECISION_ONE_YEAR` - PROPOSAL_OUTCOME_DECISION_ONE_YEAR
   * * `PROPOSAL_OUTCOME_DECISION_TWO_YEARS` - PROPOSAL_OUTCOME_DECISION_TWO_YEARS
   * * `PROPOSAL_OUTCOME_DECISION_THREE_YEARS` - PROPOSAL_OUTCOME_DECISION_THREE_YEARS
   */
  decision: DecisionEnum
  /**
   * Detailed vote counts.
   */
  votes?: ProposalVotes | null
  /**
   * The reason the proposal was withdrawn, if applicable.
   */
  withdrawal_reason?: string | null
}

export type ProviderWritable = {
  /**
   * The provider ID
   */
  id: string
  /**
   * The title of this provider
   */
  title: string
  /**
   * Generated at the time of provider creation
   */
  create_time: Date
  /**
   * Set to the latest update time
   */
  update_time: Date
}

export type ProxyIntermediaryWritable = {
  /**
   * What the proxy intermediary is called, e.g. "ProxyEdge" or "Proxymity".
   */
  title: string
}

export type ProxyIntermediaryMeetingBatchCancelResponseWritable = {
  /**
   * The cancelled meetings.
   */
  proxy_intermediary_meetings: Array<unknown>
}

export type ProxyIntermediaryMeetingResponseWritable = {
  /**
   * The meeting.
   */
  proxy_intermediary_meeting: unknown
}

export type ProxyIntermediaryMeetingUpsertResponseWritable = {
  /**
   * The created or updated meeting.
   */
  proxy_intermediary_meeting: unknown
  /**
   * Indicates whether the meeting was created, updated, or left unchanged.
   *
   * * `STATUS_MEETING_INVALID` - STATUS_MEETING_INVALID
   * * `STATUS_MEETING_CREATED` - STATUS_MEETING_CREATED
   * * `STATUS_MEETING_UPDATED` - STATUS_MEETING_UPDATED
   * * `STATUS_MEETING_NO_OPERATION` - STATUS_MEETING_NO_OPERATION
   */
  status: ProxyIntermediaryMeetingUpsertResponseStatusEnum
}

export type PublicSecurityIdWritable = {
  create_time: Date
}

/**
 * Read serializer for RulesEngineDefinition.
 */
export type RulesEngineDefinitionWritable = {
  name: string
  valid_from: Date
}

/**
 * Read serializer for RulesEngineRule.
 */
export type RulesEngineRuleWritable = {
  rule_type: RuleTypeEnum
  order: number
  parameters: unknown
}

export type SelectedPolicyWritable = {
  /**
   * Reference to the voter selecting the policy
   */
  voter_id: string
  /**
   * Reference to the selected policy
   */
  policy_id: string
}

/**
 * Serializer for the selected policy response wrapper.
 */
export type SelectedPolicyResponseWritable = {
  /**
   * The voter's selected policy, or null if none selected
   */
  selectedPolicy: SelectedPolicyWritable | null
}

export type SplitVoteInstructionProposalOverwriteWritable = {
  /**
   * Internal reason for the overwrite, not reportable
   */
  internal_reason?: string | null
  /**
   * Author of the overwrite
   */
  author: string
  /**
   * Investor votes FOR
   */
  investor_votes_for: number
  /**
   * Investor votes AGAINST
   */
  investor_votes_against: number
  /**
   * Investor votes ABSTAIN
   */
  investor_votes_abstain: number
  /**
   * Investor votes WITHHOLD
   */
  investor_votes_withhold: number
  /**
   * Investor votes NO VOTE
   */
  investor_votes_no_vote: number
  /**
   * Investor votes ONE YEAR
   */
  investor_votes_one_year: number
  /**
   * Investor votes TWO YEARS
   */
  investor_votes_two_years: number
  /**
   * Investor votes THREE YEARS
   */
  investor_votes_three_years: number
  /**
   * Split votes FOR
   */
  split_votes_for: number
  /**
   * Split votes AGAINST
   */
  split_votes_against: number
  /**
   * Split votes ABSTAIN
   */
  split_votes_abstain: number
  /**
   * Split votes WITHHOLD
   */
  split_votes_withhold: number
  /**
   * Split votes NO VOTE
   */
  split_votes_no_vote: number
  /**
   * Split votes ONE YEAR
   */
  split_votes_one_year: number
  /**
   * Split votes TWO YEARS
   */
  split_votes_two_years: number
  /**
   * Split votes THREE YEARS
   */
  split_votes_three_years: number
  /**
   * Percentage of split votes FOR
   */
  split_votes_percentage_for: number
  /**
   * Percentage of split votes AGAINST
   */
  split_votes_percentage_against: number
  /**
   * Percentage of split votes ABSTAIN
   */
  split_votes_percentage_abstain: number
  /**
   * Percentage of split votes WITHHOLD
   */
  split_votes_percentage_withhold: number
  /**
   * Percentage of split votes NO VOTE
   */
  split_votes_percentage_no_vote: number
  /**
   * Percentage of split votes ONE YEAR
   */
  split_votes_percentage_one_year: number
  /**
   * Percentage of split votes TWO YEARS
   */
  split_votes_percentage_two_years: number
  /**
   * Percentage of split votes THREE YEARS
   */
  split_votes_percentage_three_years: number
  /**
   * Reference to the SVI Proposal being overwritten
   */
  split_vote_instruction_proposal_id: string
  /**
   * Reportable reason for overwriting the SVI Proposal
   */
  reportable_reason: ReportableReasonEnum
}

export type UnassociatedInstrumentsResponseWritable = {
  instruments: Array<InstrumentWritable>
}

export type VoterWritable = {
  /**
   * Free-text label representing the voter in reporting and back office.
   */
  label: string
}

/**
 * Serializer for voter response without holdings.
 */
export type VoterResponseWritable = {
  /**
   * Mediants unique identifier for the voter
   */
  mediant_id: string
  /**
   * Broker associated with the voter
   */
  broker_id: string
  /**
   * Type of voter
   *
   * * `retail` - Retail
   * * `institutional` - Institutional
   */
  type: VoterTypeEnum
  /**
   * Authorization token for the voter
   */
  token: string
}

/**
 * Serializer for voter response with holdings.
 */
export type VoterWithHoldingsResponseWritable = {
  /**
   * Mediants unique identifier for the voter
   */
  mediant_id: string
  /**
   * Broker associated with the voter
   */
  broker_id: string
  /**
   * Type of voter
   *
   * * `retail` - Retail
   * * `institutional` - Institutional
   */
  type: VoterTypeEnum
  /**
   * Authorization token for the voter
   */
  token: string
}

/**
 * Read serializer for a VotingPolicy.
 *
 * `current_policy_document` is the latest VotingPolicyDocument for the policy by
 * issue_time descending, or null if the policy has no documents. The signed_url on
 * the document is generated at request time and is valid for 24 hours.
 */
export type VotingPolicyWritable = {
  /**
   * The voting policy title.
   */
  title: string
  /**
   * Optional abbreviated title for the voting policy.
   */
  title_abbreviation: string | null
  /**
   * Title of the policy provider.
   */
  policy_provider: string
  /**
   * The description of the voting policy.
   */
  formatted_description: string
  /**
   * Optional external identifier used to link to upstream policy systems.
   */
  external_id: string | null
  /**
   * Time the voting policy was created.
   */
  create_time: Date
  /**
   * Time the voting policy was last updated.
   */
  update_time: Date
  /**
   * Optional Cloudinary URL for the voting policy image.
   */
  image_url: string | null
}

/**
 * Serializer for VotingPolicyDocument.
 * The signed_url is generated at request time from the stored document_key; it is
 * valid for 24 hours and is not persisted.
 */
export type VotingPolicyDocumentWritable = {
  /**
   * Timestamp when the document record was created.
   */
  create_time: Date
  /**
   * Timestamp when the document record was last updated.
   */
  update_time: Date
  /**
   * The document's official publication time.
   */
  issue_time: Date
  /**
   * The document title.
   */
  title: string
}

/**
 * Read serializer for a VotingRecommendationVersion.
 *
 * The resource name uses the version ID:
 * votingPolicies/{voting_policy_id}/votingRecommendations/{version_id}
 */
export type VotingRecommendationWritable = {
  /**
   * The proposal this recommendation applies to, in the form organizations/{uuid}/generalMeetings/{uuid}/proposals/{uuid}.
   */
  proposal_name: string
  /**
   * The voting instruction: for, against, abstain, withhold, no_action, one_year, two_years, or three_years.
   */
  voting_instruction: string
  /**
   * Optional rationale supporting the voting instruction. Maximum 5000 characters.
   */
  rationale: string | null
  /**
   * Optional proposal text provided by the recommendation provider. Maximum 5000 characters.
   */
  proposal_text: string | null
  /**
   * Optional proposal label provided by the recommendation provider. Maximum 20 characters.
   */
  proposal_label: string | null
  /**
   * Optional sequence number for the proposal provided by the recommendation provider.
   */
  proposal_sequence_number: number | null
  /**
   * The provider recommendation that led to the creation of this voting recommendation, if any.
   */
  provider_voting_recommendation_id: string | null
  /**
   * Time this recommendation version was created.
   */
  create_time: Date
  /**
   * Time this recommendation version was last updated.
   */
  update_time: Date
}

export type ApiSchemaRetrieveData = {
  body?: never
  path?: never
  query?: {
    format?: 'json' | 'yaml'
    lang?:
      | 'af'
      | 'ar'
      | 'ar-dz'
      | 'ast'
      | 'az'
      | 'be'
      | 'bg'
      | 'bn'
      | 'br'
      | 'bs'
      | 'ca'
      | 'ckb'
      | 'cs'
      | 'cy'
      | 'da'
      | 'de'
      | 'dsb'
      | 'el'
      | 'en'
      | 'en-au'
      | 'en-gb'
      | 'eo'
      | 'es'
      | 'es-ar'
      | 'es-co'
      | 'es-mx'
      | 'es-ni'
      | 'es-ve'
      | 'et'
      | 'eu'
      | 'fa'
      | 'fi'
      | 'fr'
      | 'fy'
      | 'ga'
      | 'gd'
      | 'gl'
      | 'he'
      | 'hi'
      | 'hr'
      | 'hsb'
      | 'hu'
      | 'hy'
      | 'ia'
      | 'id'
      | 'ig'
      | 'io'
      | 'is'
      | 'it'
      | 'ja'
      | 'ka'
      | 'kab'
      | 'kk'
      | 'km'
      | 'kn'
      | 'ko'
      | 'ky'
      | 'lb'
      | 'lt'
      | 'lv'
      | 'mk'
      | 'ml'
      | 'mn'
      | 'mr'
      | 'ms'
      | 'my'
      | 'nb'
      | 'ne'
      | 'nl'
      | 'nn'
      | 'os'
      | 'pa'
      | 'pl'
      | 'pt'
      | 'pt-br'
      | 'ro'
      | 'ru'
      | 'sk'
      | 'sl'
      | 'sq'
      | 'sr'
      | 'sr-latn'
      | 'sv'
      | 'sw'
      | 'ta'
      | 'te'
      | 'tg'
      | 'th'
      | 'tk'
      | 'tr'
      | 'tt'
      | 'udm'
      | 'ug'
      | 'uk'
      | 'ur'
      | 'uz'
      | 'vi'
      | 'zh-hans'
      | 'zh-hant'
  }
  url: '/api/schema/'
}

export type ApiSchemaRetrieveResponses = {
  200: {
    [key: string]: unknown
  }
}

export type ApiSchemaRetrieveResponse = ApiSchemaRetrieveResponses[keyof ApiSchemaRetrieveResponses]

export type BackgroundTasksTasksRetrieveData = {
  body?: never
  path: {
    task_id: number
  }
  query?: never
  url: '/background-tasks/tasks/{task_id}/'
}

export type BackgroundTasksTasksRetrieveErrors = {
  /**
   * No response body
   */
  404: unknown
}

export type BackgroundTasksTasksRetrieveResponses = {
  200: TaskStatus
}

export type BackgroundTasksTasksRetrieveResponse =
  BackgroundTasksTasksRetrieveResponses[keyof BackgroundTasksTasksRetrieveResponses]

export type DirectoutreachBetanxtVoterPolicySnapshotExportCreateData = {
  body?: never
  path?: never
  query: {
    /**
     * ISO 8601 datetime with timezone for which to export holdings. Must include timezone (e.g., '2024-01-15T10:30:00Z' or '2024-01-15T10:30:00+00:00'). When multiple holdings exist for the same date, selects the most recent by create_time.
     */
    valid_time: string
  }
  url: '/directoutreach/betanxt/voter-policy-snapshot:export/'
}

export type DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponses = {
  200: ExportResult
}

export type DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponse =
  DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponses[keyof DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponses]

export type DirectoutreachPolicyCreateData = {
  body: PolicyRequest
  path?: never
  query?: never
  url: '/directoutreach/policy/'
}

export type DirectoutreachPolicyCreateResponses = {
  201: Policy
}

export type DirectoutreachPolicyCreateResponse =
  DirectoutreachPolicyCreateResponses[keyof DirectoutreachPolicyCreateResponses]

export type DirectoutreachPolicyAvailableListData = {
  body?: never
  path?: never
  query?: never
  url: '/directoutreach/policy/available/'
}

export type DirectoutreachPolicyAvailableListResponses = {
  200: Array<PolicyResponse>
}

export type DirectoutreachPolicyAvailableListResponse =
  DirectoutreachPolicyAvailableListResponses[keyof DirectoutreachPolicyAvailableListResponses]

export type DirectoutreachPolicyAvailableRetrieveData = {
  body?: never
  path: {
    /**
     * Unique identifier for the policy
     */
    id: string
  }
  query?: never
  url: '/directoutreach/policy/available/{id}/'
}

export type DirectoutreachPolicyAvailableRetrieveResponses = {
  200: PolicyResponse
}

export type DirectoutreachPolicyAvailableRetrieveResponse =
  DirectoutreachPolicyAvailableRetrieveResponses[keyof DirectoutreachPolicyAvailableRetrieveResponses]

export type DirectoutreachVotersRetrieveData = {
  body?: never
  path: {
    /**
     * Unique identifier for a voter
     */
    id: string
  }
  query?: never
  url: '/directoutreach/voters/{id}/'
}

export type DirectoutreachVotersRetrieveErrors = {
  /**
   * No response body
   */
  404: unknown
}

export type DirectoutreachVotersRetrieveResponses = {
  200: VoterDetailsResponse
}

export type DirectoutreachVotersRetrieveResponse =
  DirectoutreachVotersRetrieveResponses[keyof DirectoutreachVotersRetrieveResponses]

export type DirectoutreachVotersHoldingsRetrieveData = {
  body?: never
  path: {
    /**
     * Unique identifier for a voter
     */
    id: string
  }
  query?: never
  url: '/directoutreach/voters/{id}/holdings/'
}

export type DirectoutreachVotersHoldingsRetrieveErrors = {
  /**
   * No response body
   */
  404: unknown
}

export type DirectoutreachVotersHoldingsRetrieveResponses = {
  200: HoldingResponse
}

export type DirectoutreachVotersHoldingsRetrieveResponse =
  DirectoutreachVotersHoldingsRetrieveResponses[keyof DirectoutreachVotersHoldingsRetrieveResponses]

export type DirectoutreachVotersSelectedPolicyRetrieveData = {
  body?: never
  path: {
    /**
     * Unique identifier for a voter
     */
    id: string
  }
  query?: never
  url: '/directoutreach/voters/{id}/selected-policy/'
}

export type DirectoutreachVotersSelectedPolicyRetrieveErrors = {
  /**
   * No response body
   */
  404: unknown
}

export type DirectoutreachVotersSelectedPolicyRetrieveResponses = {
  200: SelectedPolicyResponse
}

export type DirectoutreachVotersSelectedPolicyRetrieveResponse =
  DirectoutreachVotersSelectedPolicyRetrieveResponses[keyof DirectoutreachVotersSelectedPolicyRetrieveResponses]

export type DirectoutreachVotersSelectedPolicyCreateData = {
  body: SelectedPolicyRequestRequest
  path: {
    /**
     * Unique identifier for a voter
     */
    id: string
  }
  query?: never
  url: '/directoutreach/voters/{id}/selected-policy/'
}

export type DirectoutreachVotersSelectedPolicyCreateErrors = {
  /**
   * No response body
   */
  400: unknown
  /**
   * No response body
   */
  404: unknown
}

export type DirectoutreachVotersSelectedPolicyCreateResponses = {
  201: SelectedPolicyResponse
}

export type DirectoutreachVotersSelectedPolicyCreateResponse =
  DirectoutreachVotersSelectedPolicyCreateResponses[keyof DirectoutreachVotersSelectedPolicyCreateResponses]

export type DirectoutreachVotersBatchCreateCreateData = {
  body: BatchVoterWithHoldingsInputRequest
  path?: never
  query?: never
  url: '/directoutreach/voters:batch-create/'
}

export type DirectoutreachVotersBatchCreateCreateErrors = {
  /**
   * Validation error - no voters created
   */
  400: unknown
  /**
   * Server error - no voters created
   */
  500: unknown
}

export type DirectoutreachVotersBatchCreateCreateResponses = {
  200: BatchVoterWithHoldingsResponse
  201: BatchVoterWithHoldingsResponse
}

export type DirectoutreachVotersBatchCreateCreateResponse =
  DirectoutreachVotersBatchCreateCreateResponses[keyof DirectoutreachVotersBatchCreateCreateResponses]

export type DirectoutreachVotersCreateCreateData = {
  body: VoterWithHoldingsInputRequest
  path?: never
  query?: never
  url: '/directoutreach/voters:create/'
}

export type DirectoutreachVotersCreateCreateResponses = {
  200: VoterWithHoldingsResponse
  201: VoterWithHoldingsResponse
}

export type DirectoutreachVotersCreateCreateResponse =
  DirectoutreachVotersCreateCreateResponses[keyof DirectoutreachVotersCreateCreateResponses]

export type DirectvotingVotersListData = {
  body?: never
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/directvoting/voters/'
}

export type DirectvotingVotersListResponses = {
  200: PaginatedVoterList
}

export type DirectvotingVotersListResponse = DirectvotingVotersListResponses[keyof DirectvotingVotersListResponses]

export type DirectvotingVotersCreateData = {
  body: VoterRequest
  path?: never
  query?: never
  url: '/directvoting/voters/'
}

export type DirectvotingVotersCreateResponses = {
  201: Voter
}

export type DirectvotingVotersCreateResponse =
  DirectvotingVotersCreateResponses[keyof DirectvotingVotersCreateResponses]

export type DirectvotingVotersDestroyData = {
  body?: never
  path: {
    /**
     * Unique identifier for the voter.
     */
    id: string
  }
  query?: never
  url: '/directvoting/voters/{id}/'
}

export type DirectvotingVotersDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type DirectvotingVotersDestroyResponse =
  DirectvotingVotersDestroyResponses[keyof DirectvotingVotersDestroyResponses]

export type DirectvotingVotersRetrieveData = {
  body?: never
  path: {
    /**
     * Unique identifier for the voter.
     */
    id: string
  }
  query?: never
  url: '/directvoting/voters/{id}/'
}

export type DirectvotingVotersRetrieveResponses = {
  200: Voter
}

export type DirectvotingVotersRetrieveResponse =
  DirectvotingVotersRetrieveResponses[keyof DirectvotingVotersRetrieveResponses]

export type DirectvotingVotersPartialUpdateData = {
  body?: PatchedVoterRequest
  path: {
    /**
     * Unique identifier for the voter.
     */
    id: string
  }
  query?: never
  url: '/directvoting/voters/{id}/'
}

export type DirectvotingVotersPartialUpdateResponses = {
  200: Voter
}

export type DirectvotingVotersPartialUpdateResponse =
  DirectvotingVotersPartialUpdateResponses[keyof DirectvotingVotersPartialUpdateResponses]

export type DirectvotingVotersUpdateData = {
  body: VoterRequest
  path: {
    /**
     * Unique identifier for the voter.
     */
    id: string
  }
  query?: never
  url: '/directvoting/voters/{id}/'
}

export type DirectvotingVotersUpdateResponses = {
  200: Voter
}

export type DirectvotingVotersUpdateResponse =
  DirectvotingVotersUpdateResponses[keyof DirectvotingVotersUpdateResponses]

export type FundManagerFundManagersCreateData = {
  body: FundManagerWriteRequest
  path?: never
  query?: never
  url: '/fund-manager/fund-managers/'
}

export type FundManagerFundManagersCreateResponses = {
  201: FundManager
}

export type FundManagerFundManagersCreateResponse =
  FundManagerFundManagersCreateResponses[keyof FundManagerFundManagersCreateResponses]

export type FundManagerFundManagersRetrieveData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/fund-manager/fund-managers/{id}/'
}

export type FundManagerFundManagersRetrieveResponses = {
  200: FundManager
}

export type FundManagerFundManagersRetrieveResponse =
  FundManagerFundManagersRetrieveResponses[keyof FundManagerFundManagersRetrieveResponses]

export type FundManagerFundManagersUpdateData = {
  body: FundManagerWriteRequest
  path: {
    id: string
  }
  query?: never
  url: '/fund-manager/fund-managers/{id}/'
}

export type FundManagerFundManagersUpdateResponses = {
  200: FundManager
}

export type FundManagerFundManagersUpdateResponse =
  FundManagerFundManagersUpdateResponses[keyof FundManagerFundManagersUpdateResponses]

export type FundManagerFundManagersSearchCreateData = {
  body?: FundManagerSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/fund-manager/fund-managers/search/'
}

export type FundManagerFundManagersSearchCreateResponses = {
  200: PaginatedFundManagerList
}

export type FundManagerFundManagersSearchCreateResponse =
  FundManagerFundManagersSearchCreateResponses[keyof FundManagerFundManagersSearchCreateResponses]

export type FundManagerFundVariantsCreateData = {
  body: FundVariantWriteRequest
  path?: never
  query?: never
  url: '/fund-manager/fund-variants/'
}

export type FundManagerFundVariantsCreateResponses = {
  201: FundVariant
}

export type FundManagerFundVariantsCreateResponse =
  FundManagerFundVariantsCreateResponses[keyof FundManagerFundVariantsCreateResponses]

export type FundManagerFundVariantsDestroyData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/fund-manager/fund-variants/{id}/'
}

export type FundManagerFundVariantsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type FundManagerFundVariantsDestroyResponse =
  FundManagerFundVariantsDestroyResponses[keyof FundManagerFundVariantsDestroyResponses]

export type FundManagerFundVariantsRetrieveData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/fund-manager/fund-variants/{id}/'
}

export type FundManagerFundVariantsRetrieveResponses = {
  200: FundVariant
}

export type FundManagerFundVariantsRetrieveResponse =
  FundManagerFundVariantsRetrieveResponses[keyof FundManagerFundVariantsRetrieveResponses]

export type FundManagerFundVariantsUpdateData = {
  body: FundVariantWriteRequest
  path: {
    id: string
  }
  query?: never
  url: '/fund-manager/fund-variants/{id}/'
}

export type FundManagerFundVariantsUpdateResponses = {
  200: FundVariant
}

export type FundManagerFundVariantsUpdateResponse =
  FundManagerFundVariantsUpdateResponses[keyof FundManagerFundVariantsUpdateResponses]

export type FundManagerFundVariantsSearchCreateData = {
  body?: FundVariantSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/fund-manager/fund-variants/search/'
}

export type FundManagerFundVariantsSearchCreateResponses = {
  200: PaginatedFundVariantList
}

export type FundManagerFundVariantsSearchCreateResponse =
  FundManagerFundVariantsSearchCreateResponses[keyof FundManagerFundVariantsSearchCreateResponses]

export type FundManagerFundsCreateData = {
  body: FundWriteRequest
  path?: never
  query?: never
  url: '/fund-manager/funds/'
}

export type FundManagerFundsCreateResponses = {
  201: Fund
}

export type FundManagerFundsCreateResponse = FundManagerFundsCreateResponses[keyof FundManagerFundsCreateResponses]

export type FundManagerFundsQuantificationSnapshotsCreateData = {
  body: FundQuantificationSnapshotWriteRequest
  path: {
    fund_id: string
  }
  query?: never
  url: '/fund-manager/funds/{fund_id}/quantification-snapshots/'
}

export type FundManagerFundsQuantificationSnapshotsCreateResponses = {
  201: FundQuantificationSnapshot
}

export type FundManagerFundsQuantificationSnapshotsCreateResponse =
  FundManagerFundsQuantificationSnapshotsCreateResponses[keyof FundManagerFundsQuantificationSnapshotsCreateResponses]

export type FundManagerFundsRetrieveData = {
  body?: never
  path: {
    id: string
  }
  query?: {
    /**
     * The product that owns the fund.
     */
    product?: ProductEnum
  }
  url: '/fund-manager/funds/{id}/'
}

export type FundManagerFundsRetrieveResponses = {
  200: Fund
}

export type FundManagerFundsRetrieveResponse =
  FundManagerFundsRetrieveResponses[keyof FundManagerFundsRetrieveResponses]

export type FundManagerFundsUpdateData = {
  body: FundWriteRequest
  path: {
    id: string
  }
  query?: never
  url: '/fund-manager/funds/{id}/'
}

export type FundManagerFundsUpdateResponses = {
  200: Fund
}

export type FundManagerFundsUpdateResponse = FundManagerFundsUpdateResponses[keyof FundManagerFundsUpdateResponses]

export type FundManagerFundsSearchCreateData = {
  body: FundSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/fund-manager/funds/search/'
}

export type FundManagerFundsSearchCreateResponses = {
  200: PaginatedFundList
}

export type FundManagerFundsSearchCreateResponse =
  FundManagerFundsSearchCreateResponses[keyof FundManagerFundsSearchCreateResponses]

export type FundManagerProvidersListData = {
  body?: never
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    names?: Array<string>
    /**
     * Number of results to return per page.
     */
    page_size?: number
    /**
     * Case-insensitive substring match on title.
     */
    search_title?: string
    titles?: Array<string>
  }
  url: '/fund-manager/providers/'
}

export type FundManagerProvidersListResponses = {
  200: PaginatedProviderList
}

export type FundManagerProvidersListResponse =
  FundManagerProvidersListResponses[keyof FundManagerProvidersListResponses]

export type FundManagerProvidersCreateData = {
  body: ProviderWriteRequest
  path?: never
  query?: never
  url: '/fund-manager/providers/'
}

export type FundManagerProvidersCreateResponses = {
  201: Provider
}

export type FundManagerProvidersCreateResponse =
  FundManagerProvidersCreateResponses[keyof FundManagerProvidersCreateResponses]

export type FundManagerProvidersRetrieveData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/fund-manager/providers/{id}/'
}

export type FundManagerProvidersRetrieveResponses = {
  200: Provider
}

export type FundManagerProvidersRetrieveResponse =
  FundManagerProvidersRetrieveResponses[keyof FundManagerProvidersRetrieveResponses]

export type FundManagerProvidersUpdateData = {
  body: ProviderWriteRequest
  path: {
    id: string
  }
  query?: never
  url: '/fund-manager/providers/{id}/'
}

export type FundManagerProvidersUpdateResponses = {
  200: Provider
}

export type FundManagerProvidersUpdateResponse =
  FundManagerProvidersUpdateResponses[keyof FundManagerProvidersUpdateResponses]

export type FundManagerQuantificationSnapshotsSearchCreateData = {
  body: FundQuantificationSnapshotSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/fund-manager/quantification-snapshots/search/'
}

export type FundManagerQuantificationSnapshotsSearchCreateResponses = {
  200: PaginatedFundQuantificationSnapshotList
}

export type FundManagerQuantificationSnapshotsSearchCreateResponse =
  FundManagerQuantificationSnapshotsSearchCreateResponses[keyof FundManagerQuantificationSnapshotsSearchCreateResponses]

export type InstitutionalMeetingsearchListData = {
  body?: never
  path?: never
  query: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Search for organizations by display title (case insensitive)
     */
    organization_title_search?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
    /**
     * Scheme name in format 'habitats/{habitat_id}/schemes/{scheme_id}'
     */
    scheme_name: string
    /**
     * Sort order by voting deadline (action_deadline). 'asc' shows meetings with soonest deadlines first. Default is 'asc'.
     */
    sort_order?: 'asc' | 'desc'
    /**
     * Filter meetings by status.
     * Note:
     * 'OPEN' status filters for Meetings that have an 'Action Deadline' of 00:01:00 today.
     * 'CLOSED' status filters for Meetings that have an 'Action Deadline'
     * before 'now' and a 'Meeting Date' after 'now'.
     * 'ALL' status filters for Meetings that have a 'Meeting Date' after 'now'.
     */
    status?: 'all' | 'closed' | 'open'
    /**
     * Comma-separated list of theme codes to filter by
     */
    theme_codes?: string
  }
  url: '/institutional/meetingsearch'
}

export type InstitutionalMeetingsearchListResponses = {
  200: PaginatedMeetingList
}

export type InstitutionalMeetingsearchListResponse =
  InstitutionalMeetingsearchListResponses[keyof InstitutionalMeetingsearchListResponses]

export type ProxyIntermediaryProposalCategoriesAssignCreateData = {
  body: AssignProposalCategoryRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/proposal-categories/assign/'
}

export type ProxyIntermediaryProposalCategoriesAssignCreateResponses = {
  200: AssignProposalCategoryResponse
}

export type ProxyIntermediaryProposalCategoriesAssignCreateResponse =
  ProxyIntermediaryProposalCategoriesAssignCreateResponses[keyof ProxyIntermediaryProposalCategoriesAssignCreateResponses]

export type ProxyIntermediaryProposalCategoriesListCreateData = {
  body: ListProposalCategoriesRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/proposal-categories/list/'
}

export type ProxyIntermediaryProposalCategoriesListCreateResponses = {
  200: ListProposalCategoriesResponse
}

export type ProxyIntermediaryProposalCategoriesListCreateResponse =
  ProxyIntermediaryProposalCategoriesListCreateResponses[keyof ProxyIntermediaryProposalCategoriesListCreateResponses]

export type ProxyIntermediaryProposalLabelsAssignCreateData = {
  body: AssignProposalLabelRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/proposal-labels/assign/'
}

export type ProxyIntermediaryProposalLabelsAssignCreateResponses = {
  200: AssignProposalLabelResponse
}

export type ProxyIntermediaryProposalLabelsAssignCreateResponse =
  ProxyIntermediaryProposalLabelsAssignCreateResponses[keyof ProxyIntermediaryProposalLabelsAssignCreateResponses]

export type ProxyIntermediaryProposalLabelsFetchCreateData = {
  body: FetchProposalLabelsRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/proposal-labels/fetch/'
}

export type ProxyIntermediaryProposalLabelsFetchCreateResponses = {
  200: FetchProposalLabelsResponse
}

export type ProxyIntermediaryProposalLabelsFetchCreateResponse =
  ProxyIntermediaryProposalLabelsFetchCreateResponses[keyof ProxyIntermediaryProposalLabelsFetchCreateResponses]

export type ProxyIntermediaryProposalsSearchCreateData = {
  body?: SearchProposalRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/proxy-intermediary/proposals/search/'
}

export type ProxyIntermediaryProposalsSearchCreateResponses = {
  200: PaginatedProxyIntermediaryProposalList
}

export type ProxyIntermediaryProposalsSearchCreateResponse =
  ProxyIntermediaryProposalsSearchCreateResponses[keyof ProxyIntermediaryProposalsSearchCreateResponses]

export type ProxyIntermediaryProxyIntermediariesSearchCreateData = {
  body?: ProxyIntermediarySearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/proxy-intermediary/proxy-intermediaries/search/'
}

export type ProxyIntermediaryProxyIntermediariesSearchCreateResponses = {
  200: PaginatedProxyIntermediaryList
}

export type ProxyIntermediaryProxyIntermediariesSearchCreateResponse =
  ProxyIntermediaryProxyIntermediariesSearchCreateResponses[keyof ProxyIntermediaryProxyIntermediariesSearchCreateResponses]

export type ProxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateData = {
  body?: ProxyIntermediaryMeetingAuditEventSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/proxy-intermediary/proxy-intermediary-meetings/audit-events/search/'
}

export type ProxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateResponses = {
  200: PaginatedProxyIntermediaryMeetingAuditEventList
}

export type ProxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateResponse =
  ProxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateResponses[keyof ProxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateResponses]

export type ProxyIntermediaryProxyIntermediaryMeetingsCancelCreateData = {
  body: ProxyIntermediaryMeetingBatchCancelRequestRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/proxy-intermediary-meetings/cancel/'
}

export type ProxyIntermediaryProxyIntermediaryMeetingsCancelCreateResponses = {
  200: ProxyIntermediaryMeetingBatchCancelResponse
}

export type ProxyIntermediaryProxyIntermediaryMeetingsCancelCreateResponse =
  ProxyIntermediaryProxyIntermediaryMeetingsCancelCreateResponses[keyof ProxyIntermediaryProxyIntermediaryMeetingsCancelCreateResponses]

export type ProxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateData = {
  body: ProxyIntermediaryMeetingLinkRequestRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/proxy-intermediary-meetings/link-transparency-general-meeting/'
}

export type ProxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateResponses = {
  200: ProxyIntermediaryMeetingResponse
}

export type ProxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateResponse =
  ProxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateResponses[keyof ProxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateResponses]

export type ProxyIntermediaryProxyIntermediaryMeetingsSearchCreateData = {
  body?: ProxyIntermediaryMeetingSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/proxy-intermediary/proxy-intermediary-meetings/search/'
}

export type ProxyIntermediaryProxyIntermediaryMeetingsSearchCreateResponses = {
  200: PaginatedProxyIntermediaryMeetingList
}

export type ProxyIntermediaryProxyIntermediaryMeetingsSearchCreateResponse =
  ProxyIntermediaryProxyIntermediaryMeetingsSearchCreateResponses[keyof ProxyIntermediaryProxyIntermediaryMeetingsSearchCreateResponses]

export type ProxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateData = {
  body: ProxyIntermediaryMeetingUnlinkRequestRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/proxy-intermediary-meetings/unlink-transparency-general-meeting/'
}

export type ProxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateResponses = {
  200: ProxyIntermediaryMeetingResponse
}

export type ProxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateResponse =
  ProxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateResponses[keyof ProxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateResponses]

export type ProxyIntermediaryProxyIntermediaryMeetingsUpsertCreateData = {
  body: ProxyIntermediaryMeetingUpsertRequestRequest
  path?: never
  query?: never
  url: '/proxy-intermediary/proxy-intermediary-meetings/upsert/'
}

export type ProxyIntermediaryProxyIntermediaryMeetingsUpsertCreateResponses = {
  200: ProxyIntermediaryMeetingUpsertResponse
}

export type ProxyIntermediaryProxyIntermediaryMeetingsUpsertCreateResponse =
  ProxyIntermediaryProxyIntermediaryMeetingsUpsertCreateResponses[keyof ProxyIntermediaryProxyIntermediaryMeetingsUpsertCreateResponses]

export type ProxyvotingEntitlementsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Include invalidated entitlements (default: false, only returns active entitlements).
     */
    include_invalid?: boolean
    /**
     * Filter by investor account UUID - exact match.
     */
    investor_account_id?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
    /**
     * Filter by proxy intermediary ballot UUID - exact match.
     */
    proxy_intermediary_ballot_id?: string
  }
  url: '/proxyvoting/entitlements'
}

export type ProxyvotingEntitlementsListResponses = {
  200: PaginatedBallotEntitlementList
}

export type ProxyvotingEntitlementsListResponse =
  ProxyvotingEntitlementsListResponses[keyof ProxyvotingEntitlementsListResponses]

export type ProxyvotingEntitlementsBreakdownCreateData = {
  body: ComputeBreakdownRequestRequest
  path?: never
  query?: never
  url: '/proxyvoting/entitlements/breakdown'
}

export type ProxyvotingEntitlementsBreakdownCreateResponses = {
  200: BreakdownResponse
}

export type ProxyvotingEntitlementsBreakdownCreateResponse =
  ProxyvotingEntitlementsBreakdownCreateResponses[keyof ProxyvotingEntitlementsBreakdownCreateResponses]

export type ProxyvotingEntitlementsComputeCreateData = {
  body: TriggerComputeEntitlementsRequest
  path?: never
  query?: never
  url: '/proxyvoting/entitlements:compute'
}

export type ProxyvotingEntitlementsComputeCreateResponses = {
  202: TaskTriggered
}

export type ProxyvotingEntitlementsComputeCreateResponse =
  ProxyvotingEntitlementsComputeCreateResponses[keyof ProxyvotingEntitlementsComputeCreateResponses]

export type ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateData = {
  body: FundManagerSupportedIssuedInstrumentsQueryRequest
  path?: never
  query?: never
  url: '/proxyvoting/fund-manager/compositions/sii/from-composition-difference'
}

export type ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateResponses = {
  /**
   * No response body
   */
  200: unknown
}

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateData = {
  body: FundManagerPolicySiiBatchCreateRequest
  path?: never
  query?: never
  url: '/proxyvoting/fund-manager/policy-supported-issued-instruments'
}

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponses = {
  200: FundManagerPolicySiiResponse
}

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponse =
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponses[keyof ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponses]

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateData = {
  body: FundManagerPolicySiiBatchDeleteRequest
  path?: never
  query?: never
  url: '/proxyvoting/fund-manager/policy-supported-issued-instruments/batch-delete'
}

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses = {
  /**
   * No response body
   */
  204: void
}

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponse =
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses[keyof ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses]

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateData = {
  body?: FundManagerPolicySiiSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/proxyvoting/fund-manager/policy-supported-issued-instruments/search'
}

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponses = {
  200: PaginatedFundManagerPolicySiiList
}

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponse =
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponses[keyof ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponses]

export type ProxyvotingFundManagerSupportedPoliciesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Return the state of policies as they were at this datetime (ISO 8601). Returns historical records.
     */
    as_of?: Date
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Filter by FundManager UUID - exact match.
     */
    fund_manager_id?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
    voting_policy_id?: Array<string>
  }
  url: '/proxyvoting/fund-manager/supported-policies'
}

export type ProxyvotingFundManagerSupportedPoliciesListResponses = {
  200: PaginatedFundManagerSupportedVotingPolicyHistoricalList
}

export type ProxyvotingFundManagerSupportedPoliciesListResponse =
  ProxyvotingFundManagerSupportedPoliciesListResponses[keyof ProxyvotingFundManagerSupportedPoliciesListResponses]

export type ProxyvotingFundManagerSupportedPoliciesCreateData = {
  body: FundManagerSupportedVotingPolicyBatchUpsertRequest
  path?: never
  query?: never
  url: '/proxyvoting/fund-manager/supported-policies'
}

export type ProxyvotingFundManagerSupportedPoliciesCreateResponses = {
  200: FundManagerSupportedVotingPolicyBatchUpsertResponse
}

export type ProxyvotingFundManagerSupportedPoliciesCreateResponse =
  ProxyvotingFundManagerSupportedPoliciesCreateResponses[keyof ProxyvotingFundManagerSupportedPoliciesCreateResponses]

export type ProxyvotingFundManagerSupportedPoliciesDestroyData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/proxyvoting/fund-manager/supported-policies/{id}'
}

export type ProxyvotingFundManagerSupportedPoliciesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type ProxyvotingFundManagerSupportedPoliciesDestroyResponse =
  ProxyvotingFundManagerSupportedPoliciesDestroyResponses[keyof ProxyvotingFundManagerSupportedPoliciesDestroyResponses]

export type ProxyvotingInvestorCompositionsDifferenceListData = {
  body?: never
  path?: never
  query: {
    /**
     * latest composition date time
     */
    end_time: string
    /**
     * Investors to fetch compositions for
     */
    investor_names: Array<string>
    /**
     * original composition date time
     */
    start_time: string
  }
  url: '/proxyvoting/investor/compositions/difference'
}

export type ProxyvotingInvestorCompositionsDifferenceListResponses = {
  200: Array<CompositionDifferenceResponse>
}

export type ProxyvotingInvestorCompositionsDifferenceListResponse =
  ProxyvotingInvestorCompositionsDifferenceListResponses[keyof ProxyvotingInvestorCompositionsDifferenceListResponses]

export type ProxyvotingInvestorCompositionsRenderCreateData = {
  body: RenderCompositionDifferenceRequest
  path?: never
  query?: never
  url: '/proxyvoting/investor/compositions/render'
}

export type ProxyvotingInvestorCompositionsRenderCreateResponses = {
  200: Blob | File
}

export type ProxyvotingInvestorCompositionsRenderCreateResponse =
  ProxyvotingInvestorCompositionsRenderCreateResponses[keyof ProxyvotingInvestorCompositionsRenderCreateResponses]

export type ProxyvotingInvestorCompositionsRulesEngineRetrieveData = {
  body?: never
  path?: never
  query: {
    /**
     * Investor resource name in format habitats/{habitat_id}/investors/{investor_id}
     */
    investor_name: string
  }
  url: '/proxyvoting/investor/compositions/rules-engine'
}

export type ProxyvotingInvestorCompositionsRulesEngineRetrieveResponses = {
  200: InvestorRulesEngine
}

export type ProxyvotingInvestorCompositionsRulesEngineRetrieveResponse =
  ProxyvotingInvestorCompositionsRulesEngineRetrieveResponses[keyof ProxyvotingInvestorCompositionsRulesEngineRetrieveResponses]

export type ProxyvotingInvestorCompositionsRulesEngineUpdateData = {
  body: InvestorRulesEngineRequest
  path?: never
  query?: never
  url: '/proxyvoting/investor/compositions/rules-engine'
}

export type ProxyvotingInvestorCompositionsRulesEngineUpdateResponses = {
  200: InvestorRulesEngine
  201: InvestorRulesEngine
}

export type ProxyvotingInvestorCompositionsRulesEngineUpdateResponse =
  ProxyvotingInvestorCompositionsRulesEngineUpdateResponses[keyof ProxyvotingInvestorCompositionsRulesEngineUpdateResponses]

export type ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateData = {
  body: SupportedIssuedInstrumentsQueryRequest
  path?: never
  query?: never
  url: '/proxyvoting/investor/compositions/sii/from-composition-difference'
}

export type ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateResponses = {
  /**
   * No response body
   */
  200: unknown
}

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateData = {
  body: InvestorPolicySiiBatchCreateRequest
  path?: never
  query?: never
  url: '/proxyvoting/investor/policy-supported-issued-instruments'
}

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponses = {
  200: InvestorPolicySiiResponse
}

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponse =
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponses[keyof ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponses]

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateData = {
  body: InvestorPolicySiiBatchDeleteRequest
  path?: never
  query?: never
  url: '/proxyvoting/investor/policy-supported-issued-instruments/batch-delete'
}

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses = {
  /**
   * No response body
   */
  204: void
}

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponse =
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses[keyof ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses]

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateData = {
  body?: InvestorPolicySiiSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/proxyvoting/investor/policy-supported-issued-instruments/search'
}

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponses = {
  200: PaginatedInvestorPolicySiiList
}

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponse =
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponses[keyof ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponses]

export type ProxyvotingInvestorSupportedIssuedInstrumentsCreateData = {
  body: InvestorSiiBatchCreateRequest
  path?: never
  query?: never
  url: '/proxyvoting/investor/supported-issued-instruments'
}

export type ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponses = {
  200: InvestorSiiResponse
}

export type ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponse =
  ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponses[keyof ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponses]

export type ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateData = {
  body: InvestorSiiBatchDeleteRequest
  path?: never
  query?: never
  url: '/proxyvoting/investor/supported-issued-instruments/batch-delete'
}

export type ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponses = {
  /**
   * No response body
   */
  204: void
}

export type ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponse =
  ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponses[keyof ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponses]

export type ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateData = {
  body?: InvestorSiiSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/proxyvoting/investor/supported-issued-instruments/search'
}

export type ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponses = {
  200: PaginatedInvestorSupportedIssuedInstrumentList
}

export type ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponse =
  ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponses[keyof ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponses]

export type ProxyvotingMeetingBallotSourcesListData = {
  body?: never
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Include invalidated sources (default: false, only returns active sources).
     */
    include_invalid?: boolean
    /**
     * Filter by meeting ballot id.
     */
    meeting_ballot_id?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
    /**
     * Filter by proxy intermediary ballot id.
     */
    proxy_intermediary_ballot_id?: string
  }
  url: '/proxyvoting/meeting-ballot-sources'
}

export type ProxyvotingMeetingBallotSourcesListResponses = {
  200: PaginatedMeetingBallotSourceList
}

export type ProxyvotingMeetingBallotSourcesListResponse =
  ProxyvotingMeetingBallotSourcesListResponses[keyof ProxyvotingMeetingBallotSourcesListResponses]

export type ProxyvotingMeetingBallotsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Filter by general meeting id.
     */
    general_meeting_id?: string
    /**
     * Filter by investor id.
     */
    investor_id?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/proxyvoting/meeting-ballots'
}

export type ProxyvotingMeetingBallotsListResponses = {
  200: PaginatedMeetingBallotList
}

export type ProxyvotingMeetingBallotsListResponse =
  ProxyvotingMeetingBallotsListResponses[keyof ProxyvotingMeetingBallotsListResponses]

export type ProxyvotingMeetingballotsComputeCreateData = {
  body: TriggerProcessMeetingBallotsRequest
  path?: never
  query?: never
  url: '/proxyvoting/meetingballots:compute'
}

export type ProxyvotingMeetingballotsComputeCreateResponses = {
  202: TaskTriggered
}

export type ProxyvotingMeetingballotsComputeCreateResponse =
  ProxyvotingMeetingballotsComputeCreateResponses[keyof ProxyvotingMeetingballotsComputeCreateResponses]

export type ProxyvotingPiballotsFilterListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Filter ballots by workflow checker email - exact string match.
     */
    checker?: string
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Custodian account identifier - exact string match.
     */
    custodian_account_number?: string
    /**
     * External ballot identifier - exact string match.
     */
    external_id?: string
    /**
     * Filter ballots by fund manager title - case-insensitive substring match.
     */
    fund_manager_title?: string
    /**
     * Filter ballots by fund title - case-insensitive substring match.
     */
    fund_title?: string
    /**
     * Filter ballots by whether they have a workflow checker email assigned. True for ballots with checker, False for ballots without checker, omit for all.
     */
    has_checker?: boolean
    /**
     * Filter ballots by whether they have a workflow submitter email assigned. True for ballots with submitter, False for ballots without submitter, omit for all.
     */
    has_submitter?: boolean
    /**
     * Filter ballots by scope. True for in-scope (any policy support field is true), False for out-of-scope (all policy support fields are false), omit for all.
     */
    in_scope?: boolean
    /**
     * ISIN (International Securities Identification Number) - exact match filter. Must be 12-character alphanumeric code.
     */
    isin?: string
    /**
     * Filter ballots by whether they are linked to a general meeting. True for linked, False for unlinked, omit for all.
     */
    linked?: boolean
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * Filter ballots by organization title - case-insensitive substring match.
     */
    organization_title?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
    /**
     * Filter ballots by whether the 'proxy_intermediary_id' and 'proxy_intermediary_meeting_id' match the provided meeting name.
     * Expected format:'proxyIntermediaries/{proxy_intermediary_id}/meetings/{proxy_intermediary_meeting_id}'
     */
    pi_meeting_name?: string
    /**
     * Proxy intermediary(s) managing the meetings. Options: Proxymity, ProxyEdge, ProxyExchange, or omit for all.
     *
     * * `Proxymity` - Proxymity
     * * `ProxyEdge` - ProxyEdge
     * * `ProxyExchange` - ProxyExchange
     */
    proxy_intermediaries?: Array<'ProxyEdge' | 'ProxyExchange' | 'Proxymity'>
    /**
     * Filter ballots by proxy intermediary title - exact string match.
     */
    proxy_intermediary?: string
    /**
     * General search across organization title, ballot external ID, and ISIN - case-insensitive substring match.
     */
    search?: string
    /**
     * Filter ballots by whether split vote checking is required. True for required, False for not required, omit for all.
     */
    split_vote_check_required?: boolean
    /**
     * Filter ballots by workflow status. Multiple values can be selected to match any of the specified statuses.
     *
     * * `invalid` - Invalid
     * * `not_submitted_in_testing` - Not Submitted in Testing
     * * `not_submitted_unvoted` - Not Submitted Unvoted
     * * `not_submitted_no_entitlements` - Not Submitted No Entitlements
     * * `not_submitted_undefined` - Not Submitted Undefined
     * * `needs_attention` - Needs Attention
     * * `ineligible` - Ineligible
     * * `cancelled` - Cancelled
     * * `meeting_needs_refining` - Meeting Needs Refining
     * * `meeting_voting_enabled` - Meeting Voting Enabled
     * * `entitled_to_vote` - Entitled to Vote
     * * `ready_for_split_vote` - Ready for Split Vote
     * * `late_vote_process` - Late Vote Process
     * * `split_vote_awaiting_check` - Split Vote Awaiting Check
     * * `split_vote_submitted` - Split Vote Submitted
     * * `successful` - Successful
     * * `rejected` - Rejected
     * * `overridden` - Overridden
     * * `in_testing` - In Testing
     */
    status?: Array<
      | 'cancelled'
      | 'entitled_to_vote'
      | 'in_testing'
      | 'ineligible'
      | 'invalid'
      | 'late_vote_process'
      | 'meeting_needs_refining'
      | 'meeting_voting_enabled'
      | 'needs_attention'
      | 'not_submitted_in_testing'
      | 'not_submitted_no_entitlements'
      | 'not_submitted_undefined'
      | 'not_submitted_unvoted'
      | 'overridden'
      | 'ready_for_split_vote'
      | 'rejected'
      | 'split_vote_awaiting_check'
      | 'split_vote_submitted'
      | 'successful'
    >
    /**
     * Filter ballots by workflow submitter email - exact string match.
     */
    submitter?: string
    /**
     * Filter ballots with vote deadline after or equal to this UTC datetime.
     */
    vote_deadline_after?: Date
    /**
     * Filter ballots with vote deadline before or equal to this UTC datetime.
     */
    vote_deadline_before?: Date
  }
  url: '/proxyvoting/piballots/filter'
}

export type ProxyvotingPiballotsFilterListResponses = {
  200: PaginatedPiBallotSearchList
}

export type ProxyvotingPiballotsFilterListResponse =
  ProxyvotingPiballotsFilterListResponses[keyof ProxyvotingPiballotsFilterListResponses]

export type ProxyvotingPiballotsInvestorsCanVoteCreateData = {
  body: InvestorsCanVoteRequest
  path?: never
  query?: never
  url: '/proxyvoting/piballots/investors-can-vote'
}

export type ProxyvotingPiballotsInvestorsCanVoteCreateResponses = {
  200: InvestorsCanVoteResponse
}

export type ProxyvotingPiballotsInvestorsCanVoteCreateResponse =
  ProxyvotingPiballotsInvestorsCanVoteCreateResponses[keyof ProxyvotingPiballotsInvestorsCanVoteCreateResponses]

export type ProxyvotingPimeetingsFilterListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Filter meetings by assigned checker user email address - exact match.
     */
    assigned_checker_user_id?: string
    /**
     * Filter meetings by assigned refiner user email address - exact match.
     */
    assigned_refiner_user_id?: string
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Filter meetings with earliest ballot submission deadline is after or equal to this UTC datetime,
     */
    earliest_ballot_submission_deadline_after?: Date
    /**
     * Filter meetings with earliest ballot submission before or equal to this UTC datetime.
     */
    earliest_ballot_submission_deadline_before?: Date
    /**
     * Filter meetings by ballot presence. True for meetings with ballots, False for meetings without ballots, omit for all.
     */
    has_ballots?: boolean
    /**
     * Filter meetings by checker presence. True for meetings with checker, False for meetings without checker, omit for all.
     */
    has_checker?: boolean
    /**
     * Filter meetings by refiner presence. True for meetings with refiner, False for meetings without refiner, omit for all.
     */
    has_refiner?: boolean
    /**
     * Filter meetings by scope. True for in-scope (any policy support field is true), False for out-of-scope (all policy support fields are false), omit for all.
     */
    in_scope?: boolean
    /**
     * Filter meetings by whether they are linked to Tumelo meetings. True for linked, False for unlinked, omit for all.
     */
    linked_to_tumelo_meeting?: boolean
    /**
     * Filter meetings created after or equal to this UTC datetime.
     */
    meeting_create_time_after?: Date
    /**
     * Filter meetings created before or equal to this UTC datetime.
     */
    meeting_create_time_before?: Date
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
    /**
     * Proxy intermediary(s) managing the meetings. Options: Proxymity, ProxyEdge, ProxyExchange, or omit for all.
     *
     * * `Proxymity` - Proxymity
     * * `ProxyEdge` - ProxyEdge
     * * `ProxyExchange` - ProxyExchange
     */
    proxy_intermediaries?: Array<'ProxyEdge' | 'ProxyExchange' | 'Proxymity'>
    /**
     * Proxy intermediary managing the meetings. Options: Proxymity, ProxyEdge, ProxyExchange, or omit for all.
     *
     * * `Proxymity` - Proxymity
     * * `ProxyEdge` - ProxyEdge
     * * `ProxyExchange` - ProxyExchange
     */
    proxy_intermediary?: 'ProxyEdge' | 'ProxyExchange' | 'Proxymity'
    /**
     * General search across meeting external ID, organization title, and security IDs - case-insensitive substring match. Maximum 255 characters.
     */
    search?: string
    /**
     * Filter meetings by workflow status. Multiple values can be selected to match any of the specified statuses.
     *
     * * `invalid` - Invalid
     * * `new` - New
     * * `unlinked` - Unlinked
     * * `unsupported` - Unsupported
     * * `needs_attention` - Needs Attention
     * * `cancelled` - Cancelled
     * * `cancellation_incomplete` - Cancellation Incomplete
     * * `ready_for_refinement` - Ready for Refinement
     * * `refinement_complete` - Refinement Complete
     * * `manual_voting_enabled` - Manual Voting Enabled
     * * `entitled_to_vote` - Entitled to Vote
     * * `ready_for_split_vote` - Ready for Split Vote
     * * `split_vote_submitted` - Split Vote Submitted
     * * `successful` - Successful
     * * `rejected` - Rejected
     * * `overridden` - Overridden
     * * `partial_success` - Partial Success
     */
    status?: Array<
      | 'cancellation_incomplete'
      | 'cancelled'
      | 'entitled_to_vote'
      | 'invalid'
      | 'manual_voting_enabled'
      | 'needs_attention'
      | 'new'
      | 'overridden'
      | 'partial_success'
      | 'ready_for_refinement'
      | 'ready_for_split_vote'
      | 'refinement_complete'
      | 'rejected'
      | 'split_vote_submitted'
      | 'successful'
      | 'unlinked'
      | 'unsupported'
    >
    /**
     * Filter meetings with submission deadline after or equal to this UTC datetime, where the latest valid_to SII date is before this datetime, with an 8 month buffer.
     */
    submission_deadline_after?: Date
    /**
     * Filter meetings with submission deadline before or equal to this UTC datetime.
     */
    submission_deadline_before?: Date
  }
  url: '/proxyvoting/pimeetings/filter'
}

export type ProxyvotingPimeetingsFilterListResponses = {
  200: PaginatedPiMeetingSearchList
}

export type ProxyvotingPimeetingsFilterListResponse =
  ProxyvotingPimeetingsFilterListResponses[keyof ProxyvotingPimeetingsFilterListResponses]

export type ProxyvotingRulesEngineDefinitionsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Filter by engine name (exact match)
     */
    name?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/proxyvoting/rules-engine-definitions'
}

export type ProxyvotingRulesEngineDefinitionsListResponses = {
  200: PaginatedRulesEngineDefinitionList
}

export type ProxyvotingRulesEngineDefinitionsListResponse =
  ProxyvotingRulesEngineDefinitionsListResponses[keyof ProxyvotingRulesEngineDefinitionsListResponses]

export type ProxyvotingRulesEngineDefinitionsCreateData = {
  body: RulesEngineDefinitionCreateRequest
  path?: never
  query?: never
  url: '/proxyvoting/rules-engine-definitions'
}

export type ProxyvotingRulesEngineDefinitionsCreateResponses = {
  201: RulesEngineDefinition
}

export type ProxyvotingRulesEngineDefinitionsCreateResponse =
  ProxyvotingRulesEngineDefinitionsCreateResponses[keyof ProxyvotingRulesEngineDefinitionsCreateResponses]

export type ProxyvotingRulesEngineDefinitionsRulesListData = {
  body?: never
  path: {
    definition_id: string
  }
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules'
}

export type ProxyvotingRulesEngineDefinitionsRulesListResponses = {
  200: PaginatedRulesEngineRuleList
}

export type ProxyvotingRulesEngineDefinitionsRulesListResponse =
  ProxyvotingRulesEngineDefinitionsRulesListResponses[keyof ProxyvotingRulesEngineDefinitionsRulesListResponses]

export type ProxyvotingRulesEngineDefinitionsRulesCreateData = {
  body: RulesEngineRuleWriteRequest
  path: {
    definition_id: string
  }
  query?: never
  url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules'
}

export type ProxyvotingRulesEngineDefinitionsRulesCreateResponses = {
  201: RulesEngineRule
}

export type ProxyvotingRulesEngineDefinitionsRulesCreateResponse =
  ProxyvotingRulesEngineDefinitionsRulesCreateResponses[keyof ProxyvotingRulesEngineDefinitionsRulesCreateResponses]

export type ProxyvotingRulesEngineDefinitionsRulesDestroyData = {
  body?: never
  path: {
    definition_id: string
    id: string
  }
  query?: never
  url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules/{id}'
}

export type ProxyvotingRulesEngineDefinitionsRulesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type ProxyvotingRulesEngineDefinitionsRulesDestroyResponse =
  ProxyvotingRulesEngineDefinitionsRulesDestroyResponses[keyof ProxyvotingRulesEngineDefinitionsRulesDestroyResponses]

export type ProxyvotingRulesEngineDefinitionsRulesUpdateData = {
  body: RulesEngineRuleWriteRequest
  path: {
    definition_id: string
    id: string
  }
  query?: never
  url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules/{id}'
}

export type ProxyvotingRulesEngineDefinitionsRulesUpdateResponses = {
  200: RulesEngineRule
}

export type ProxyvotingRulesEngineDefinitionsRulesUpdateResponse =
  ProxyvotingRulesEngineDefinitionsRulesUpdateResponses[keyof ProxyvotingRulesEngineDefinitionsRulesUpdateResponses]

export type ProxyvotingRulesEngineDefinitionsDestroyData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/proxyvoting/rules-engine-definitions/{id}'
}

export type ProxyvotingRulesEngineDefinitionsDestroyErrors = {
  /**
   * No response body
   */
  404: unknown
  /**
   * No response body
   */
  409: unknown
}

export type ProxyvotingRulesEngineDefinitionsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type ProxyvotingRulesEngineDefinitionsDestroyResponse =
  ProxyvotingRulesEngineDefinitionsDestroyResponses[keyof ProxyvotingRulesEngineDefinitionsDestroyResponses]

export type ProxyvotingRulesEngineDefinitionsRetrieveData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/proxyvoting/rules-engine-definitions/{id}'
}

export type ProxyvotingRulesEngineDefinitionsRetrieveResponses = {
  200: RulesEngineDefinition
}

export type ProxyvotingRulesEngineDefinitionsRetrieveResponse =
  ProxyvotingRulesEngineDefinitionsRetrieveResponses[keyof ProxyvotingRulesEngineDefinitionsRetrieveResponses]

export type ProxyvotingRulesEngineDefinitionsByNameDestroyData = {
  body?: never
  path: {
    name: string
  }
  query?: never
  url: '/proxyvoting/rules-engine-definitions/by-name/{name}'
}

export type ProxyvotingRulesEngineDefinitionsByNameDestroyErrors = {
  /**
   * No response body
   */
  404: unknown
  /**
   * No response body
   */
  409: unknown
}

export type ProxyvotingRulesEngineDefinitionsByNameDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type ProxyvotingRulesEngineDefinitionsByNameDestroyResponse =
  ProxyvotingRulesEngineDefinitionsByNameDestroyResponses[keyof ProxyvotingRulesEngineDefinitionsByNameDestroyResponses]

export type ProxyvotingRulesEngineDefinitionsNamesRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/proxyvoting/rules-engine-definitions/names'
}

export type ProxyvotingRulesEngineDefinitionsNamesRetrieveResponses = {
  200: RulesEngineNamesResponse
}

export type ProxyvotingRulesEngineDefinitionsNamesRetrieveResponse =
  ProxyvotingRulesEngineDefinitionsNamesRetrieveResponses[keyof ProxyvotingRulesEngineDefinitionsNamesRetrieveResponses]

export type ProxyvotingSviProposalOverwriteCreateData = {
  body: SplitVoteInstructionProposalOverwriteRequest
  path?: never
  query?: never
  url: '/proxyvoting/svi/proposal/overwrite'
}

export type ProxyvotingSviProposalOverwriteCreateResponses = {
  201: SplitVoteInstructionProposalOverwrite
}

export type ProxyvotingSviProposalOverwriteCreateResponse =
  ProxyvotingSviProposalOverwriteCreateResponses[keyof ProxyvotingSviProposalOverwriteCreateResponses]

export type ProxyvotingSviProposalOverwriteReasonsListData = {
  body?: never
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
  }
  url: '/proxyvoting/svi/proposal/overwrite/reasons'
}

export type ProxyvotingSviProposalOverwriteReasonsListResponses = {
  200: PaginatedSplitVoteInstructionOverwriteReasonList
}

export type ProxyvotingSviProposalOverwriteReasonsListResponse =
  ProxyvotingSviProposalOverwriteReasonsListResponses[keyof ProxyvotingSviProposalOverwriteReasonsListResponses]

export type TransparencyAuditEventsSearchCreateData = {
  body?: AuditEventSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/transparency/audit-events/search/'
}

export type TransparencyAuditEventsSearchCreateResponses = {
  200: PaginatedAuditEventList
}

export type TransparencyAuditEventsSearchCreateResponse =
  TransparencyAuditEventsSearchCreateResponses[keyof TransparencyAuditEventsSearchCreateResponses]

export type TransparencyExternalMeetingIdsCreateData = {
  body: ExternalMeetingIdCreateRequest
  path?: never
  query?: never
  url: '/transparency/external-meeting-ids/'
}

export type TransparencyExternalMeetingIdsCreateResponses = {
  201: ExternalMeetingId
}

export type TransparencyExternalMeetingIdsCreateResponse =
  TransparencyExternalMeetingIdsCreateResponses[keyof TransparencyExternalMeetingIdsCreateResponses]

export type TransparencyExternalMeetingIdsDestroyData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/transparency/external-meeting-ids/{id}/'
}

export type TransparencyExternalMeetingIdsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type TransparencyExternalMeetingIdsDestroyResponse =
  TransparencyExternalMeetingIdsDestroyResponses[keyof TransparencyExternalMeetingIdsDestroyResponses]

export type TransparencyGeneralMeetingsCreateData = {
  body: GeneralMeetingWriteRequest
  path?: never
  query?: never
  url: '/transparency/general-meetings/'
}

export type TransparencyGeneralMeetingsCreateResponses = {
  201: GeneralMeeting
}

export type TransparencyGeneralMeetingsCreateResponse =
  TransparencyGeneralMeetingsCreateResponses[keyof TransparencyGeneralMeetingsCreateResponses]

export type TransparencyGeneralMeetingsRetrieveData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/transparency/general-meetings/{id}/'
}

export type TransparencyGeneralMeetingsRetrieveResponses = {
  200: GeneralMeeting
}

export type TransparencyGeneralMeetingsRetrieveResponse =
  TransparencyGeneralMeetingsRetrieveResponses[keyof TransparencyGeneralMeetingsRetrieveResponses]

export type TransparencyGeneralMeetingsPartialUpdateData = {
  body?: PatchedGeneralMeetingWriteRequest
  path: {
    id: string
  }
  query?: never
  url: '/transparency/general-meetings/{id}/'
}

export type TransparencyGeneralMeetingsPartialUpdateResponses = {
  200: GeneralMeeting
}

export type TransparencyGeneralMeetingsPartialUpdateResponse =
  TransparencyGeneralMeetingsPartialUpdateResponses[keyof TransparencyGeneralMeetingsPartialUpdateResponses]

export type TransparencyGeneralMeetingsSearchCreateData = {
  body?: GeneralMeetingSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/transparency/general-meetings/search/'
}

export type TransparencyGeneralMeetingsSearchCreateResponses = {
  200: PaginatedGeneralMeetingList
}

export type TransparencyGeneralMeetingsSearchCreateResponse =
  TransparencyGeneralMeetingsSearchCreateResponses[keyof TransparencyGeneralMeetingsSearchCreateResponses]

export type TransparencyInstrumentsCreateData = {
  body: InstrumentWriteRequest
  path?: never
  query?: never
  url: '/transparency/instruments/'
}

export type TransparencyInstrumentsCreateResponses = {
  201: Instrument
}

export type TransparencyInstrumentsCreateResponse =
  TransparencyInstrumentsCreateResponses[keyof TransparencyInstrumentsCreateResponses]

export type TransparencyInstrumentsDestroyData = {
  body?: never
  path: {
    isin: string
  }
  query?: never
  url: '/transparency/instruments/{isin}/'
}

export type TransparencyInstrumentsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type TransparencyInstrumentsDestroyResponse =
  TransparencyInstrumentsDestroyResponses[keyof TransparencyInstrumentsDestroyResponses]

export type TransparencyInstrumentsRetrieveData = {
  body?: never
  path: {
    isin: string
  }
  query?: never
  url: '/transparency/instruments/{isin}/'
}

export type TransparencyInstrumentsRetrieveResponses = {
  200: Instrument
}

export type TransparencyInstrumentsRetrieveResponse =
  TransparencyInstrumentsRetrieveResponses[keyof TransparencyInstrumentsRetrieveResponses]

export type TransparencyInstrumentsUpdateData = {
  body: InstrumentWriteRequest
  path: {
    isin: string
  }
  query?: never
  url: '/transparency/instruments/{isin}/'
}

export type TransparencyInstrumentsUpdateResponses = {
  200: Instrument
}

export type TransparencyInstrumentsUpdateResponse =
  TransparencyInstrumentsUpdateResponses[keyof TransparencyInstrumentsUpdateResponses]

export type TransparencyInstrumentsFetchMinimalCreateData = {
  body: FetchMinimalInstrumentsRequestRequest
  path?: never
  query?: never
  url: '/transparency/instruments/fetch-minimal/'
}

export type TransparencyInstrumentsFetchMinimalCreateResponses = {
  200: FetchMinimalInstrumentsResponse
}

export type TransparencyInstrumentsFetchMinimalCreateResponse =
  TransparencyInstrumentsFetchMinimalCreateResponses[keyof TransparencyInstrumentsFetchMinimalCreateResponses]

export type TransparencyInstrumentsSearchCreateData = {
  body?: InstrumentSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/transparency/instruments/search/'
}

export type TransparencyInstrumentsSearchCreateResponses = {
  200: PaginatedInstrumentList
}

export type TransparencyInstrumentsSearchCreateResponse =
  TransparencyInstrumentsSearchCreateResponses[keyof TransparencyInstrumentsSearchCreateResponses]

export type TransparencyInstrumentsUnassociatedRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/transparency/instruments/unassociated/'
}

export type TransparencyInstrumentsUnassociatedRetrieveResponses = {
  200: UnassociatedInstrumentsResponse
}

export type TransparencyInstrumentsUnassociatedRetrieveResponse =
  TransparencyInstrumentsUnassociatedRetrieveResponses[keyof TransparencyInstrumentsUnassociatedRetrieveResponses]

export type TransparencyOrganizationsCreateData = {
  body: OrganizationWriteRequest
  path?: never
  query?: never
  url: '/transparency/organizations/'
}

export type TransparencyOrganizationsCreateResponses = {
  201: Organization
}

export type TransparencyOrganizationsCreateResponse =
  TransparencyOrganizationsCreateResponses[keyof TransparencyOrganizationsCreateResponses]

export type TransparencyOrganizationsDestroyData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/transparency/organizations/{id}/'
}

export type TransparencyOrganizationsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type TransparencyOrganizationsDestroyResponse =
  TransparencyOrganizationsDestroyResponses[keyof TransparencyOrganizationsDestroyResponses]

export type TransparencyOrganizationsRetrieveData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/transparency/organizations/{id}/'
}

export type TransparencyOrganizationsRetrieveResponses = {
  200: Organization
}

export type TransparencyOrganizationsRetrieveResponse =
  TransparencyOrganizationsRetrieveResponses[keyof TransparencyOrganizationsRetrieveResponses]

export type TransparencyOrganizationsPartialUpdateData = {
  body?: PatchedOrganizationWriteRequest
  path: {
    id: string
  }
  query?: never
  url: '/transparency/organizations/{id}/'
}

export type TransparencyOrganizationsPartialUpdateResponses = {
  200: Organization
}

export type TransparencyOrganizationsPartialUpdateResponse =
  TransparencyOrganizationsPartialUpdateResponses[keyof TransparencyOrganizationsPartialUpdateResponses]

export type TransparencyOrganizationsUpdateData = {
  body: OrganizationWriteRequest
  path: {
    id: string
  }
  query?: never
  url: '/transparency/organizations/{id}/'
}

export type TransparencyOrganizationsUpdateResponses = {
  200: Organization
}

export type TransparencyOrganizationsUpdateResponse =
  TransparencyOrganizationsUpdateResponses[keyof TransparencyOrganizationsUpdateResponses]

export type TransparencyOrganizationsLogoCreateData = {
  body?: OrganizationLogoUploadRequest
  path: {
    id: string
  }
  query?: never
  url: '/transparency/organizations/{id}/logo/'
}

export type TransparencyOrganizationsLogoCreateResponses = {
  200: Organization
}

export type TransparencyOrganizationsLogoCreateResponse =
  TransparencyOrganizationsLogoCreateResponses[keyof TransparencyOrganizationsLogoCreateResponses]

export type TransparencyOrganizationsGeneralMeetingsProposalsCreateData = {
  body: ProposalWriteRequest
  path: {
    gm_id: string
    org_id: string
  }
  query?: never
  url: '/transparency/organizations/{org_id}/general-meetings/{gm_id}/proposals/'
}

export type TransparencyOrganizationsGeneralMeetingsProposalsCreateResponses = {
  201: Proposal
}

export type TransparencyOrganizationsGeneralMeetingsProposalsCreateResponse =
  TransparencyOrganizationsGeneralMeetingsProposalsCreateResponses[keyof TransparencyOrganizationsGeneralMeetingsProposalsCreateResponses]

export type TransparencyOrganizationsGeneralMeetingsProposalsRetrieveData = {
  body?: never
  path: {
    gm_id: string
    org_id: string
    proposal_id: string
  }
  query?: never
  url: '/transparency/organizations/{org_id}/general-meetings/{gm_id}/proposals/{proposal_id}/'
}

export type TransparencyOrganizationsGeneralMeetingsProposalsRetrieveResponses = {
  200: Proposal
}

export type TransparencyOrganizationsGeneralMeetingsProposalsRetrieveResponse =
  TransparencyOrganizationsGeneralMeetingsProposalsRetrieveResponses[keyof TransparencyOrganizationsGeneralMeetingsProposalsRetrieveResponses]

export type TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateData = {
  body?: PatchedProposalPatchRequest
  path: {
    gm_id: string
    org_id: string
    proposal_id: string
  }
  query?: never
  url: '/transparency/organizations/{org_id}/general-meetings/{gm_id}/proposals/{proposal_id}/'
}

export type TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponses = {
  200: Proposal
}

export type TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponse =
  TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponses[keyof TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponses]

export type TransparencyOrganizationsGeneralMeetingsProposalsUpdateData = {
  body: ProposalWriteRequest
  path: {
    gm_id: string
    org_id: string
    proposal_id: string
  }
  query?: never
  url: '/transparency/organizations/{org_id}/general-meetings/{gm_id}/proposals/{proposal_id}/'
}

export type TransparencyOrganizationsGeneralMeetingsProposalsUpdateResponses = {
  200: Proposal
}

export type TransparencyOrganizationsGeneralMeetingsProposalsUpdateResponse =
  TransparencyOrganizationsGeneralMeetingsProposalsUpdateResponses[keyof TransparencyOrganizationsGeneralMeetingsProposalsUpdateResponses]

export type TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateData = {
  body?: ProposalSearchRequestRequest
  path: {
    gm_id: string
    org_id: string
  }
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/transparency/organizations/{org_id}/general-meetings/{gm_id}/proposals/search/'
}

export type TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponses = {
  200: PaginatedProposalList
}

export type TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponse =
  TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponses[keyof TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponses]

export type TransparencyOrganizationsGetByIdentifierCreateData = {
  body: GetOrganizationByIdentifierRequestRequest
  path?: never
  query?: never
  url: '/transparency/organizations/get-by-identifier/'
}

export type TransparencyOrganizationsGetByIdentifierCreateResponses = {
  200: Organization
}

export type TransparencyOrganizationsGetByIdentifierCreateResponse =
  TransparencyOrganizationsGetByIdentifierCreateResponses[keyof TransparencyOrganizationsGetByIdentifierCreateResponses]

export type TransparencyOrganizationsIsinsToNamesCreateData = {
  body: BatchIsinsToOrganizationNamesRequestRequest
  path?: never
  query?: never
  url: '/transparency/organizations/isins-to-names/'
}

export type TransparencyOrganizationsIsinsToNamesCreateResponses = {
  200: BatchIsinsToOrganizationNamesResponse
}

export type TransparencyOrganizationsIsinsToNamesCreateResponse =
  TransparencyOrganizationsIsinsToNamesCreateResponses[keyof TransparencyOrganizationsIsinsToNamesCreateResponses]

export type TransparencyOrganizationsSearchCreateData = {
  body?: OrganizationSearchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/transparency/organizations/search/'
}

export type TransparencyOrganizationsSearchCreateResponses = {
  200: PaginatedOrganizationList
}

export type TransparencyOrganizationsSearchCreateResponse =
  TransparencyOrganizationsSearchCreateResponses[keyof TransparencyOrganizationsSearchCreateResponses]

export type TransparencyProposalsClassificationCodesRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/transparency/proposals/classification-codes/'
}

export type TransparencyProposalsClassificationCodesRetrieveResponses = {
  200: ProposalClassificationCodesResponse
}

export type TransparencyProposalsClassificationCodesRetrieveResponse =
  TransparencyProposalsClassificationCodesRetrieveResponses[keyof TransparencyProposalsClassificationCodesRetrieveResponses]

export type TransparencyProposalsCountCreateData = {
  body: ProposalCountRequestRequest
  path?: never
  query?: never
  url: '/transparency/proposals/count/'
}

export type TransparencyProposalsCountCreateResponses = {
  200: ProposalCountResponse
}

export type TransparencyProposalsCountCreateResponse =
  TransparencyProposalsCountCreateResponses[keyof TransparencyProposalsCountCreateResponses]

export type TransparencyProposalsFetchCreateData = {
  body: ProposalFetchRequestRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/transparency/proposals/fetch/'
}

export type TransparencyProposalsFetchCreateResponses = {
  200: PaginatedProposalList
}

export type TransparencyProposalsFetchCreateResponse =
  TransparencyProposalsFetchCreateResponses[keyof TransparencyProposalsFetchCreateResponses]

export type TransparencyProposalsFetchNamesFromIdsCreateData = {
  body: ProposalFetchNamesFromIdsRequestRequest
  path?: never
  query?: never
  url: '/transparency/proposals/fetch-names-from-ids/'
}

export type TransparencyProposalsFetchNamesFromIdsCreateResponses = {
  200: ProposalFetchNamesFromIdsResponse
}

export type TransparencyProposalsFetchNamesFromIdsCreateResponse =
  TransparencyProposalsFetchNamesFromIdsCreateResponses[keyof TransparencyProposalsFetchNamesFromIdsCreateResponses]

export type TransparencyProposalsSecClassificationCodesRetrieveData = {
  body?: never
  path?: never
  query?: never
  url: '/transparency/proposals/sec-classification-codes/'
}

export type TransparencyProposalsSecClassificationCodesRetrieveResponses = {
  200: ProposalSecClassificationCodesResponse
}

export type TransparencyProposalsSecClassificationCodesRetrieveResponse =
  TransparencyProposalsSecClassificationCodesRetrieveResponses[keyof TransparencyProposalsSecClassificationCodesRetrieveResponses]

export type TransparencyPublicSecurityIdsSearchCreateData = {
  body?: PublicSecurityIdListQueryRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/transparency/public-security-ids/search/'
}

export type TransparencyPublicSecurityIdsSearchCreateResponses = {
  200: PaginatedPublicSecurityIdList
}

export type TransparencyPublicSecurityIdsSearchCreateResponse =
  TransparencyPublicSecurityIdsSearchCreateResponses[keyof TransparencyPublicSecurityIdsSearchCreateResponses]

export type VotingOperationsPiballotsFilterListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Filter ballots by workflow checker email - exact string match.
     */
    checker?: string
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Custodian account identifier - exact string match.
     */
    custodian_account_number?: string
    /**
     * External ballot identifier - exact string match.
     */
    external_id?: string
    /**
     * Filter ballots by fund manager title - case-insensitive substring match.
     */
    fund_manager_title?: string
    /**
     * Filter ballots by fund title - case-insensitive substring match.
     */
    fund_title?: string
    /**
     * Filter ballots by whether they have a workflow checker email assigned. True for ballots with checker, False for ballots without checker, omit for all.
     */
    has_checker?: boolean
    /**
     * Filter ballots by whether they have a workflow submitter email assigned. True for ballots with submitter, False for ballots without submitter, omit for all.
     */
    has_submitter?: boolean
    /**
     * Filter ballots by scope. True for in-scope (any policy support field is true), False for out-of-scope (all policy support fields are false), omit for all.
     */
    in_scope?: boolean
    /**
     * ISIN (International Securities Identification Number) - exact match filter. Must be 12-character alphanumeric code.
     */
    isin?: string
    /**
     * Filter ballots by whether they are linked to a general meeting. True for linked, False for unlinked, omit for all.
     */
    linked?: boolean
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * Filter ballots by organization title - case-insensitive substring match.
     */
    organization_title?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
    /**
     * Filter ballots by whether the 'proxy_intermediary_id' and 'proxy_intermediary_meeting_id' match the provided meeting name.
     * Expected format:'proxyIntermediaries/{proxy_intermediary_id}/meetings/{proxy_intermediary_meeting_id}'
     */
    pi_meeting_name?: string
    /**
     * Proxy intermediary(s) managing the meetings. Options: Proxymity, ProxyEdge, ProxyExchange, or omit for all.
     *
     * * `Proxymity` - Proxymity
     * * `ProxyEdge` - ProxyEdge
     * * `ProxyExchange` - ProxyExchange
     */
    proxy_intermediaries?: Array<'ProxyEdge' | 'ProxyExchange' | 'Proxymity'>
    /**
     * Filter ballots by proxy intermediary title - exact string match.
     */
    proxy_intermediary?: string
    /**
     * General search across organization title, ballot external ID, and ISIN - case-insensitive substring match.
     */
    search?: string
    /**
     * Filter ballots by whether split vote checking is required. True for required, False for not required, omit for all.
     */
    split_vote_check_required?: boolean
    /**
     * Filter ballots by workflow status. Multiple values can be selected to match any of the specified statuses.
     *
     * * `invalid` - Invalid
     * * `not_submitted_in_testing` - Not Submitted in Testing
     * * `not_submitted_unvoted` - Not Submitted Unvoted
     * * `not_submitted_no_entitlements` - Not Submitted No Entitlements
     * * `not_submitted_undefined` - Not Submitted Undefined
     * * `needs_attention` - Needs Attention
     * * `ineligible` - Ineligible
     * * `cancelled` - Cancelled
     * * `meeting_needs_refining` - Meeting Needs Refining
     * * `meeting_voting_enabled` - Meeting Voting Enabled
     * * `entitled_to_vote` - Entitled to Vote
     * * `ready_for_split_vote` - Ready for Split Vote
     * * `late_vote_process` - Late Vote Process
     * * `split_vote_awaiting_check` - Split Vote Awaiting Check
     * * `split_vote_submitted` - Split Vote Submitted
     * * `successful` - Successful
     * * `rejected` - Rejected
     * * `overridden` - Overridden
     * * `in_testing` - In Testing
     */
    status?: Array<
      | 'cancelled'
      | 'entitled_to_vote'
      | 'in_testing'
      | 'ineligible'
      | 'invalid'
      | 'late_vote_process'
      | 'meeting_needs_refining'
      | 'meeting_voting_enabled'
      | 'needs_attention'
      | 'not_submitted_in_testing'
      | 'not_submitted_no_entitlements'
      | 'not_submitted_undefined'
      | 'not_submitted_unvoted'
      | 'overridden'
      | 'ready_for_split_vote'
      | 'rejected'
      | 'split_vote_awaiting_check'
      | 'split_vote_submitted'
      | 'successful'
    >
    /**
     * Filter ballots by workflow submitter email - exact string match.
     */
    submitter?: string
    /**
     * Filter ballots with vote deadline after or equal to this UTC datetime.
     */
    vote_deadline_after?: Date
    /**
     * Filter ballots with vote deadline before or equal to this UTC datetime.
     */
    vote_deadline_before?: Date
  }
  url: '/voting-operations/piballots/filter'
}

export type VotingOperationsPiballotsFilterListResponses = {
  200: PaginatedPiBallotSearchList
}

export type VotingOperationsPiballotsFilterListResponse =
  VotingOperationsPiballotsFilterListResponses[keyof VotingOperationsPiballotsFilterListResponses]

export type VotingOperationsPimeetingsFilterListData = {
  body?: never
  path?: never
  query?: {
    /**
     * Filter meetings by assigned checker user email address - exact match.
     */
    assigned_checker_user_id?: string
    /**
     * Filter meetings by assigned refiner user email address - exact match.
     */
    assigned_refiner_user_id?: string
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Filter meetings with earliest ballot submission deadline is after or equal to this UTC datetime,
     */
    earliest_ballot_submission_deadline_after?: Date
    /**
     * Filter meetings with earliest ballot submission before or equal to this UTC datetime.
     */
    earliest_ballot_submission_deadline_before?: Date
    /**
     * Filter meetings by ballot presence. True for meetings with ballots, False for meetings without ballots, omit for all.
     */
    has_ballots?: boolean
    /**
     * Filter meetings by checker presence. True for meetings with checker, False for meetings without checker, omit for all.
     */
    has_checker?: boolean
    /**
     * Filter meetings by refiner presence. True for meetings with refiner, False for meetings without refiner, omit for all.
     */
    has_refiner?: boolean
    /**
     * Filter meetings by scope. True for in-scope (any policy support field is true), False for out-of-scope (all policy support fields are false), omit for all.
     */
    in_scope?: boolean
    /**
     * Filter meetings by whether they are linked to Tumelo meetings. True for linked, False for unlinked, omit for all.
     */
    linked_to_tumelo_meeting?: boolean
    /**
     * Filter meetings created after or equal to this UTC datetime.
     */
    meeting_create_time_after?: Date
    /**
     * Filter meetings created before or equal to this UTC datetime.
     */
    meeting_create_time_before?: Date
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
    /**
     * Proxy intermediary(s) managing the meetings. Options: Proxymity, ProxyEdge, ProxyExchange, or omit for all.
     *
     * * `Proxymity` - Proxymity
     * * `ProxyEdge` - ProxyEdge
     * * `ProxyExchange` - ProxyExchange
     */
    proxy_intermediaries?: Array<'ProxyEdge' | 'ProxyExchange' | 'Proxymity'>
    /**
     * Proxy intermediary managing the meetings. Options: Proxymity, ProxyEdge, ProxyExchange, or omit for all.
     *
     * * `Proxymity` - Proxymity
     * * `ProxyEdge` - ProxyEdge
     * * `ProxyExchange` - ProxyExchange
     */
    proxy_intermediary?: 'ProxyEdge' | 'ProxyExchange' | 'Proxymity'
    /**
     * General search across meeting external ID, organization title, and security IDs - case-insensitive substring match. Maximum 255 characters.
     */
    search?: string
    /**
     * Filter meetings by workflow status. Multiple values can be selected to match any of the specified statuses.
     *
     * * `invalid` - Invalid
     * * `new` - New
     * * `unlinked` - Unlinked
     * * `unsupported` - Unsupported
     * * `needs_attention` - Needs Attention
     * * `cancelled` - Cancelled
     * * `cancellation_incomplete` - Cancellation Incomplete
     * * `ready_for_refinement` - Ready for Refinement
     * * `refinement_complete` - Refinement Complete
     * * `manual_voting_enabled` - Manual Voting Enabled
     * * `entitled_to_vote` - Entitled to Vote
     * * `ready_for_split_vote` - Ready for Split Vote
     * * `split_vote_submitted` - Split Vote Submitted
     * * `successful` - Successful
     * * `rejected` - Rejected
     * * `overridden` - Overridden
     * * `partial_success` - Partial Success
     */
    status?: Array<
      | 'cancellation_incomplete'
      | 'cancelled'
      | 'entitled_to_vote'
      | 'invalid'
      | 'manual_voting_enabled'
      | 'needs_attention'
      | 'new'
      | 'overridden'
      | 'partial_success'
      | 'ready_for_refinement'
      | 'ready_for_split_vote'
      | 'refinement_complete'
      | 'rejected'
      | 'split_vote_submitted'
      | 'successful'
      | 'unlinked'
      | 'unsupported'
    >
    /**
     * Filter meetings with submission deadline after or equal to this UTC datetime, where the latest valid_to SII date is before this datetime, with an 8 month buffer.
     */
    submission_deadline_after?: Date
    /**
     * Filter meetings with submission deadline before or equal to this UTC datetime.
     */
    submission_deadline_before?: Date
  }
  url: '/voting-operations/pimeetings/filter'
}

export type VotingOperationsPimeetingsFilterListResponses = {
  200: PaginatedPiMeetingSearchList
}

export type VotingOperationsPimeetingsFilterListResponse =
  VotingOperationsPimeetingsFilterListResponses[keyof VotingOperationsPimeetingsFilterListResponses]

export type VotingPolicyProviderVotingRecommendationsCreateData = {
  body: ProviderVotingRecommendationCreateRequest
  path?: never
  query?: never
  url: '/voting-policy/provider-voting-recommendations/'
}

export type VotingPolicyProviderVotingRecommendationsCreateResponses = {
  201: ProviderVotingRecommendation
}

export type VotingPolicyProviderVotingRecommendationsCreateResponse =
  VotingPolicyProviderVotingRecommendationsCreateResponses[keyof VotingPolicyProviderVotingRecommendationsCreateResponses]

export type VotingPolicyProviderVotingRecommendationsDestroyData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/voting-policy/provider-voting-recommendations/{id}/'
}

export type VotingPolicyProviderVotingRecommendationsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type VotingPolicyProviderVotingRecommendationsDestroyResponse =
  VotingPolicyProviderVotingRecommendationsDestroyResponses[keyof VotingPolicyProviderVotingRecommendationsDestroyResponses]

export type VotingPolicyProviderVotingRecommendationsMatchCreateData = {
  body: MatchVotingRecommendationFromPvrRequest
  path: {
    id: string
  }
  query?: never
  url: '/voting-policy/provider-voting-recommendations/{id}/match/'
}

export type VotingPolicyProviderVotingRecommendationsMatchCreateResponses = {
  201: VotingRecommendation
}

export type VotingPolicyProviderVotingRecommendationsMatchCreateResponse =
  VotingPolicyProviderVotingRecommendationsMatchCreateResponses[keyof VotingPolicyProviderVotingRecommendationsMatchCreateResponses]

export type VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveData = {
  body?: never
  path?: never
  query: {
    /**
     * The meeting batch version to fetch. Must be a positive integer.
     */
    meeting_batch_version: number
    /**
     * UUID4 identifying the meeting and policy combination.
     */
    unique_meeting_policy_id: string
  }
  url: '/voting-policy/provider-voting-recommendations/fetch-by-version/'
}

export type VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponses = {
  200: ProviderVotingRecommendationListResponse
}

export type VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponse =
  VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponses[keyof VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponses]

export type VotingPolicyProviderVotingRecommendationsSearchCreateData = {
  body?: ProviderVotingRecommendationSearchRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/voting-policy/provider-voting-recommendations/search/'
}

export type VotingPolicyProviderVotingRecommendationsSearchCreateResponses = {
  200: PaginatedProviderVotingRecommendationList
}

export type VotingPolicyProviderVotingRecommendationsSearchCreateResponse =
  VotingPolicyProviderVotingRecommendationsSearchCreateResponses[keyof VotingPolicyProviderVotingRecommendationsSearchCreateResponses]

export type VotingPolicyVotingPoliciesCreateData = {
  body: VotingPolicyCreateRequest
  path?: never
  query?: never
  url: '/voting-policy/voting-policies/'
}

export type VotingPolicyVotingPoliciesCreateResponses = {
  201: VotingPolicy
}

export type VotingPolicyVotingPoliciesCreateResponse =
  VotingPolicyVotingPoliciesCreateResponses[keyof VotingPolicyVotingPoliciesCreateResponses]

export type VotingPolicyVotingPoliciesDestroyData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/voting-policy/voting-policies/{id}/'
}

export type VotingPolicyVotingPoliciesDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type VotingPolicyVotingPoliciesDestroyResponse =
  VotingPolicyVotingPoliciesDestroyResponses[keyof VotingPolicyVotingPoliciesDestroyResponses]

export type VotingPolicyVotingPoliciesRetrieveData = {
  body?: never
  path: {
    id: string
  }
  query?: never
  url: '/voting-policy/voting-policies/{id}/'
}

export type VotingPolicyVotingPoliciesRetrieveResponses = {
  200: VotingPolicy
}

export type VotingPolicyVotingPoliciesRetrieveResponse =
  VotingPolicyVotingPoliciesRetrieveResponses[keyof VotingPolicyVotingPoliciesRetrieveResponses]

export type VotingPolicyVotingPoliciesPartialUpdateData = {
  body?: PatchedVotingPolicyUpdateRequest
  path: {
    id: string
  }
  query?: never
  url: '/voting-policy/voting-policies/{id}/'
}

export type VotingPolicyVotingPoliciesPartialUpdateResponses = {
  200: VotingPolicy
}

export type VotingPolicyVotingPoliciesPartialUpdateResponse =
  VotingPolicyVotingPoliciesPartialUpdateResponses[keyof VotingPolicyVotingPoliciesPartialUpdateResponses]

export type VotingPolicyVotingPoliciesDocumentsListData = {
  body?: never
  path: {
    voting_policy_id: string
  }
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/voting-policy/voting-policies/{voting_policy_id}/documents/'
}

export type VotingPolicyVotingPoliciesDocumentsListResponses = {
  200: PaginatedVotingPolicyDocumentList
}

export type VotingPolicyVotingPoliciesDocumentsListResponse =
  VotingPolicyVotingPoliciesDocumentsListResponses[keyof VotingPolicyVotingPoliciesDocumentsListResponses]

export type VotingPolicyVotingPoliciesDocumentsCreateData = {
  body?: Blob | File
  path: {
    voting_policy_id: string
  }
  query: {
    /**
     * The document's official publication time.
     */
    issue_time: Date
    /**
     * The document title.
     */
    title: string
  }
  url: '/voting-policy/voting-policies/{voting_policy_id}/documents/'
}

export type VotingPolicyVotingPoliciesDocumentsCreateResponses = {
  201: VotingPolicyDocument
}

export type VotingPolicyVotingPoliciesDocumentsCreateResponse =
  VotingPolicyVotingPoliciesDocumentsCreateResponses[keyof VotingPolicyVotingPoliciesDocumentsCreateResponses]

export type VotingPolicyVotingPoliciesDocumentsRetrieveData = {
  body?: never
  path: {
    id: number
    voting_policy_id: string
  }
  query?: never
  url: '/voting-policy/voting-policies/{voting_policy_id}/documents/{id}/'
}

export type VotingPolicyVotingPoliciesDocumentsRetrieveResponses = {
  200: VotingPolicyDocument
}

export type VotingPolicyVotingPoliciesDocumentsRetrieveResponse =
  VotingPolicyVotingPoliciesDocumentsRetrieveResponses[keyof VotingPolicyVotingPoliciesDocumentsRetrieveResponses]

export type VotingPolicyVotingPoliciesDocumentsPartialUpdateData = {
  body?: PatchedVotingPolicyDocumentUpdateRequest
  path: {
    id: number
    voting_policy_id: string
  }
  query?: never
  url: '/voting-policy/voting-policies/{voting_policy_id}/documents/{id}/'
}

export type VotingPolicyVotingPoliciesDocumentsPartialUpdateResponses = {
  200: VotingPolicyDocument
}

export type VotingPolicyVotingPoliciesDocumentsPartialUpdateResponse =
  VotingPolicyVotingPoliciesDocumentsPartialUpdateResponses[keyof VotingPolicyVotingPoliciesDocumentsPartialUpdateResponses]

export type VotingPolicyVotingPoliciesVotingRecommendationsListData = {
  body?: never
  path: {
    voting_policy_id: string
  }
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
    /**
     * Filter by proposal resource name (organizations/{uuid}/generalMeetings/{uuid}/proposals/{uuid}). Repeat for multiple.
     */
    proposal_names?: Array<string>
    /**
     * Filter by provider voting recommendation UUID. Repeat for multiple.
     */
    provider_voting_recommendation_ids?: Array<string>
  }
  url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/'
}

export type VotingPolicyVotingPoliciesVotingRecommendationsListResponses = {
  200: PaginatedVotingRecommendationList
}

export type VotingPolicyVotingPoliciesVotingRecommendationsListResponse =
  VotingPolicyVotingPoliciesVotingRecommendationsListResponses[keyof VotingPolicyVotingPoliciesVotingRecommendationsListResponses]

export type VotingPolicyVotingPoliciesVotingRecommendationsCreateData = {
  body: VotingRecommendationCreateRequest
  path: {
    voting_policy_id: string
  }
  query?: never
  url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/'
}

export type VotingPolicyVotingPoliciesVotingRecommendationsCreateResponses = {
  201: VotingRecommendation
}

export type VotingPolicyVotingPoliciesVotingRecommendationsCreateResponse =
  VotingPolicyVotingPoliciesVotingRecommendationsCreateResponses[keyof VotingPolicyVotingPoliciesVotingRecommendationsCreateResponses]

export type VotingPolicyVotingPoliciesVotingRecommendationsDestroyData = {
  body?: never
  path: {
    id: string
    voting_policy_id: string
  }
  query?: never
  url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/{id}/'
}

export type VotingPolicyVotingPoliciesVotingRecommendationsDestroyResponses = {
  /**
   * No response body
   */
  204: void
}

export type VotingPolicyVotingPoliciesVotingRecommendationsDestroyResponse =
  VotingPolicyVotingPoliciesVotingRecommendationsDestroyResponses[keyof VotingPolicyVotingPoliciesVotingRecommendationsDestroyResponses]

export type VotingPolicyVotingPoliciesVotingRecommendationsRetrieveData = {
  body?: never
  path: {
    id: string
    voting_policy_id: string
  }
  query?: never
  url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/{id}/'
}

export type VotingPolicyVotingPoliciesVotingRecommendationsRetrieveResponses = {
  200: VotingRecommendation
}

export type VotingPolicyVotingPoliciesVotingRecommendationsRetrieveResponse =
  VotingPolicyVotingPoliciesVotingRecommendationsRetrieveResponses[keyof VotingPolicyVotingPoliciesVotingRecommendationsRetrieveResponses]

export type VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateData = {
  body?: PatchedVotingRecommendationUpdateRequest
  path: {
    id: string
    voting_policy_id: string
  }
  query?: never
  url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/{id}/'
}

export type VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponses = {
  200: VotingRecommendation
}

export type VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponse =
  VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponses[keyof VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponses]

export type VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateData = {
  body: UpdateVotingRecommendationFromPvrRequest
  path: {
    id: string
    voting_policy_id: string
  }
  query?: never
  url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/{id}/update-from-pvr/'
}

export type VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponses = {
  200: VotingRecommendation
}

export type VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponse =
  VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponses[keyof VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponses]

export type VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateData = {
  body?: VotingRecommendationSearchRequest
  path: {
    voting_policy_id: string
  }
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/search/'
}

export type VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponses = {
  200: PaginatedVotingRecommendationList
}

export type VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponse =
  VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponses[keyof VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponses]

export type VotingPolicyVotingPoliciesSearchCreateData = {
  body?: VotingPolicySearchRequest
  path?: never
  query?: {
    /**
     * The pagination cursor value.
     */
    cursor?: string
    /**
     * Number of results to return per page.
     */
    page_size?: number
  }
  url: '/voting-policy/voting-policies/search/'
}

export type VotingPolicyVotingPoliciesSearchCreateResponses = {
  200: PaginatedVotingPolicyList
}

export type VotingPolicyVotingPoliciesSearchCreateResponse =
  VotingPolicyVotingPoliciesSearchCreateResponses[keyof VotingPolicyVotingPoliciesSearchCreateResponses]

export type VotingPolicyVotingRecommendationConfidenceScoresUpdateData = {
  body: VotingRecommendationConfidenceScoreUpsertRequest
  path: {
    version_id: string
  }
  query?: never
  url: '/voting-policy/voting-recommendation-confidence-scores/{version_id}/'
}

export type VotingPolicyVotingRecommendationConfidenceScoresUpdateResponses = {
  200: VotingRecommendationConfidenceScore
  201: VotingRecommendationConfidenceScore
}

export type VotingPolicyVotingRecommendationConfidenceScoresUpdateResponse =
  VotingPolicyVotingRecommendationConfidenceScoresUpdateResponses[keyof VotingPolicyVotingRecommendationConfidenceScoresUpdateResponses]
